import localeAntd from "ant-design-vue/lib/locale-provider/fr_FR";

const messages = {
  all: {
    selectionnerEleves: "Sélectionner des élèves",
    printByLevel: "Imprimer par niveaux",
    printLoginCredentials: "Imprimer les identifiants de connexion",
    understood: "J'ai compris",
    automatique: "Automatique",
    manuel: "Manuel",
    okay: "OK",
    table: "Tableau",
    add: "Ajouter",
    select: "Sélectionner",
    or: "ou",
    edit: "Modifier",
    cancel: "Annuler",
    save: "Enregistrer",
    cloneByType: "Dupliquer par type",
    apply: "Appliquer",
    source: "Source",
    targets: "Cible(s)",
    selectTypes: "Sélectionner les types",
    selectLevels: "Sélectionner les niveaux",
    selectTrimesters: "Sélectionner les trimestres",
    sureToCancelAlert: "Êtes-vous sûr d'annuler?",
    sureToDelete: "Voulez-vous supprimer?",
    startDate: "Date de début",
    endDate: "Date de fin",
    requiredStartDate: "La Date de début est requise",
    requiredEndDate: "La Date de fin est requise",
    requiredName: "Le nom est requis",
    requiredLevel: "Le niveau est requis!",
    enterInformationBelow: "Entrez les informations dans les champs ci-dessous",
    oui: "Oui",
    non: "Non",
    none: "Aucun",
    and: "Et",
    filterBy: "Recherche",
    filterByAddedDate: "Recherche par date d'ajout",
    filtresEtRecherche: "Filtres et Recherche",
    sureTo: "Êtes-vous sûr?",
    unsavedchanges: "Modifications non enregistrées !",
    unsavedchangesContent:
      "Voulez-vous vraiment partir ? Vous avez des changements non enregistrés !",
    unsavedChangesInfo:
      "Vous avez des changements non enregistrés. Veuillez enregistrer pour que vos modifications prennent effet.",
    unsavedChangesLeaveConfirm:
      "Vous avez des changements non enregistrés. Si vous quittez, vous perdrez ces changements. Êtes-vous sûr de vouloir quitter ?",

    savedChanges: "Les modifications ont été enregistrées avec succès",
    typeNeeded: "Types de fichiers autorisés : png, jpg, jpeg.",
    packAcces:
      "Vous ne pouvez pas accéder à cette fonctionnalité avec votre plan d'abonnement actuel.",
    attention: "Attention",
    nonGroupAssigned: "Non groupé",
    pagination: {
      showTotal: "Afficher {start}-{end} sur {total} éléments",
      pageSize: "Éléments par page",
      jumpTo: "Aller à",
      page: "Page",
      total: "Total",
      items: "éléments",
    },
    date: "Date",
    switchMode: "Basculer le thème sombre / clair",
    loadingText: "Chargement...",
    selectDate: "Sélectionner une date",
    noData: "Aucune donnée",
    tpiAll: "Tous",
    pending: "En attente",
    dateRangeToday: "Aujourd'hui",
    dateRangeThisWeek: "Cette semaine",
    dateRangeThisMonth: "Ce mois",
    dateRangeLastThreeMonths: "Les trois derniers mois",
    enabled: "Activé",
    disabled: "Désactivé",
  },
  time: {
    minuteAgo: "Il y a 1 minute",
    minutesAgo: "Il y a {count} minutes",
    hourAgo: "Il y a 1 heure",
    hoursAgo: "Il y a {count} heures",
    dayAgo: "Il y a 1 jour",
    daysAgo: "Il y a {count} jours",
    monthAgo: "Il y a 1 mois",
    monthsAgo: "Il y a {count} mois",
    yearAgo: "Il y a 1 an",
    yearsAgo: "Il y a {count} ans",
  },
  pdf: {
    pageNumber: "Page {current} / {total}",
  },
  months: {
    january: "Janvier",
    february: "Février",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Août",
    september: "Septembre",
    october: "Octobre",
    november: "Novembre",
    december: "Décembre",
  },
  pdfLogin: {
    loginInfo: "Informations de connexion",
    father: "Père",
    mother: "Mère",
    guardian: "Gardien",
    teacher: "Enseignant",
    student: "Élève",
    students: "Élèves",
    option1: "Option 1: Connexion avec identifiants",
    option2: "Option 2: Connexion avec QR Code",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    qrCodeInstruction:
      "Vous pouvez s'identifier en utlisant ce Qr code dans l'application mobile :",
    scanQRCode: "Scannez ce code QR avec l'application mobile :",
    howToAccess: "Comment accéder à la plateforme",
    webPlatform: "Plateforme web :",
    mobileApp: "Application mobile :",
    installApp: "Installez l'application {appName} sur votre téléphone mobile",
    importantInfo: "Informations importantes",
    changePassword: "• Changez votre mot de passe à la première connexion.",
    keepDocumentSafe: "• Conservez ce document en lieu sûr.",
    contactAdmin: "• Contactez l'administration en cas de problème.",
    parentLogins: "Logins parents",
    teacherLogins: "Logins enseignants",
    studentLogins: "Logins élèves",
    adminLogins: "Logins administrateurs",
  },
  pack: {
    new: "nouveau",
    upgrade: "Mise à niveau",
    packMessage: "Mise à niveau pour plus de fonctionnalités",
    typeNeededPNG: "Types de fichiers autorisés : png.",
    infoConx: "Informations de connexion",
    lienConx: "Lien de connexion",
    lienConxText: "ou application Mobile EdTeacher",
    upgradeModal: {
      title: "Fonctionnalité Non Disponible",
      subtitle:
        "Votre plan d'abonnement actuel ne prend pas en charge cette fonctionnalité",
      description:
        "Pour accéder à cette fonctionnalité, vous devez mettre à niveau votre plan. Veuillez contacter notre équipe commerciale pour plus de détails et d'informations sur les prix.",
      contactInfo: "Informations de Contact",
      phone: "Téléphone",
      email: "Email",
      website: "Site Web",
      contactSales: "Contacter l'Équipe Commerciale",
      close: "Fermer",
    },
  },
  moduleType: {
    pedagogicalModule: "Module pédagogique",
    pilotModule: "Module pilote",
    specificModule: "Module spécifique",
  },
  teacherAvailability: {
    available: "Je suis disponible",
    notAvailable: "Je ne suis pas disponible",
    saved: "La disponibilité a été enregistrée avec succès",
    notFilledYet: "L'enseignant n'a pas encore saisi la fiche de disponibilité",
  },
  smartSchedule: {
    generalParams: "General",
    comment: "Commentaire",
    commentRequired: "Le commentaire est requis",
    startDay: "Jour de début",
    endDay: "Jour de fin",
    workingTime: "Temps de travail",
    breakingTime: "Temps de pause",
    startAt: "Commencer à",
    endAt: "Terminer à",
    scheduleParmsAdded: "L'emploi a été ajouté avec succès",
    generalParamsSaved:
      "Les paramètres généraux ont été enregistrés avec succès",
    selectSchedule: "Sélectionner le paramétrage",
    subjectsSchedParam: "Les matières",
    weeklyRate: "Taux horaire par semaine",
    module: "Module",
    subject: "Matière",
    moduleSpecific: "Module pilote",
    teacherClassParam: "Affectation des enseignants",
    teacherAffectedSuccess: "L'enseignant a été affecté avec succès",
    teachersWeeklyRate: "Taux horaire des enseignants",
    name: "Nom du paramétrage",
    smartSchedule: "Emploi intelligent",
    smartSchedules: "Emplois intelligent",
    ready: "Prêt",
    pending: "En attente",
    finished: "Terminé",
    error: "Erreur",
    addParam: "Ajouter un paramétrage",
    migrateSuccess: "Les emplois a été migré avec succès",
    migrate: "Migrer les emplois",
    unmigrated: "Les emplois ont été restaurés avec succès",
    noDataToUnmigrate: "Les emplois contiennent déjà des sessions manuelles !",
    unmigrate: "Restaurer les sessions manuelles",
    minDuration: "Durée minimale",
    maxDuration: "Durée maximale",
    fillAllClassroomsToGenerate:
      "Veuillez remplir toutes les classes pour générer les emplois",
    weeklyRateMaxError:
      "Le taux horaire par semaine doit être égal ou supérieur à la durée maximale",
    weeklyRateMinError:
      "Le taux horaire par semaine doit être égal ou supérieur à la durée minimale",
  },
  calender: {
    calendar: "Calendrier",
    noDescription: "Il n'y a pas de description",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    addEvent: "Ajouter un événement",
    addEventTitle: "Ajouter un nouvel événement",
    duration: "Durée",
    durationRequired: "La durée est requise",
    exam: "Examen",
    party: "Fête",
    excursion: "Excursion",
    meeting: "Réunion",
    other: "Autre",
    eventType: "Type d'événement",
    color: "Couleur",
    typeRequired: "Le type d'événement est requis",
    editEventTitle: "Modifier l'événement",
    editEvent: "Modifier l'événement",
    editedEvent: "L'événement a été modifié avec succès",
    deletedEvent: "L'événement a été supprimé avec succès",
    addedEvent: "L'événement a été ajouté avec succès",
    meetingBetweenTeachersAdvisors:
      "Réunion entre les enseignants et les conseillers pédagogiques",
    createdBy: "Créé par le conseiller",
  },
  chat: {
    ROOMS_EMPTY: "Aucune conversation",
    ROOM_EMPTY: "Aucune conversation sélectionnée",
    NEW_MESSAGES: "Nouveaux messages",
    MESSAGE_DELETED: "Ce message a été supprimé",
    MESSAGES_EMPTY: "Aucun message",
    CONVERSATION_STARTED: "La conversation a commencée le :",
    TYPE_MESSAGE: "Tapez votre message",
    SEARCH: "Rechercher",
    filter: "Filtre",
    IS_ONLINE: "est en ligne",
    searchParents: "Rechercher un parent",
    parentDetails: "Détails du parent",
    startNewConversationWithParent:
      "Créer nouvelle conversation avec un parent",
    addParent: "Ajouter un parent",
    deleted: "Supprimé",
    LAST_SEEN: "dernière connexion",
    noLogin: "Aucun compte de connexion",
    inactiveParent: "Parent inactif",
    alreadyAdded: "Déjà ajouté au chat",
    availableToAdd: "Disponible à ajouter",
    noParentsFound: "Aucun parent trouvé",
    legacyMessage: "Messages hérités (avant la séparation par type de parent)",
    legacyMessageInfo:
      "Les messages ci-dessus ont été envoyés lorsque les parents avaient un compte joint.",
    deleteMessage: "Supprimer le message",
    individualChats: "Discussions individuelles",
    groupChats: "Discussions de groupe",
    groupDetails: "Détails du groupe",
    name: "Nom",
    members: "Membres",
    teacher: "Enseignant",
    parent: "Parent",
    manager: "Gestionnaire",
    group: "Groupe",
    user: "Utilisateur",
    description: "Description",
    noDescription: "Aucune description",
    classLabel: "Classe",
    subjectLabel: "Matière",
    noSubject: "Aucune matière",
    classroomBased: "Basé sur la classe",
    subjectBased: "Basé sur la matière",
    manualSelection: "Manuel",
    selectionMode: "Mode de sélection",
  },
  paymentStatus: {
    paymentStatus: "Statut des paiement",
    paidAmount: "Le montant payé",
    monthRemainingPayments: "Paiements restants ({month})",
    allRemainingPayments: "Tous les paiements restants",
    noRemainingPyaments: "Il n'y a paiements restants",
    nothingPaid: "Il n'y a pas de paiements payés",
    statutPaiement: "Statut de paiement",
    nomEleve: "Nom de l'élève",
    categorie: "Catégorie",
    frais: "Frais",
    montant: "Montant",
    etat: "Etat",
    totalNonPaye: "Total non payé",
    totalPaye: "Total payé",
    totalAPayer: "Total à payer",
    resteAPayer: "Reste à payer",
    legende: "Légende",
    date: "Date",
    inscription: "Inscription",
    pastYearsArrearsTitle: "Impayés des années scolaires précédentes",
    pastYearsArrearsSummary:
      "{fees} frais non réglés (scolarité et activités) sur : {years}. À encaisser avant les nouvelles inscriptions.",
    pastYearsArrearsDetails: "Voir le détail",
    pastYearsArrearsHide: "Masquer le détail",
    pastYearsArrearsCollect: "Encaisser sur {year}",
    scolarite: "Scolarité",
    activite: "Activité",
  },
  language: {
    ar: "Arabe",
    fr: "Français",
    en: "Anglais",
    sw: "Swahili",
  },
  appreciation: {
    adminAppreciation: "Appréciation de l'admin",
    withOptions: "Appréciations spécifiées",
    manual: "Appréciations manuelles",
    automaticDescription: "Système automatique basé sur les moyennes",
    automaticDescriptionCollege:
      "Appréciation automatique par moyenne de matière (collège / lycée).",
    applyNotImplemented:
      "L'application n'est pas encore disponible ; elle sera activée dans une prochaine mise à jour.",
    appreciation: "Appréciation",
    automatic: "Appréciation automatique",
    applyAutomatic: "Appliquer l'appréciation automatique",
    duplicateAppreciations: "Dupliquer les appréciations",
    existingAppreciations: "Appréciations existantes",
    noExistingAppreciations: "Aucune appréciation existante trouvée",
    selectToReplace:
      "Sélectionnez les appréciations que vous souhaitez remplacer par des appréciations automatiques:",
    add: "Ajouter une appréciation",
    changedToManual: "Le mode d'appréciation est passé à manuel",
    changedToOptions: "Le mode d'appréciation est passé à spécifié",
    giveAppreciation: "Donner une appréciation",
    bulkAppreciation: "Appréciations en masse",
    selectAppreciation: "Sélectionner une appréciation",
    customAppreciation: "Ajouter une appréciation personnalisée",
    selectPredefinedAppreciation: "Sélectionner une appréciation prédéfinie",
    insertPredefinedAppreciation: "Insérer une appréciation prédéfinie",
    teacherManualDesc:
      "L'enseignant a accès à écrire quoi que ce soit dans l'appréciation",
    saved: "L'appréciation a été enregistrée avec succès",
    deleted: "L'appréciation a été supprimer avec succès",
    teacherAppreciation: "Appréciations des enseignants",
    studentsWithoutAppreciation: "Élèves sans aucune appréciation",
    allStudentsHaveAppreciations: "Tous les étudiants ont des appréciations",
    missingAppreciation: "manque des appréciations",
    appreciationGiven: "Appréciation donnée",
    duplicateAppreciations: "Dupliquer les appréciations",
    noTeacherAssigned: "Aucun enseignant assigné",
    transferAppreciation: "Transférer les appréciations",
    transferSource: "Bulletin source",
    transferTarget: "Bulletin cible",
    selectTargetType: "Sélectionner le type de bulletin cible",
    targetModulesSelected: "{count} module(s) cible(s) sélectionné(s)",
    transferSelectSource: "Veuillez sélectionner un module source",
    transferSelectTargetModules: "Veuillez sélectionner au moins un module cible",
    transferNoModules: "Aucun module disponible",
    transferPickTypeFirst: "Sélectionnez un type de bulletin cible pour afficher les modules",
    transferOverwritePolicy: "Que faire si une appréciation existe déjà",
    transferSkipExisting: "Ignorer les appréciations existantes",
    transferReplaceExisting: "Remplacer les appréciations existantes",
    transferConfirmTitle: "Confirmer le transfert",
    transferConfirmContent:
      "Copier les appréciations de « {source} » ({sourceType}) vers {count} module(s) ({targets}) de type {targetType} ? Politique : {policy}",
    transferResult:
      "Transfert terminé : {copied} copiée(s), {skipped} ignorée(s)",
    applySuccess:
      "Les appréciations automatiques ont été appliquées à {count} élèves",
    applyNone: "Aucune appréciation automatique n'a été appliquée.",
    cloneCollegeSourceHint:
      "Choisissez la matière et l'année scolaire dont vous voulez copier les barèmes d'appréciation automatique.",
    cloneCollegeTargetHint:
      "Choisissez d'abord la ou les années scolaires cibles. Vous pouvez sélectionner plusieurs niveaux et plusieurs trimestres ; la liste des matières regroupe le bulletin pour toutes ces combinaisons. « Tout sélectionner » coche tous les niveaux, tous les trimestres et toutes les matières sauf la source.",
    cloneSelectAllNoLevels:
      "Aucun niveau n'est disponible pour cet établissement.",
    cloneSelectAllNoSubjects:
      "Aucune matière cible trouvée, ou seule la matière source figure dans la configuration — ajoutez d'autres matières ou modifiez les filtres.",
    cloneCollegeSourceIncomplete:
      "Veuillez sélectionner la matière source et l'année scolaire source.",
    selectTargetSubjects: "Veuillez sélectionner au moins une matière cible.",
    selectTargetTrimesters:
      "Veuillez sélectionner au moins un trimestre cible.",
    selectTargetLevels: "Veuillez sélectionner au moins un niveau cible.",
    selectSourceModule:
      "Veuillez sélectionner le module source et l'année scolaire",
    selectTargetSchoolYear: "Veuillez sélectionner l'année scolaire cible",
    selectTargetModules:
      "Veuillez sélectionner les modules cibles ou les filtres",
    noTargetModulesFound: "Aucun module cible trouvé",
    noAutoAppreciationToClone: "Aucune appréciation automatique à cloner",
  },
  connected: {
    online: "En ligne",
    offline: "hors ligne",
    all: "Tout",
    button_name: "Utilisateurs",
    school_user: "utilisateurs administrateurs",
    noname: "Sans-nom",
  },
  feedback: {
    title: "Commentaire",
    sendFeedback: "Envoyer un commentaire",
    category: "Catégorie",
    comment: "Commentaire",
    problem: "Probléme/bug",
    idea: "Idée d'amélioration",
    others: "Autre",
    section: "Section",
    selectSection: "Veuillez sélectionner la section",
    priority: "Priorité",
    selectPriority: "Veuillez choisir la priorité",
    low: "Basse",
    medium: "Moyenne",
    high: "Haute",
    critical: "Critique",
    message: "Message",
    uploadFiles: "Télécharger des fichiers",
    uploadAudio: "Enregistrement audio",
    record: "Enregistrer",
    successSent:
      "Merci pour votre contribution. Nous allons l'examiner et vous recontacter si besoin. Bonne journée !",
  },
  certification: {
    Corresponding: "Décision correspondante",
    pass: "Admis",
    fail: "Refusé",
    cnd_pass: "Admis par dérogation",
    age_pass: "Admis par dérogation d'âge (إسعاف عمري)",
    add: "Ajouter un certificat",
    moyPer: "Moyenne personnalisé",
    moySpec: "Moyenne specifique",
    default: "Utiliser les certificats par défaut",
    confirmDefault:
      "Cette action supprimera votre certification. Êtes-vous sûr de le définir par défaut ?",
    name: "Nom du certificat",
    min: "Moyenne minimale",
    max: "Moyenne maximale",
    minError:
      "La moyenne minimale ne peut pas être supérieure à la moyenne maximale",
    maxError:
      "La moyenne maximale ne peut pas être inférieure à la moyenne minimale",
    defaultDone: "Les certificats ont été mis à jour avec succès",
    addCertificateDesigns: "Ajoutez vos designs de certificats",
    namePlaceholder: "ex: Certificat de remerciement",
    fileUploadedSuccessfully: "Fichier téléchargé avec succès",
    moyenne: "Moyenne",
    certificateDate: "Date du certificat",
    printDate: "Date d'impression",
    printDateEnabled: "Activer la date d'impression",
    dateFormat: "Format de date",
    dateLabel: "Texte avant la date",
    stamp: "Cachet",
    stampEnabled: "Activer le cachet",
    stampPosition: "Position du cachet",
    stampScale: "Échelle du cachet",
    stampWarning: "Aucun cachet n'est configuré pour cette école",
    stampHelp:
      "Le cachet sera ajouté automatiquement depuis les paramètres de l'établissement",
    generalSettings: "Configuration générale",
    studentName: "Nom de l'élève",
    className: "Nom du classe",
    trimesterName: "Nom du trimestre",
    schoolYearHeader: "Année scolaire",
    printDateHeader: "Date d'impression",
    stampHeader: "Cachet",
    orientation: "Orientation",
    positionX: "Position X",
    font: "Font",
    size: "Taille",
    color: "Couleur",
    enable: "Activer",
    format: "Format",
    textBefore: "Texte avant",
    scale: "Échelle",
    vertical: "Vertical",
    horizontal: "Horizontal",
    centered: "Centré",
    atStart: "Au début",
    dateFormatDDMMYYYY: "JJ/MM/AAAA",
    dateFormatYYYYMMDD: "AAAA-MM-JJ",
    placeholderOrientation: "orientation",
    placeholderPositionX: "Position X",
    placeholderSelectFont: "Sélectionner une police",
    placeholderX: "x",
    placeholderY: "y",
    placeholderTextSize: "Taille du texte",
    placeholderDateLabel: "ex: Date d'impression :",
    placeholderScale: "1.0",
    scaleHelp: "Entre 0.1 et 3 (1 = taille normale)",
  },
  decisionConseil: {
    decision: "Décision",
    decisionM: "Décision (garçon)",
    decisionF: "Décision (fille)",
    decisionConseil: "Décisions du conseil",
    default: "Utiliser les décisions par défaut",
    defaultDone: "Les décisions du conseil ont été mis à jour avec succès",
    confirmDefault:
      "Cette action supprimera vos décisions du conseil. Êtes-vous sûr de le définir par défaut ?",
    editorTitle: "Décisions du conseil par élève",
    openEditor: "Décisions du conseil",
    auto: "Auto (par moyenne)",
    other: "Autre",
    manualPlaceholder: "Saisir la décision",
    apply: "Appliquer",
    applyToSelected: "Appliquer à la sélection",
    selectDecision: "Choisir une décision",
    selectStudents:
      "Veuillez sélectionner au moins un élève avant d'appliquer.",
    noClassroom: "Veuillez sélectionner une classe d'abord.",
    unsavedHint:
      "Vous avez des modifications non enregistrées. Cliquez sur Enregistrer pour les confirmer.",
    bulkConfirmTitle: "Appliquer à la sélection",
    bulkConfirmContent:
      "Cette décision ne sera attribuée qu'aux élèves sélectionnés ayant un moyenne générale. Les élèves sans moyenne seront ignorés.",
    bulkConfirmCounts:
      "{eligible} élève(s) sur {selected} sélectionné(s) seront mis à jour.",
    noEligibleStudents:
      "Aucun élève sélectionné n'a de moyenne générale. La décision ne peut pas être appliquée.",
    noMoyenneForStudent:
      "Cet élève n'a pas de moyenne générale. Une décision du conseil ne peut pas être attribuée.",
    filterByStudentName: "Rechercher par nom d'élève",
    decisonOnPlaceholder: "Décision correspondante",
    decisonOnRequired:
      "Veuillez choisir la décision correspondante (A/C/R) pour le PV conseil de classe.",
    pvNotDisplayed: "Non affiché au PV",
    pvMissingKeyRow:
      "Cet élève ne sera pas affiché dans le PV conseil de classe. Corrigez le paramétrage ou assignez une décision correspondante.",
    pvMissingKeyBanner: "{count} élève(s) sans décision correspondante (A/C/R)",
    pvMissingKeyHint:
      "Ces élèves n'apparaîtront pas dans les tableaux du PV conseil de classe. Corrigez le paramétrage des décisions du conseil ou assignez une décision par élève.",
    pvMissingKeyMore: "... et {count} autre(s)",
    years:  "Périodes d'étude",
  },
  notifications: {
    desactivation:
      "Compte a été suspendu ! Contacter l'administration pour plus d'information !",
    desactivateBuilding:
      "Votre établissement a été suspendu ! Contacter l'administration pour plus d'information !",
    updateuser: "Compte Modifié ! veuillez reconnecter!",
    updateAccess: "Accès Modifié ! veuillez reconnecter!",
  },
  login: {
    incorrectInfo: "Le nom d'utilisateur ou mot de passe est incorrect",
    bienvenue: "Bienvenue à",
    title: "Système de gestion pour les établissements scolaires",
    connectezVous: "Connectez-vous !",
    connextion: "Connexion",
    requisMdp: "Veuillez saisir votre mot de passe!",
    requisUsername: "Veuillez saisir votre username!",
    username: "Nom de l'utilisateur",
    password: "Mot de passe",
    connecte: "Connecté",
    loginSuccess: "Vous vous êtes connecté avec succès",
    readAndAccept: "j'ai lu et j'accepte les",
    termsAndConditions: "Termes et Conditions",
    subscribePart1:
      "Si votre école n'est pas encore inscrite, découvrez nos offres exclusives sur notre ",
    subscribePart2: "site web",
    subscribePart3: "et rejoignez notre communauté éducative dès aujourd'hui !",
    scanQR: "Approchez votre QR code de la webcam pour vous connecter.",
    back: "Retour",
    qrCodeInvalid: "Le QR code est invalide",
    oldQRCode:
      "Ce QR code utilise un ancien format. Demandez un nouveau code à l'administration.",
    qrCameraError: "Impossible d'accéder à la caméra",
  },
  mfa: {
    twoFactorAuth: "Authentification à deux facteurs",
    notEnabled: "L'authentification à deux facteurs n'est pas activée",
    notEnabledDescription:
      "Activez l'authentification à deux facteurs pour ajouter une couche de sécurité supplémentaire à votre compte.",
    enable: "Activer",
    enabled: "L'authentification à deux facteurs est activée",
    enabledDescription:
      "Votre compte est protégé par l'authentification à deux facteurs.",
    enabledSuccess:
      "L'authentification à deux facteurs a été activée avec succès.",
    disabled: "L'authentification à deux facteurs est désactivée",
    disabledSuccess:
      "L'authentification à deux facteurs a été désactivée avec succès.",
    method: "Méthode",
    authenticatorApp: "Application d'authentification",
    sms: "SMS",
    phoneNumber: "Numéro de téléphone",
    disable: "Désactiver",
    disableConfirmation:
      "Êtes-vous sûr de vouloir désactiver l'authentification à deux facteurs ? Cela rendra votre compte moins sécurisé.",
    passwordRequiredToDisable:
      "Pour des raisons de sécurité, veuillez entrer votre mot de passe pour désactiver l'authentification à deux facteurs.",
    enterPasswordToDisable: "Entrez votre mot de passe",
    passwordRequired: "Le mot de passe est requis",
    invalidPassword: "Mot de passe invalide. Veuillez réessayer.",
    confirmDisable: "Désactiver MFA",
    setup: "Configurer l'authentification à deux facteurs",
    chooseMethod: "Choisir la méthode",
    verify: "Vérifier",
    complete: "Terminer",
    phoneRequired:
      "Un numéro de téléphone est requis pour l'authentification par SMS. Veuillez d'abord ajouter un numéro de téléphone dans votre profil.",
    continue: "Continuer",
    scanQRCode: "Scanner le code QR",
    scanQRCodeDescription:
      "Utilisez votre application d'authentification pour scanner ce code QR.",
    manualEntry: "Impossible de scanner ? Entrez ce code manuellement :",
    secret: "Secret",
    next: "Suivant",
    smsReady:
      "L'authentification par SMS est prête. Cliquez sur 'Activer' pour l'activer.",
    verificationRequired: "Vérification requise",
    enterAppCode:
      "Entrez le code à 6 chiffres de votre application d'authentification.",
    enterSMSCode:
      "Entrez le code à 6 chiffres envoyé à votre téléphone. Le SMS peut prendre jusqu'à 10 minutes pour être reçu.",
    sentTo: "Code envoyé à",
    verificationCode: "Code de vérification",
    codeRequired: "Le code de vérification est requis",
    codeLength: "Le code doit contenir 6 chiffres",
    codeFormat: "Le code doit contenir 6 chiffres",
    enterCode: "Entrez le code à 6 chiffres",
    enterBackupCode: "Entrez le code de secours",
    backupCode: "Code de Secours",
    authenticatorCode: "Code Authentificateur",
    backupCodeLength: "Le code de secours doit contenir 8 caractères",
    backupCodeFormat:
      "Le code de secours doit contenir 8 caractères alphanumériques",
    backupCodeHint:
      "Entrez l'un de vos codes de secours. Chaque code ne peut être utilisé qu'une seule fois.",
    useBackupCode:
      "Vous n'avez pas accès à votre authentificateur ? Utilisez un code de secours",
    useAuthenticatorCode: "Utiliser le code de l'authentificateur à la place",
    resendCode: "Renvoyer le code",
    codeSent: "Code envoyé",
    codeSentDescription:
      "Un nouveau code de vérification a été envoyé à votre téléphone.",
    rateLimitExceeded: "Limite de renvoi atteinte",
    rateLimitMessage:
      "Vous devez attendre {minutes} minutes avant de pouvoir demander un nouveau code.",
    rateLimitMessageSingular:
      "Vous devez attendre {minutes} minute avant de pouvoir demander un nouveau code.",
    backupCodes: "Codes de secours",
    backupCodesDescription:
      "Enregistrez ces codes de secours dans un endroit sûr. Vous pouvez les utiliser pour accéder à votre compte si vous perdez l'accès à votre application d'authentification.",
    copyCodes: "Copier les codes",
    codesCopied: "Codes de secours copiés dans le presse-papiers",
    smsEnabledDescription:
      "L'authentification par SMS a été activée. Vous recevrez un code par SMS lors de la connexion.",
    chooseMethodTitle: "Choisissez votre méthode de sécurité",
    chooseMethodDescription:
      "Sélectionnez comment vous souhaitez vérifier votre identité lors de la connexion. Nous recommandons d'utiliser une application d'authentification pour une meilleure sécurité.",
    recommended: "Recommandé",
    authenticatorAppDescription:
      "Utilisez une application d'authentification sur votre téléphone pour générer des codes sécurisés. Fonctionne même sans connexion Internet.",
    moreSecure: "Plus sécurisé que le SMS",
    fasterLogin: "Connexion plus rapide - pas d'attente de SMS",
    moreReliable: "Plus fiable - pas de délais SMS",
    noNetworkNeeded: "Aucun réseau nécessaire sur votre téléphone",
    industryStandard: "Méthode de sécurité standard de l'industrie",
    smsDescription:
      "Recevez des codes de vérification par message texte sur votre numéro de téléphone.",
    setupAuthenticatorApp: "Configurer l'application d'authentification",
    setupAuthenticatorAppDescription:
      "Suivez ces étapes simples pour configurer l'authentification à deux facteurs avec une application d'authentification.",
    step1Download: "Étape 1 : Télécharger une application d'authentification",
    downloadInstruction:
      "Si vous n'avez pas encore d'application d'authentification, téléchargez l'une de ces applications gratuites sur votre téléphone :",
    appStore: "App Store",
    googlePlay: "Google Play",
    step2Scan: "Étape 2 : Scanner le code QR",
    scanQRCodeInstruction:
      "Ouvrez votre application d'authentification et scannez ce code QR avec l'appareil photo de votre téléphone. L'application ajoutera automatiquement votre compte sous le nom 'EdManager'.",
    cantScan: "Impossible de scanner le code QR ?",
    manualEntryDescription:
      "Si vous ne pouvez pas scanner le code QR, vous pouvez entrer ce code secret manuellement dans votre application d'authentification :",
    copySecret: "Copier le secret",
    secretCopied: "Code secret copié dans le presse-papiers",
    iHaveScanned: "J'ai scanné le code",
    setupSMS: "Configurer l'authentification par SMS",
    setupSMSDescription:
      "L'authentification par SMS enverra des codes de vérification à votre numéro de téléphone enregistré.",
    smsReadyDescription:
      "L'authentification par SMS est prête à être activée. Vous recevrez un code à 6 chiffres par message texte à chaque connexion.",
    enterAppCodeDescription:
      "Ouvrez votre application d'authentification et entrez le code à 6 chiffres affiché sur votre écran.",
    enterSMSCodeDescription:
      "Vérifiez votre téléphone pour le message SMS et entrez le code à 6 chiffres que vous avez reçu.",
    codeHint:
      "Le code se renouvelle toutes les 30 secondes. Assurez-vous d'entrer le code actuel.",
    backupCodesWarning: "Important : Enregistrez ces codes maintenant !",
    securityAlertTitle:
      "⚠️ Recommandation de sécurité : Activez l'authentification à deux facteurs",
    securityAlertDescription:
      "Protégez votre compte avec une couche de sécurité supplémentaire. L'authentification à deux facteurs réduit considérablement le risque d'accès non autorisé à votre compte.",
    benefit1:
      "Empêche l'accès non autorisé même si votre mot de passe est compromis",
    benefit2:
      "Requis par les meilleures pratiques de sécurité pour les comptes sensibles",
    benefit3:
      "Protège vos données et prévient les attaques de prise de contrôle de compte",
    setupError: "Erreur de configuration MFA",
    setupErrorDescription:
      "Impossible de configurer l'authentification à deux facteurs",
    enableError: "Erreur d'activation MFA",
    enableErrorDescription:
      "Le code de vérification est incorrect. Veuillez vérifier le code et réessayer.",
    disableError: "Erreur de désactivation MFA",
    disableErrorDescription:
      "Mot de passe invalide. Veuillez vérifier le mot de passe et réessayer.",
    invalidCode: "Code de vérification invalide",
    invalidCodeDescription: "Le code de vérification est incorrect",
    smsError: "Erreur d'envoi SMS",
    smsErrorDescription: "Impossible d'envoyer le code SMS",
    adminStatusOn: "MFA activé",
    adminStatusOff: "MFA non activé",
    adminDisableConfirm:
      "Désactiver le MFA pour ce compte ? L'utilisateur sera déconnecté de tous ses appareils et se connectera uniquement avec son mot de passe.",
    adminDisableSuccess: "MFA désactivé avec succès",
    adminDisableError: "Impossible de désactiver le MFA",
  },
  forceLogout: {
    passwordChanged: "Votre mot de passe a été modifié",
    accountDeactivated: "Votre compte a été désactivé",
    mfaEnabled: "La MFA a été activée sur votre compte",
    securityEvent: "Événement de sécurité détecté",
    sessionExpired: "Session expirée",
    loggedOut: "Vous avez été déconnecté. Veuillez vous reconnecter.",
  },
  trialCommercialBlock: {
    title: "Votre période d'essai est terminée",
    badge: "Essai gratuit terminé",
    body:
      "Merci d'avoir testé EdTrust. Pour continuer à gérer votre établissement depuis EdManager, contactez notre équipe commerciale afin de choisir l'offre adaptée.",
    contactTitle: "Contactez notre équipe commerciale",
    switchBuildingHint:
      "Vous pouvez toujours accéder à vos autres établissements en changeant d'établissement ci-dessous.",
    accountsKeptTitle: "Les comptes EdParent et EdTeacher sont conservés",
    parentsKept: "Les comptes des parents ne sont pas supprimés.",
    teachersKept: "Les comptes des enseignants ne sont pas supprimés.",
    accountsKeptFootnote: "L'accès complet sera rétabli dès la régularisation de votre situation.",
    phoneLabel: "Téléphone",
    emailLabel: "E-mail",
  },
  overduePaymentBlock: {
    title: "L'accès à EdManager est suspendu",
    badge: "Paiement en attente",
    body:
      "Les frais d'abonnement de votre établissement n'ont pas encore été réglés. Pour réactiver l'accès, veuillez contacter notre équipe commerciale pour régulariser votre paiement.",
    reasonLabel: "Motif :",
    reason: "date limite de paiement dépassée depuis plus de {days} jours (date prévue : {date}, heure de Tunis, UTC+1).",
    reasonNoDate: "date limite de paiement dépassée depuis plus de {days} jours.",
    contactTitle: "Une question sur votre paiement ? Contactez notre équipe commerciale",
  },
  auth: {
    loginFailed: "La connexion a échoué",
    ssoLoginFailed: "La connexion a échoué SSO",
    genericError: "Une erreur est survenue",
  },
  niveau: {
    niveauPre: "Préscolaire",
    niveau0: "Préparatoire",
    playGroup: "Groupe de jeu",
    pp1: "PP1",
    pp2: "PP2",
    niveau1: "1 ère année",
    niveau2: "2 ème année",
    niveau3: "3 ème année",
    niveau4: "4 ème année",
    niveau5: "5 ème année",
    niveau6: "6 ème année",
    niveau7: "7 ème année",
    niveau8: "8 ème année",
    niveau9: "9 ème année",
    niveau10: "1 ère année secondaire",
    niveau11: "2 ème année secondaire",
    niveau12: "3 ème année secondaire",
    niveau13: "4 ème année secondaire",
    autres: "Autres",
  },
  assiduite: {
    assiduite: "Assiduité",
    retard: "Retard",
    present: "Présent",
    absence: "Absence",
    exclus: "Exclu",
    assiduiteMSA: "Assiduité a été mise à jour",
    assiduiteMoisChart: "Assiduité ce mois-ci de classe { className }",
    nb_absent: "Nombre d'absences",
    nb_delay: "Nombre de retards",
    nb_exclusion: "Nombre d'exclus",
    date: "Date",
    areYouSureToEdit: "Êtes-vous sûr de vouloir modifier l’assiduité ?",
    erreurRecuperationSeances: "Erreur lors de la récupération des séances",
    erreurRecuperationDonnees:
      "Erreur lors de la récupération des données d'assiduité",
    callSheet: "Feuille d'appel",
    seance: "Séance",
    type: "Type",
  },
  teacherAttendance: {
    title: "Assiduité des enseignants",
    teacher: "Enseignant",
    filterTeacher: "Filtrer par enseignant",
    allTeachers: "Tous les enseignants",
    filterStatus: "Filtrer par statut",
    allStatuses: "Tous les statuts",
    notMarked: "Non marqué",
    status_present: "Présent",
    status_absent: "Absent",
    status_late: "En retard",
    status_absent_morning: "Absent (matin)",
    status_absent_afternoon: "Absent (après-midi)",
    status_absent_morning_short: "Matin",
    status_absent_afternoon_short: "Après-midi",
    lateTitle: "Saisir le retard",
    enterDelay: "Veuillez saisir la durée du retard (en minutes)",
    delayPlaceholder: "Durée en minutes",
    updated: "Assiduité mise à jour",
    removed: "Assiduité supprimée",
    offSite: "Hors site",
    offSiteHint:
      "Le pointage a été effectué hors de la zone de l'établissement",
    tabDaily: "Pointage journalier",
    tabPersonnelDaily: "Journalier (sans emploi)",
    tabReport: "Rapport",
    reportMode: "Type de rapport",
    personnelDailyReportTitle: "Rapport assiduité journalière",
    markedDays: "Jours marqués",
    tabComparison: "Attendu vs réel",
    searchByName: "Rechercher par nom",
    searchByNamePlaceholder: "Nom du personnel...",
    comparisonHint:
      "Compare les heures attendues (config matière × semaines, ou emploi du temps / config journalière) aux heures réelles. Développez une ligne enseignant pour le détail par matière.",
    comparisonTitle: "Rapport attendu vs réel",
    expectedHours: "Heures attendues",
    actualHours: "Heures réelles",
    absentHours: "Heures d'absence",
    delayHours: "Heures de retard",
    varianceHours: "Écart",
    timetableHours: "Heures emploi du temps",
    noSubjectBreakdown: "Pas de détail par matière pour cette personne.",
    validationPending: "En attente de validation",
    validationValidated: "Validé",
    validate: "Valider",
    validateAll: "Valider tous les en attente",
    validationHint:
      "La hiérarchie de validation est activée : les pointages restent en attente jusqu'à confirmation par un responsable.",
    moduleDisabled:
      "L'assiduité enseignants est désactivée pour cet établissement. Activez-la dans Établissement → Configurations.",
    personnelDailyHint:
      "Assiduité par personne et par jour, sans lien avec l'emploi du temps. Non marqué = Présent par défaut.",
    filterPersonnel: "Filtrer par personnel",
    allPersonnel: "Tout le personnel",
    defaultPresent: "Présent (défaut)",
    reportTitle: "Rapport assiduité enseignants",
    period: "Période",
    delayMinutes: "Retard (min)",
    workedHours: "Heures travaillées",
    workedDays: "Jours travaillés",
    editHistory: "Historique des pointages",
    noHistory: "Aucun historique pour le moment",
    recordDeleted: "Ce pointage a été supprimé",
    showDeleted: "Afficher les supprimés",
    historyBy: "Par",
    historyBefore: "Avant",
    historyAfter: "Après",
    historyAction_created: "Créé",
    historyAction_updated: "Modifié",
    historyAction_deleted: "Supprimé",
    historyAction_restored: "Restauré",
    source_teacher_checkin: "Pointage enseignant",
    source_admin_manual: "Saisie manuelle",
    minShort: "min",
  },
  avance: {
    ajoutAvance: "Ajouter une avance",
    ajoutAvanceSubTitle:
      "Veuillez remplir les champs ci-dessous pour ajouter une avance.",
    montantAvance: "Montant avance",
    impoAnnulerAvance: "Impossible d'annuler l'avance",
    typeRecetteRequis: "Le type de recette est requis !",
    saisirChequeInfo: "Saisir les informations du chèque",
    saisirChequeEspaceInfo: "Saisir les informations du chèque et espéce",
    chequeNumRequis: "Le numéro du chèque est requis !",
    historiqueAvances: "Historique des avances",
    avanceAjoute: "Avance ajoutée avec succès",
  },
  xlsxUploader: {
    cliquer:
      "Cliquer ou faire glisser un fichier dans cette zone pour le télécharger",
    importEleves: "Importer des élèves",
    importElevesSubTitle:
      "Importer des élèves en suivant la fromat dans la template",
    downloadTemplate: "Télécharger la template Excel",
    affectation: "Affectation",
    affectationSubTitle: "Affecter les parents",
    enregistrer: "Enregistrer",
    enregistrerSubTitle: "Vérifier puis enregistrer",
    erreurValidationEleves: "Erreur de validation - feuille élèves",
    erreurValidationParents: "Erreur de validation - feuille parents",
    erreurFormatDate: "Erreur de format de date",
    formatFichierInvalide: "Format de fichier invalide",
    formatFichierInvalideSubTitle:
      "Veuillez télécharger le fichier modèle et y remplir vos données!",
    verifierDonnees: "Vérifier vos données",
    affecterParents: "Affecter les parents",
    sectionParent: "Section parent dans le tableaux",
    totalEleves: "Total des élèves",
    totalParents: "Total des parents",
    elevesNonAffectes: "Eléves non affecté",
    verificationParents:
      "A vérifier ,plusieurs parents avec le même nom peuvent être affectés",
    eleveNonAffecte: "Eléve non affecté",
    affecterParent: "Affecter un parent",
    rechercher: "Rechercher",
    reset: "Réinitialiser",
    laLigne: "la ligne",
    lesLignes: "les lignes",
    dansLeFichierExcel: "dans le fichier excel",
    verifierDonneesEleves:
      "Veillez vérifier les données obligatoires des élèves",
    verifierDonneesParents:
      "Veillez vérifier les données obligatoires des parents",
    verifierDonnees:
      "Veillez vérifier les formats des données, les champs obligatoires et l'affectation des parents à chaque élève",
    listeImporteeSucces: "Liste importée avec succès",
    incompleteImport:
      "Importation incomplète, des élèves ou des parents n'ont pas été importés",
    erreurImportationParents: "Erreur d'importation des parents",
    elevesExistants: "Élèves potentiellement existants",
    elevesExistantsPotentiels: "Élèves existants potentiels",
    existeDeja: "Existe potentiellement déjà dans la base",
    correspondances: "Correspondances",
    eleveExisteDeja: "élève existe potentiellement déjà",
    elevesExistentDeja: "élèves existent potentiellement déjà",
    lignesExcel: "Lignes",
    verifierAvantImport: "Veuillez vérifier avant d'enregistrer",
    erreurVerificationExistence:
      "Erreur lors de la vérification des élèves existants. Veuillez continuer avec prudence.",
    filtrerPar: "Filtrer par",
    effacerFiltres: "Effacer les filtres",
    erreurImportationEleves: "Erreur d'importation des élèves",
    erreurImportationSubTitle: "Veuillez vérifier les lignes suivantes",
    elevesExistantsDeja: "Élèves potentiellement existants",
    elevesExistantsDejaSubTitle:
      "Ces élèves existent peut-être déjà dans la base de données",
    verificationEnCours: "Vérification des élèves existants en cours...",
    eleveExistePotentiellement: "Cet élève existe potentiellement déjà",
    confirmerEnregistrement: "Confirmer l'enregistrement",
    resumeImportation: "Résumé de l'importation",
    totalDansFichier: "Total dans le fichier Excel",
    elevesAInserer: "Élèves à insérer",
    elevesAvecParentsSimilaires: "Élèves avec parents similaires",
    confirmezVousEnregistrement:
      "Confirmez-vous l'enregistrement de ces élèves ?",
    eleves: "élèves",
    confirmerRetraitTitle: "Confirmer le retrait",
    confirmerRetrait: "Confirmer le retrait",
    confirmer: "Confirmer",
    annuler: "Annuler",
    confirmerRetraitMessage:
      "Êtes-vous sûr de vouloir retirer {count} élève(s) de la liste ?",
    actionIrreversible: "Cette action est irréversible",
    selectionnerAuMoinsUn: "Veuillez sélectionner au moins un élève",
    elevesRetires: "{count} élève(s) retiré(s) avec succès",
    modeSelection: "Mode de sélection actif",
    modeSelectionDescription:
      "Sélectionnez les élèves à retirer de la liste, puis cliquez sur 'Confirmer le retrait'",
    retirerDeLaListe: "Retirer de la liste",
    actions: "Actions",
    nomPrenom: "Nom et prénom",
    dateNaissance: "Date de naissance",
    adresse: "Adresse",
    sexe: "Sexe",
    telephone: "Téléphone",
    identifiantUnique: "Identifiant unique",
    parent: "Parent",
    garcon: "Garçon",
    fille: "Fille",
    elevesRetiresDeListe: "Élèves retirés de la liste",
  },
  profil: {
    noParentCredentials: "Ce parent n'a pas de compte de connexion",
    noParentInfo:
      "Veuillez ajouter les informations pour ce parent pour créer un compte de connexion",
    photoMediaConsent: "Consentement photo & médias du parent",
    photoMediaConsentCard: "Photos / médias",
    photoMediaConsentHint: "S’applique à tous les élèves de ce compte parent.",
    parentSuggestionTitle: "Parents qui ont le même numéro de téléphone",
    changerNomUtilisateur: "Changer le nom d'utilisateur",
    historique: "Historique",
    paiement: "Paiement",
    payes: "Payés",
    nonPayes: "Non payés",
    bulletin: " Bulletin",
    qrCode: "Qr code",
    informations: "Informations",
    Control: "Contrôle parentale ",
    edtudiant: "Informations élève",
    paiementScol: "Paiement scolarité",
    paiementAct: "Paiements activités",
    paidWithAvance: "Payé avec avance",
    listeReglements: "Liste de règlements",
    sexe: "Sexe",
    nom: "Nom ",
    middleName: "Deuxième prénom",
    prenom: "Prénom",
    nomFr: "Nom en français",
    prenomFr: "Prénom en français",
    middleNameFr: "Deuxième prénom en français",
    nemisNumber: "Numéro NEMIS de l'élève",
    birthCertificate: "Certificat de naissance",
    saccoName: "Nom du SACCO",
    saccoBankName: "Nom de la banque SACCO",
    fullname: "Nom et prénom",
    dateNaissance: "Date de naissance",
    garcon: "Garçon",
    fille: "Fille",
    adresse: "Adresse",
    postalAddress: "Adresse postale",
    physicalAddress: "Adresse physique",
    tel: "Téléphone",
    classe: "Classe",
    notes: "Notes",
    healthInformation: "Informations de santé",
    bloodType: "Groupe sanguin",
    medicalCondition: "Condition médicale",
    medicalNotes: "Notes médicales",
    allergies: "Allergies",
    parentNoteOnAllergies: "Note des parents sur les allergies",
    unknown: "Inconnu",
    nonInscrit: "N'est pas encore inscrit",
    nomUser: "Nom d'utilisateur",
    mdp: "Mot de passe",
    currentPassword: "Mot de passe actuel",
    NewPwd: "Nouveau mot de passe",
    ConfirmNewPwd: "Confirmer nouveau mot de passe",
    resetPwd: "Reinitialiser mot de passe",
    gere: "Gérer",
    consulter: "Consulter",
    consulterPaiement: "Consulter Paiement",
    etat: "Etat",
    mois: "Mois",
    etablissement: "Etablissement",
    ajouteLe: "Ajouté le",
    lastModifi: "Dernière modification",
    annulerInscri: "Annuler l'inscription",
    father: "Père",
    mother: "Mère",
    guardian: "Tuteur",
    changerPrametreParent: "Changer les paramètres du parent",
    changerPrametreParents: "Changer les paramètres des parents",
    changerPrametreEleve: "Changer les paramètres de l'élevé",
    changerPrametreTeacher: "Changer les paramètres de l'enseignant(e)",
    teacherCredentialsSessionWarning:
      "La modification du nom d'utilisateur ou du mot de passe déconnectera l'enseignant(e) de tous les appareils et sessions.",
    noTeacherCredentials: "Ce compte n'a pas de compte de connexion",
    noTeacherInfo:
      "Veuillez ajouter les informations (email) pour ce compte pour créer un compte de connexion",
    ajouterCompteEnseignant: "Ajouter un compte enseignant",
    inscriActivitePour: "Inscription activité pour {name}",
    poid: "Poids",
    taille: "Taille",
    maladies: "Maladies",
    remarques: "Remarques",
    selectOption: "Sélectionner au moins une option",
    aucuneMaladieEnregistree: "Aucune maladie a été enregistrée",
    aucuneDossierMedical: "Aucun dossier médical est trouvé!",
    annulationEleve: "Annulation d'inscription",
    deleteEleve: "Suppression élève",
    nameChangeRequest: "Des modifications de nom ont été demandées le",
    firstNameChangeRequest: "Changement de prénom de",
    lastNameChangeRequest: "Changement de nom de",
    requestedBy: "demandé par",
    student: "Élève",
    to: "à",
    approuver: "Approuver",
    rejeter: "Rejeter",
    birthPlace: "Lieu de naissance",
    confirmDelete:
      "Êtes-vous sûr de vouloir supprimer cette photo de l'élève ? Cette action ne peut pas être annulée.",
    viewStudentPhoto: "Voir la photo de l'élève",
    uploadStudentPhoto: "Télécharger la photo de l'élève",
    removeStudentPhoto: "Supprimer la photo de l'élève",
    years: "ans",
    profile: "Profil",
    userProfilePhoto: "Photo de profil",
    uploadUserPhoto: "Télécharger la photo de profil",
    removeUserPhoto: "Supprimer la photo de profil",
    unavailableUserName: "Le nom d'utilisateur n'est pas disponible!",
    passwordMustIncludeDigit:
      "Le mot de passe doit contenir au moins un chiffre",
    passwordMustIncludeUppercase:
      "Le mot de passe doit contenir au moins une lettre majuscule",
    passwordMustIncludeLowercase:
      "Le mot de passe doit contenir au moins une lettre minuscule",
    passwordMinLength: "Le mot de passe doit contenir au moins 8 caractères",
    passwordMustNotMatchUsername:
      "Le mot de passe doit être différent du nom d'utilisateur",
    ajouterCompteParent: "Ajouter un compte parent",
    administration: "Administration",
  },
  topBar: {
    issuesHistory: "Histoire des problèmes",
    projectManagement: "Gestion de projet",
    typeToSearch: "Chercher...",
    findPages: "Trouver des pages...",
    actions: "Actes",
    status: "Statut",
    profileMenu: {
      hello: "Bonjour",
      billingPlan: "Plan de facturation",
      role: "Rôle",
      email: "Email",
      phone: "Téléphone",
      editProfile: "Editer le profil",
      logout: "Connectez - Out",
    },
    notification: {
      notifications: "Notifications",
      searchPlaceholder: "Rechercher des notifications...",
      noNotifications: "Aucune notification trouvé!",
      errorFetch: "Échec du chargement des notifications",
      readMore: "Lire plus",
    },
    bookmarks: "Favoris",
    pack: "Pack",
    storage: {
      menuLabel: "Stockage",
      menuHintNoBar: "Ouvrir pour l’historique et le détail",
      tooltip: "Espace de stockage",
      modalTitle: "Historique d'utilisation du stockage",
      seriesStorage: "Stockage",
      noData: "Aucune donnée de scan pour le moment",
      objectsLabel: "objets",
      currentSummary: "Dernier : {storage} · {count} objets",
      scopeDescription:
        "Ce total correspond à l’espace utilisé par votre établissement sur la plateforme : cours, exercices et autres fichiers déposés par les enseignants, et contenus similaires.",
      quotaTitle: "Stockage de votre pack",
      quotaUsedOf: "{used} sur {allowed} utilisés",
      quotaUnlimitedLine:
        "{used} utilisés · aucun plafond de stockage sur votre pack",
      quotaOver:
        "Vous avez dépassé la limite de stockage de votre pack. Les envois peuvent être bloqués. Contactez l’équipe commerciale pour augmenter votre quota.",
      quotaNear:
        "Vous approchez de la limite de stockage. Libérez de l’espace ou contactez l’équipe commerciale pour obtenir plus de quota.",
      objectsInLastScan: "{count} objets (dernier relevé)",
      chartLimitLabel: "Limite du pack",
    },
  },
  command: {
    idCommand: "ID Commande",
    clientName: "Nom du client",
    date: "Date",
    montant: "Montant",
    productName: "Nom du produit",
    quantity: "Quantité",
    etat: "Etat",
    status: "Statut",
    detailsTitle: "Détails de la commande",
    available: "Disponible",
    unavailable: "Indisponible",
    productsInCommand: "Produits dans la commande",
    associatedCommands: "Commandes associées",
    state: "État",
    Commands: "Commandes",
    createdAt: "	Créé le",
    pending: "	En attente",
    inProgress: "En cours",
    cancelled: "	Annulé",
    validated: "	Validé",
    active: "Actif",
    inactive: "Inactif",
    note: "Note",
    showArchived: "Afficher les archivés",
    search: "Rechercher par référence ou nom du client",
    showActive: "Afficher les actifs",
    ennote: "Entrer une note pour la commande.",
  },
  product: {
    image: "Image",
    name: "Nom",
    price: "Prix",
    availability: "Disponibilité",
    quantity: "Quantité",
    lastUpdate: "Dernière mise à jour",
    addProduct: "Ajouter un produit",
    editProduct: "Modifier le produit",
    visiblity: "Visibilité",
    tags: "Tags",
    description: "Description",
    coverPicture: "Image de couverture",
    additionalPictures: "Images supplémentaires",
    submit: "Soumettre",
    available: "Disponible",
    unavailable: "Indisponible",
    private: "Privé",
    public: "Public",
    visibility: "Visibilité",
    uploadCoverPicture: "Télécharger une image de couverture",
    modifyCoverPicture: "Modifier  l'image de couverture",
    uploadAdditionalPictures: "Télécharger des images supplémentaires",
    reference: "Référence",
    pictures: "Images",
    Products: "Produits",
    available: "Disponible",
    comingSoon: "Bientôt disponible",
    outOfStock: "En rupture de stock",
    unavailable: "Indisponible",
    reqprice: "Le prix est requis",
    reqavailability: "La disponibilité est requise",
    reqquantity: "La quantité est requise",
    productAdded: "Produit ajouté avec succès",
    impoPubAjout: "Impossible d'ajouter le produit",
    reqname: "Le nom est requis",
    tag: "Entrez des étiquettes ou sélectionnez parmi les existantes",
    ref: "Entrez une référence (optionnelle)",
    currency: "TND",
    search: "Entrez le nom du produit",
    minprice: "Prix minimum",
    maxprice: " Prix maximum",
    noChanges: "Aucun changement détecté",
    productDetails: "Détails du produit",
  },
  menu: {
    marketproducts_list: "Liste des produits",
    marketPlace: "Boutique scolaire",
    powerbi: "powerBI",
    connection: "Utilisateurs",
    statstiqueGeneral: "Statistique générale",
    financialStats: "Statistiques financières",
    accessTeacher: "Accès des enseignants",
    parametrageEtablissement: "Paramétrage de l'établissement",
    printExport: "Impression et Export",
    dataManagement: "Gestion des Données",
    accessManagement: "Gestion des Accès",
    parentLogins: "Logins Parents",
    studentLogins: "Logins Élèves",
    parametrageComptabilite: "Paramétrage de la comptabilité",
    parametrageScolarite: "Paramétrage de la scolarité",
    smartSchedule: "Emploi intelligent",
    teacherAvailability: "Dispo enseignants.",
    calender: "Calendrier",
    cheques: "Les chèques",
    chat: "Chat",
    supervision: "Supervision",
    ptchat: "Chat enseignant et parent",
    logout: "Se déconnecter",
    activites: "Activités",
    etablissement: "Etablissement",
    generale: "Générale",
    accueil: "Accueil",
    parametrage: "Paramétrage",
    actualite: "Actualité",
    administration: "Administration",
    autorisation: "Autorisation",
    utilisateur: "Utilisateur",
    liste: "Liste des élèves",
    cantine: "Menu cantine",
    etatPaiement: "Etat de paiement",
    inscriActiv: "Inscription : Activités",
    emploiActivites: "Emploi : Activités",
    assiduiteActivites: "Assiduité : Activités",
    scolarite: "Scolarité",
    inscriScol: "Inscription : Scolarité",
    etatPaiements: "Etat des paiements",
    listePunition: "Liste des punitions",
    emploi: "Emploi du temps",
    eleves: "Élèves",
    enseignants: "Enseignants",
    bulletin: "Bulletin",
    bulletinCollege: "Bulletin Collège / Lycée",
    bulletinStatistique: "Bulletin statistique",
    notes: "Notes",
    notesModule: "Notes par matière",
    notesParEleve: "Notes par élève",
    notesModuleComplet: "Notes par module",
    personnel: "Personnel",
    listePersonnels: "Liste des personnels",
    listeEnseignants: "Liste des enseignants",
    teacherAttendance: "Assiduité enseignants",
    listeActivites: "Liste des activités",
    virementBancaire: "Virement Bancaire",
    listeEleves: "Liste des élèves",
    comptabilite: "Comptabilité",
    etatRecettes: "Etat des recettes",
    journaleCaisse: "Journal Caisse",
    depenses: "Dépenses",
    nouvelleDepense: "Nouvelle dépense",
    fournisseurs: "Fournisseurs",
    fournisseurProfile: "Fiche fournisseur",
    factures: "Factures",
    saisiePaiement: "Saisie de paiement",
    historiquePaiements: "Historique des paiements",
    encaissementValidation: "Validation de réception",
    reconciliation: "Réconciliation",
    avoirFournisseur: "Avoir fournisseur",
    dettes: "Engagements",
    depensesPersonnel: "Dépenses salariales",
    etatImpayes: "Etat des impayés",
    listeReglement: "Liste des réglements",
    reglementsAnnules: "Réglements annulés",
    etatImpayesActivites: "Etat impayés : Activités",
    etatImpayesScolarite: "Etat impayés : Scolarité",
    declaration: "Déclaration",
    decaissement: "Décaissement",
    declarationTva: "Déclaration TVA",
    chiffreAffaires: "Chiffre d'affaires",
    chiffreAffairesScolarite: "Chiffre d'affaires : Scolarité",
    statistique: "Statistique",
    administration: "Administration",
    actulite: "Actualité",
    sms: "SMS",
    smsAndNotifications: "SMS et Notifications",
    envoyerSms: "Envoyer SMS",
    envoyerSmsLogin: "Connexion parents",
    envoyerParClasseSms: "Envoyer par classe",
    historiqueSms: "Historique",
    caisseAvance: "Caisse avance",
    assiduite: "Assiduités",
    preinscription: "Pré-inscription",
    profile: "Mon Profile",
    certificate: "Certificat",
    degital_library: "Bibliothèque Digital",
    degital_library_list: "Liste des documents",
    finance: "Finance",
    tresorerie: "Trésorerie",
    manageCaisses: "Gestion des caisses",
    myCaisse: "Ma caisse",
    encaissement: "Encaissement",
    chequeEtTraite: "Chèques et traites",
  },
  finance: {
    invoiceBuilder: "Ajouter un paiement",
    legend: "Legende :",
  },
  accueil: {
    title: "Tableau de bord",
    subtitle: "Vue d'ensemble des activités et statistiques de l'école",
    refresh: "Actualiser",
    activite: "Activité",
    activiteSubtitle: "Nombre total d'activités disponibles",
    eleves: "Elèves",
    elevesSubtitle: "Nombre total d'élèves inscrits",
    employees: "Employés",
    employeesSubtitle: "Nombre total d'employés",
    classes: "Classes",
    classesSubtitle: "Nombre total de classes disponibles",
    serviceActiv: "Services / Activités",
    benefice: "Recette totale",
    montant: "Montant",
    pourcentage: "POURCENTAGE",
    depense: "Dépense totale",
    RevenuDep: "Dépenses / Revenu ",
    depenses: "Dépenses",
    revenu: "Revenu",
    tnd: "TND",
    boys: "Garçons",
    girls: "Filles",
    totalBoys: "Total des garçons",
    totalGirls: "Total des filles",
    noDataClasses: "Pas de données pour les classes",
    totalClasses: "Nombre total de classes",
    nombreDeClasses: "Nombre de classes",
    noDataNiveaux: "Pas de données pour les niveaux",
    moreDetails: "Cliquez ici pour plus de détails",
    stat: "Statistiques détaillées",
    deletedClasse: "Classe supprimée",
    dashboard: {
      hello: "Bonjour",
      guest: "Invité",
      subtitleOverview: "Voici un aperçu de votre établissement aujourd'hui.",

      // Accès rapide
      quickCantine: "Cantine",
      quickConsolidation: "Consolidation",
      quickClasses: "Classes",
      quickEmploi: "Emploi du temps",
      quickEleves: "Élèves",
      quickDiscipline: "Discipline",
      quickSupport: "Support",

      // Résumé financier
      financialSummary: "Résumé financier",
      seeDetails: "Voir les détails",
      encaissementDuJour: "Encaissement du jour",
      decaissementDuJour: "Décaissement du jour",
      vsHier: "vs hier",
      soldeNetJour: "Solde net du jour",

      // Tâches critiques
      criticalTasks: "Tâches critiques",
      criticalTasksSubtitle: "Action requise · Votre attention est nécessaire",
      enAttente: "en attente",
      allClear: "Tout est à jour !",
      punitionsPending: "Punitions en attente de validation",
      actualitesPending: "Actualités en attente de validation",
      notificationsUnread: "Notifications non lues",
      messagesUnanswered: "Messages parents non répondus",
      addNews: "Ajouter une actualité",
      newsCtaFirstTitle:
        "Ajoutez votre première actualité et notifiez vos parents",
      newsCtaFirstSubtitle:
        "Partagez les informations importantes de votre établissement en quelques clics.",
      newsCtaTodayTitle:
        "Ajoutez une actualité du jour pour garder vos parents informés",
      newsCtaTodaySubtitle:
        "Aucune actualité n'a été publiée aujourd'hui. Restez connecté avec vos parents.",

      // Alertes / demandes
      pendingRequests: "Demandes en attente",
      enAttenteReponse: "En attente de réponse",
      requestsParents: "Parents",
      requestsEleves: "Élèves",
      requestsPersonnel: "Personnel",

      // Anniversaires
      birthdays: "Anniversaires à venir ce mois",
      searchByName: "Rechercher un nom...",
      staff: "Personnel",
      student: "Élève",
      birthdayToday: "Aujourd'hui",
      birthdayTomorrow: "Demain",
      birthdayInDays: "Dans {days} jours",
      birthdayOnDate: "{date}",
      noBirthdaysToday: "Aucun anniversaire ce mois-ci",

      // Top élèves
      topStudents: "Top 10 des meilleures moyennes",
      moyenne: "Moyenne",
      bulletinPedagogique: "Pédagogique",
      bulletinPilote: "Pilote",
      bulletinSpecifique: "Spécifique",
      noTopStudents: "Aucune moyenne disponible pour ce bulletin",
      accessDenied: "Accès non autorisé",

      // Événements
      upcomingEvents: "Événements à venir",
      seeAllEvents: "Voir tous les événements",
      noUpcomingEvents: "Aucun événement prévu dans les 7 prochains jours",

      // Actualités
      latestNews: "Dernières actualités",
      seeAllNews: "Voir toutes les actualités",
      noNews: "Aucune actualité pour le moment",

      // Salles
      roomsAvailability: "Disponibilité des salles en temps réel",
      free: "Libre",
      occupied: "Occupée",
      noRooms: "Aucune salle configurée",

      // Discipline
      disciplineBreakdown: "Répartition disciplinaire",
      total: "Total",
      cases: "cas",
      noSanctions: "Aucune sanction enregistrée",
    },
  },
  action: {
    impressionReussie: "Impression réussie",
    erreurImpression: "Une erreur est survenue lors de l'impression",
    reinitialiser: "Réinitialiser",
    clone: "Dupliquer",
    cloneSuccess: "Toutes les données ont été dupliqués avec succès",
    refreshPage: "veuillez actualiser la page pour voir l'effet complet",
    reset: "Réinitialiser",
    imprimerTab: "Imprimer le tableau",
    imprimerFreresSoeurs: "Imprimer la liste des frères et sœurs",
    imprimerBadges: "Imprimer les badges",
    imprimerNewBadges: "Imprimer les badges avec photo",
    simpleBadge: "Badge simple",
    badgeAvecPhoto: "Badge avec photo",
    actions: "Actions",
    operation: "Opération",
    supprimer: "Supprimer",
    ajouter: "Ajouter",
    modifier: "Modifier",
    consulter: "Consulter",
    annuler: "Annuler",
    enregistrer: "Enregistrer",
    afficher: "Afficher",
    voir: "Voir",
    desactiver: "Désactiver",
    activer: "Activer",
    imprimer: "Imprimer",
    confirmer: "Confirmer",
    changer: "Changer",
    importer: "Importer",
    preview: "Aperçu",
    revoke: "Révoquer",
    retour: "Retour",
    refresh: "Actualiser",
    retry: "Réessayer",
    selectAll: "Sélectionner tout",
    bulkEdit: "Modifier en lot",
    saveAll: "Enregistrer tout",
    applySameReduction:
      "Appliquer la même réduction pour toutes les lignes sélectionnées",
    selected: "sélectionné(s)",
    editing: "En cours de modification",
    fullyPaid: "Entièrement payé",
    imprimerHistorique: "Imprimer historique",
    genererPdfHistorique: "Générer PDF",
    pdfGenereAvecSucces: "PDF généré avec succès",
    succes: "Succès",
    upload: "Télécharger",
    search: "Rechercher",
    fermer: "Fermer",
    status: "Statut",
    suivant: "Suivant",
  },
  common: {
    loading: "Chargement des statistiques...",
    selected: "sélectionné(s)",
    editing: "En cours de modification",
  },
  message: {
    noSelection: "Aucune sélection trouvée",
    noValidUpdates: "Aucune mise à jour valide trouvée",
    bulkUpdateSuccess: "{count} réductions mises à jour avec succès",
    bulkUpdateError: "Erreur lors de la mise à jour en lot",
    enterReductionValue: "Veuillez saisir une valeur de réduction",
    paymentDataNotFound: "Données de paiement introuvables",
    loadingBulletin: "Veillez patientez...",
  },
  confirmation: {
    revokeAccess: "Confirmez-vous la révocation de l'accès ?",
    revokeAccessSaved: "L'accès a été révoqué avec succès",
    solveTheConflictError: "Résoudre le conflit d'accès",
  },
  sms: {
    smsSentSuccess: "SMS envoyé avec succès",
    selectionner: "Sélectionner",
    corriger: "Corriger",
    paymentRappel: "Rappel de paiement",
    deatilsAutoSmsTitle: "Détails des messages SMS automatiques",
    seeProfile: "Voir le profil",
    newPayment: "Nouveau paiement",
    newInscription: "Nouvelle inscription",
    newAbsence: "Absence/retard",
    newCourse: "Cours/Exercice",
    bulletinDispo: "Bulletin disponible",
    actualite: "Actualité",
    autoSms: "Paramètres de SMS automatiques",
    autoPn: "Paramètres de notification mobile",
    votreSolde: "VOTRE SOLDE",
    nbrSmsRestant: "Nombre d'SMS restant",
    paymentTemplate1:
      "Vous avez payé {montant payé} TND les frais du \"{Nom de l'activité}\" pour {Nom de l'éléve}. Ce paiement est pour la période {liste des mois}.",
    paymentTemplate2:
      "Vous avez payé {montant payé} TND les frais de la scolarité pour {Nom de l'éléve}. Ce paiement est pour la période {liste des mois}.",
    inscriptionTemplate1:
      "Votre enfant {nom de l'élève} a été inscrit avec succès dans {nom de l'activité}.",
    inscriptionTemplate2:
      "Votre enfant {nom de l'élève} a été inscrit avec succès dans la classe {nom de la classe}.",
    absenceTemplate1:
      'Votre enfant {nom de l\'élève} était absent le {date} à {temps} durant la séance de "{nom de la séance}"',
    absenceTemplate2:
      'Votre enfant {nom de l\'élève} est arrivé(e) en retard le {date} à {temps} durant la séance de "{nom de la séance}"',
    courseTemplate1:
      "Un nouveau cours a été ajouté pour votre enfant avec le titre : {titre}.",
    courseTemplate2:
      "Un nouveau exercice a été ajouté pour votre enfant avec le titre : {titre}.",
    bulletinTemplate:
      "Le bulletin {pédagogique/pilote/spécifique} de {nom de l'élève} pour le trimestre {trimestre} est disponible sur EdParent.",
    actualiteTemplate:
      "Une nouvelle actualité a été ajoutée sur Edparent avec le titre : {titre}.",
    nomlExpediteur: "NOM DE L'EXPÉDITEUR",
    desclExpediteur: "Les SMS sont envoyés en tant que",
    gererListeDistinateurs: "GÉRER LA LISTE DES DESTINATEURS",
    envoyerDesSms: "ENVOYER DES SMS",
    listeVosEleves: "Liste de vos élèves",
    listeClasses: "Liste des classes",
    selectionnerEleves: "Sélectionner des élèves",
    selectionnerClases: "Sélectionner des classes",
    pressEnterToSelect: "Appuyez sur Entrée pour sélectionner",
    pressEnterToRemove: "Appuyez sur Entrée pour supprimer",
    selected: "Sélectionné",
    maxClassesReached: "Vous pouvez choisir 4 classes maximum",
    entrerNumerosSpecifiques: "Entrer des numéros spécifiques",
    entrerNumerosSpecifiquesDesc:
      "Les numéros de téléphone doit être séparés par des virgules",
    categorieTag: "Catégorie/tag",
    categorieTagDesc: "Les tags vous aide à bien organiser vos messages",
    saisirCategorieTag: "Saisir des catégories/tags",
    contenueVotreMessage: "Saisir la contenue de votre message",
    contenueMessage: "Saisir le contenu de l'SMS",
    listeFinale: "LISTE FINALE",
    nombreSms: "Nombre des Sms",
    nombreMessage: "Nombre de messages",
    nomberTotal: "Nombre total",
    nombreMessageParCategorie: "Nombre des messages par catégorie",
    nombreCaracteres: "NOMBRE DES CARACTÈRES",
    pere: "Père",
    mere: "Mère",
    guardian: "Tuteur",
    specifique: "Spécifique",
    destinataire: "Destinataire",
    telephone: "Téléphone",
    parents: "parents",
    personnel: "personnel",
    sanction: "sanction",
    bulletin: "bulletin",
    envoyer: "Envoyer",
    nonInscrit: "Non inscrit",
    noOptions: "La liste est vide",
    jours: "Jours",
    boiteEnvoieSms: "Boite d'envoie des SMS",
    message: "Message",
    numsSpecifiques: "Numéros spécifiques",
    listeParents: "Liste des parents",
    envoyeParUser: "Envoyé par l'utilisateur",
    groupe: "Groupe",
    tags: "Tags",
    envoiDate: "Date envoyée",
    selectAll: "Sélectionner tous",
    selectAllTeachers: "Sélectionner tous les enseignants",
    selectAllStudents: "Sélectionner tous les élèves",
    noValidParentsInformation:
      "Aucune information valide pour les parents de l'élève:",
    noValidParentInformation:
      "Aucune information valide pour le {parent} de l'élève:",
    noAccount: "Pas de compte pour le {parent} de l'élève:",
    envoyerDesSmsLogins: "ENVOYER DES SMS DES LOGINS",
    alertNumberSMS:
      "Si le nom d'utilisateur et le mot de passe sont longue (dépasse 66 caractères arabe ou 156 français ) le nombre d'SMS pour un parent peut consommer 2 SMS du solde",
    envoyerDesLoginsParents: "Envoyer des logins parents",
    calculerNombreSms: "Calculer le nombre d'SMS...",
    totalSms: "Totale des sms : ",
    boiteEnvoie: "Boite d'envoi",
    nomUtilisateur: "Nom d'utilisateur",
    nombreSmsEnvoye: "Nombre d'SMS envoyé",
    date: "Date",
    noRecipients:
      "Veuillez sélectionner au moins un destinataire pour envoyer le SMS.",
    confirmSendTitle: "Confirmation d'envoi SMS",
    invalidPhones: "invalide(s)",
    duplicatePhones: "doublon(s)",
    duplicateTag: "Doublon",
    noValidNumbers: "Aucun numéro valide",
    confirmTotalLabel: "Nombre d'SMS qui seront envoyés",
  },
  mobileNotifications: {
    title: "Notifications mobiles",
    detailsTitle: "Détails des notifications mobiles automatiques",
    enablePaymentReminder: "Activer les rappels de paiement",
    recurringFrequency: "Fréquence de récurrence",
    weekly: "Hebdomadaire",
    monthly: "Mensuel",
    dayOfWeek: "Jour de la semaine",
    dayOfMonth: "Jour du mois",
    time: "Heure",
    selectDays: "Sélectionner les jours",
    paymentReminderTitle: "Rappel de paiement",
    paymentReminderClassroom: "Rappel de paiement - Scolarité",
    paymentReminderActivity: "Rappel de paiement - Activités",
    notificationTitle: "Titre",
    // Monthly payment messages (matching Lambda function)
    messageClassroomMonthly:
      "Rappel: Merci de régler les frais de scolarité du mois de {month}. Veuillez consulter l'application pour plus de détails.",
    messageActivityMonthly:
      "Rappel: Merci de régler les frais d'activités du mois de {month}. Veuillez consulter l'application pour plus de détails.",
    // Tranche payment messages (matching Lambda function)
    messageClassroomTranche:
      "Rappel: Merci de régler les frais de scolarité de la tranche actuellement due. Veuillez consulter l'application pour plus de détails.",
    messageActivityTranche:
      "Rappel: Merci de régler les frais d'activités de la tranche actuellement due. Veuillez consulter l'application pour plus de détails.",
    sendNow: "Envoyer maintenant",
    sendNotificationSuccess:
      "Notification de rappel de paiement envoyée avec succès",
    sendNowConfirmTitle: "Envoyer la notification maintenant ?",
    sendNowConfirmMessage:
      "Êtes-vous sûr de vouloir envoyer les notifications de rappel de paiement à tous les parents avec des paiements impayés maintenant ?",
    timeRequired: "L'heure est requise lorsque les notifications sont activées",
    dayOfWeekRequired:
      "Au moins un jour de la semaine est requis pour la fréquence hebdomadaire",
    dayOfMonthRequired:
      "Au moins un jour du mois est requis pour la fréquence mensuelle",
  },
  notificationConfig: {
    title: "Configuration des notifications",
    sendPaymentValidationNotification:
      "Envoyer une notification aux parents lorsqu'un paiement est validé",
  },
  library: {
    yes: "Oui",
    no: "Non",
    createdBy: "Créé par",
    ajouterDocument: "Ajouter un document",
    editDocument: "Modifier un document",
    titre: "Titre",
    subject: "Matière",
    grade: "Niveau",
    search: "Recherche",
    submit: "Soumettre",
    contentType: "Type de contenu",
    text: "Texte",
    video: "Vidéo",
    attachment: "Pièce jointe",
    createdAt: "Créé à",
    lastUpdate: "Dernière mise à jour",
    uploadAttachment: "Télécharger une pièce jointe",
    uploadVideo: "Télécharger une vidéo",
    uploadText: "Télécharger un texte",
    visibility: "Visibilité",
    public: "Public",
    private: "Privé",
    shared: "Partagé",
    add: "Ajouter",
    document: "Document",
    documents: "Documents",
    levelRequired: "Le niveau est requis",
    select: "Sélectionner un",
    docRequired: "Vous devez télécharger des documents",
    maxDocs: "Vous ne pouvez pas télécharger plus de 15 fichiers",
    ressources: "Ressources",
    search: "Saisir le titre à rechercher",
    fileName: "Nom du fichier",
    fileUploadError:
      "Vous ne pouvez télécharger que des fichiers JPG, JPEG ou PNG !",
    added: "Ajouté",
    deleted: "Supprimé",
    updated: "Mis à jour",
  },
  subject: {
    subject1: "Langue Arabe",
    subject2: "Langue Française",
    subject3: "Mathématiques",
    subject4: "Sciences Naturelles",
    subject5: "Histoire",
    subject6: "Géographie",
    subject7: "Éducation Civique",
    subject8: "Éducation Artistique",
    subject9: "Éducation Physique et Sportive",
    subject10: "Informatique",
    subject11: "Langue Anglaise",
    subject12: "Langue Vivante",
    subject13: "Physique-Chimie",
    subject14: "Sciences de la Vie et de la Terre",
    subject15: "Technologie",
    subject16: "Philosophie",
  },
  actualite: {
    ajouterAlbum: "Ajouter un album",
    ajouterActualite: "Ajouter une actualité",
    modifierAlbum: "Modifier un album",
    modifierActualite: "Modifier une actualité",
    album: "Album",
    date: "Date de sortie",
    seenAtLabel: "Vu le",

    tousClasses: "Toutes les classes",
    titre: "Titre",
    categorie: "Catégorie",
    customCategory: "Catégorie personnalisée",
    customCategoryPlaceholder: "Saisir une catégorie personnalisée",
    categoryInfo: "Information",
    categoryImportantInfo: "Information importante",
    categoryUrgent: "Urgent",
    categoryAvisImportant: "Avis important",
    categoryAvis: "Avis",
    categoryImportant: "Important",
    categoryOther: "Autre",
    cibles: "Cibles",
    jaimes: "J'aimes",
    photos: "Photos",
    dateCreation: "Date de création",
    tous: "Tous",
    enseignants: "Enseignants",
    eleves: "Elèves",
    teachers: "Enseignants",
    students: "Elèves",
    administration: "Administration",
    parents: "Parents",
    cliquer:
      "Cliquez ou faites glisser le fichier vers la zone pour le télécharger",
    support:
      "Prise en charge d'un téléchargement unique ou groupé. Interdire strictement de télécharger des données d'entreprise ou d'autres fichiers de groupe",
    description: "Description",
    ajouterPub: "Ajouter une publication",
    trimestre1: "Triméstre 1",
    trimestre2: "Triméstre 2",
    trimestre3: "Triméstre 3",
    trimester_one: "Trimestre d'origine",
    trimester_two: "Trimestre destination",
    retour: "Retour",
    pasImages: "Pas d'images",
    mentionJaimes: "Mentions de j'aime",
    seenByParentsNewsTitle: "Parents ayant consulté cette actualité",
    notSeenByParentsNewsTitle: "Parents n'ayant pas consulté cette actualité",
    seenNotSeenParentsTitle: "Vu / Non vu par les parents",
    seenNotSeenParentsLabel: "Vu et non vu par les parents",
    seenTrackedOnlyForParents:
      "Les vues ne sont suivies que pour les actualités destinées aux parents.",
    noParentSeenNews: "Aucun parent n'a encore consulté cette actualité.",
    allParentsSeenNews: "Tous les parents ciblés ont consulté cette actualité.",
    seenCountLabel: "Vu ({count})",
    notSeenLabel: "Non vu",
    notSeenCountLabel: "Non vu ({count})",
    modifierImages: "Modifier les images",
    specificFor: "Spécifique pour",
    levels: "Niveaux",
    classrooms: "Classes",
    students: "Élèves",
    activities: "Activités",
    selectActivities: "Sélectionner des activités",
    activitiesRequired: "Les activités sont requises",
    specified: "Spécifié",
    specifiedInfo:
      "Les filtres d'envoie s'appliqueront seulement pour les parents",
    studentSpecifiedInfo:
      "Les filtres d'envoie s'appliqueront seulement pour les élèves",
    teacherSpecifiedInfo:
      "Les filtres d'envoie s'appliqueront seulement pour les enseignants",
    selectionnerEnseignants: "Sélectionner des enseignants",
    files: "Fichiers",
    noFiles: "Aucun fichier trouvé",
    details: "Détails de l'actualité",
    aucuneActualite: "Aucune actualité publiée",
    enableComments: "Activer les commentaires",
    commentsEnabled:
      "Les commentaires peuvent être activés ou désactivés pour chaque actualité séparément",
    commentsDisabled:
      "Les commentaires sont désactivés pour toutes les actualités",
    videoProcessing: "Traitement de la vidéo en cours...",
    videoError: "Erreur lors du traitement de la vidéo",
    videoNotReady: "La vidéo n'est pas encore prête",
    videoLoading: "Chargement de la vidéo...",
    videoNotSupported:
      "Votre navigateur ne prend pas en charge la lecture de cette vidéo",
    videoTagNotSupported:
      "Votre navigateur ne prend pas en charge la balise vidéo.",
    videoPlaybackError: "Erreur lors de la lecture de la vidéo",
    videoQualityAuto: "Auto",
    videoQuality: "Qualité",
    enableCommentsForThisNews: "Activer les commentaires pour cette actualité",
    enableCommentsForThisNewsDesc:
      "Permettre aux utilisateurs de commenter cette actualité",
    searchAndFilters: "Recherche et Filtres",
    total: "Total",
    actualitesPlural: "actualités",
    clearFilters: "Effacer les filtres",
    searchByTitle: "Rechercher par titre",
    filterByCategory: "Filtrer par catégorie",
    actualiteLabel: "Actualité",
    filterByCreationDate: "Filtrer par date de création",
    filterByTarget: "Filtrer par cible",
    search: "Rechercher",
    parentLabel: "Parent :",
    videos: "Vidéos",
    uploadVideo:
      "Cliquez ou faites glisser les fichiers vidéo ici pour les télécharger",
    videoSupport: "Prise en charge des formats vidéo MP4, MOV, AVI, MKV",
    pendingValidation: "En attente de validation",
    validated: "Validée",
    approve: "Approuver",
    reject: "Rejeter",
    rejected: "Rejetée",
    confirmReject: "Êtes-vous sûr de vouloir rejeter cette actualité ?",
    newsValidated: "Actualité approuvée avec succès",
    newsRejected: "Actualité rejetée avec succès",
    createdByTeacher: "Créée par l'enseignant",
    createdByLabel: "Créée par",
    statusLabel: "Statut",
    validation: "Validation",
    validatedLabel: "Validée",
    teacher: "Enseignant",
    admin: "Administrateur",
    filterByValidation: "Filtrer par statut",
    allNews: "Toutes",
    pendingOnly: "En attente",
    validatedOnly: "Validées",
    rejectedOnly: "Rejetées",
    seeMore: "Voir plus",
    seeLess: "Voir moins",
    like: "J'aime",
    liked: "Aimé",
    commentBtn: "Commenter",
    writeCommentPlaceholder: "Écrire un commentaire...",
    commentsCountLabel: "{count} commentaires",
    noLikesYet: "Soyez le premier à aimer cette publication",
    noCommentsYet: "Aucun commentaire pour le moment",
    postOptions: "Options",
    composerPrompt1: "Quoi de neuf à l'école aujourd'hui ?",
    composerPrompt2: "Partagez l'actualité du jour avec toute la communauté…",
    composerPrompt3: "Annoncez un événement, célébrez une réussite, informez en un clic.",
    composerPrompt4: "Une idée, une info importante, une belle nouvelle à transmettre ?",
    composerPrompt5: "Inspirez parents, élèves et équipe — commencez votre publication ici.",
    emojiPickerLabel: "Ajouter un emoji",
    sendCommentLabel: "Envoyer le commentaire",
  },
  activityClub: {
    confirmDeletePost:
      "Êtes-vous sûr de vouloir supprimer cette activité / club ?",
    tabNews: "Actualités & Albums",
    tabClub: "Activité / Club",
    addPost: "Ajouter une activité / club",
    editPost: "Modifier l'activité / club",
    noPosts: "Aucune activité / club publiée",
    searchByTitle: "Rechercher par titre",
    activity: "Activité / Club",
    other: "Autre",
    customActivityName: "Nom du club",
    price: "Prix",
    registrationStartDate: "Date début d'inscription",
    clubStartDate: "Date début du club",
    clubEndDate: "Date fin du club",
    maxPlaces: "Places max",
    maxPlacesOptional: "Laisser vide pour illimité",
    unlimited: "Illimité",
    coverImage: "Image de couverture",
    attachments: "Pièces jointes",
    pending: "En attente",
    accepted: "Accepté",
    rejected: "Rejeté",
    subscribers: "Inscrits",
    views: "Vues",
    searchByName: "Rechercher par nom",
    allStatuses: "Tous les statuts",
    parentName: "Parent",
    studentName: "Élève",
    status: "Statut",
    subscribedAt: "Inscrit le",
    accept: "Accepter",
    reject: "Rejeter",
    register: "S'inscrire",
    joinSuccess: "Votre demande a été envoyée",
    registrationStartsOn: "Les inscriptions commencent le {date}",
    status_pending: "En attente",
    status_accepted: "Accepté",
    status_rejected: "Rejeté",
    enableComments: "Activer les commentaires",
    commentsEnabled:
      "Les commentaires peuvent être activés ou désactivés pour chaque publication activité / club",
    commentsDisabled:
      "Les commentaires sont désactivés pour toutes les publications activité / club",
    enableCommentsForThisPost:
      "Activer les commentaires pour cette publication",
    enableCommentsForThisPostDesc:
      "Permettre aux utilisateurs de commenter cette publication activité / club",
    composerPrompt1: "Partagez une nouvelle activité ou un club…",
    composerPrompt2: "Annoncez une inscription ouverte…",
    composerPrompt3: "Publiez les infos du prochain club…",
  },
  etablissement: {
    reductionType: "Type de réduction",
    pourcentage: "Pourcentage",
    dinar: "Dinar",
    shilling: "Shilling",
    currency: "Devise",
    TND: "Dinar tunisien (TND)",
    KES: "Shilling kenyan (KES)",
    currencyRequired: "La devise est requise",
    access: "Accès",
    editAccess: "Modifier l'accès",
    accessUpdated: "L'accès a été modifié avec succès",
    editingAccess: "Modification de l'accès",
    config: "Configurations",
    editConfig: "Modifier la configuration",
    editBuilding: "Modifier l'établissement",
    accessConfig: "la configuration a été modifié avec succès",
    editingConfig: "Modification de la configuration",
    alertDisableChat:
      "Activer ou désactiver le chat entre les parents et les enseignants (si désactivé, les enseignants et les parents perdront instantanément l'accès au chat dans les applications mobiles et Web)",
    alertDisableTeacherParentGroupChat:
      "Activer ou désactiver les groupes de chat enseignant-parent (si désactivés, les groupes existants restent visibles mais en lecture seule pour les enseignants et les parents).",
    teacherParentGroupChat: "Groupes de chat enseignant-parent",
    alertRequirePunishmentValidation:
      "Si activé, les punitions ajoutées par l'administration restent en attente jusqu'à validation par un administrateur. Si désactivé (par défaut), elles sont validées automatiquement dès leur ajout.",
    requirePunishmentValidation:
      "Exiger la validation des punitions ajoutées par l'administration",
    alertTeacherAttendanceEnabled:
      "Activer ou désactiver le module Assiduité enseignants (pointage séance, journalier, rapports et attendu vs réel). Si désactivé, le menu est masqué et les API sont bloquées.",
    teacherAttendanceEnabled: "Activer l'assiduité enseignants",
    alertRequireTeacherAttendanceValidation:
      "Si activé, les pointages restent en attente jusqu'à validation par un responsable. Si désactivé (par défaut), les pointages sont définitifs immédiatement — les modes séance / journalier existants ne changent pas.",
    requireTeacherAttendanceValidation:
      "Exiger la validation de l'assiduité enseignants/personnel (hiérarchie)",
    etablissements: "Etablissements",
    classe: "Classe",
    classes: "Classes",
    niveaux: "Niveaux",
    ajouterNiveau: "Ajouter un niveau",
    createAllLevels: "Créer tous les niveaux",
    niveauxHint:
      "Définissez les frais par niveau. Les classes héritent automatiquement des frais de leur niveau.",
    levelRequiredFirst:
      "Ce niveau doit d'abord être créé dans l'onglet Niveaux avant d'ajouter une classe.",
    niveauAffectation: "Niveau (affectation)",
    elevesAffectes: "Élèves affectés",
    salles: "Salles",
    services: "Services",
    activites: "Activités",
    typeQualification: "Type Qualifications",
    anneeScolaire: "Année Scolaire",
    logo: "Logo",
    name: "Nom",
    nom: "Nom",
    headMaster: "Directeur/Directrice",
    dateEnregistrement: "Date d'enregistrement",
    createdAt: "Date d'enregistrement",
    phone: "Téléphone",
    mainPhone: "Téléphone principal",
    email: "Email",
    mainEmail: "Email principal",
    additionalEmails: "Emails supplémentaires",
    addEmail: "Ajouter un email",
    additionalPhones: "Téléphones supplémentaires",
    addPhone: "Ajouter un téléphone",
    kenyaPhoneRequirement:
      "Au moins 2 numéros de téléphone supplémentaires requis",
    MF: "Matricule Fiscal",
    schoolNEMISNumber: "Numéro NEMIS de l'école",
    RIB: "RIB",
    adress: "Adresse",
    geoLat: "Latitude (GPS)",
    geoLng: "Longitude (GPS)",
    geoRadius: "Rayon (mètres)",
    geoHint:
      "Coordonnées de l'établissement pour le pointage enseignants (hors site si hors rayon).",
    postalAddress: "Adresse postale",
    type: "Type",
    niveau: "Niveau",
    fraisInscri: "Frais d'inscription",
    fraisMensuel: "Frais mensuels",
    fraisParJour: "Frais par jour",
    typeActivite: "Type d'activité",
    nameActivite: "Désignation",
    parJour: "Par jour",
    mensuelleParTranche: "Mensuelle/par tranche",
    emploi: "Emploi",
    dateCreation: "Date de création",
    capacite: "Capacité",
    fournisseurs: "Les fournisseurs",
    fournisseur: "Fournisseur",
    fournisseurNonRequis: "Fournisseur (non requis) :",
    service: "Service",
    designation: "Désignation",
    legalName: "Nom légal",
    responsable: "Responsable",
    responsableActivite: "Responsable de l'activité",
    ordrePriorite: "Ordre/priorité",
    order: "Order",
    dateDebut: "Date de début",
    dateFin: "Date de fin",
    seuleFois: "Une seul fois",
    entrerInfo: "Entrez les informations dans les champs ci-dessous",
    modifierEmploi: "Modifier l'emploi pour {name}",
    other: "Autre",
    editAlert:
      "La modification de l'année scolaire n'engendre pas une modification sur les mois d'inscription des élèves déjà inscrits, vos étes sûrs de modifier ?",
    clickOrDragToUpload:
      "Cliquez ou faites glisser un fichier dans cette zone pour le télécharger",
    clickForUploadLogo: "Clicker pour modifier le logo",
    ecole: "École primaire",
    college: "Collége",
    lycee: "Lycée",
    collegeEtLycee: "Collége & Lycée",
    primaireEtCollege: "Primaire & Collége",
    jardinEnfant: "Jardin d'enfant",
    preSchool: "Préscolaire",
    prePrimary: "Pré-primaire",
    middle: "École moyenne",
    junior: "Secondaire inférieur",
    senior: "Secondaire supérieur",
    cache: "Caché",
    choisir: "Choisir",
    matriculeFiscale: "Matricule fiscale",
    ArabicName: "Nom en Arabe",
    delegeRegional: "Délégué régional",
    countyLocation: "Localisation du pays",
    slogan: "Slogan",
    nameRequired: "Le nom est requis",
    arabicNameRequired: "Le nom arabe est requis",
    legalNameRequired: "Le nom légal est requis",
    delegeRegionalRequired: "La délégation régionale est requise",
    countyLocationRequired: "La localisation du pays est requise",
    headMasterRequired: "Le directeur est requis",
    headMasterFrench: "Directeur/Directrice en français",
    headMasterGender: "Genre du directeur",
    additionalDirectors: "Directeurs supplémentaires",
    directorName: "Nom du directeur",
    addDirector: "Ajouter un directeur",
    male: "Homme",
    female: "Femme",
    phoneRequired: "Le téléphone est requis",
    showFeesParentPayment: "Afficher les frais de paiement aux parents",
    showInvoicesParentPayment:
      "Afficher l'historique des paiements aux parents (factures/recus)",
    alertShowFeesParentPayment:
      "Si activé, les parents pourront voir les frais de paiement dans l'application mobile",
    alertShowInvoicesParentPayment:
      "Si activé, les parents pourront voir les factures et les recus de paiement dans l'application mobile",
    rib20Digits: "Le RIB doit contenir exactement 20 chiffres",
    tranches: "Tranches",
    fraisMensuelle: "Frais mensuelle",
    addTranche: "Ajouter une tranche",
    tranche: "Tranche",
    verifierTranches: "Vérifier les frais des tranches",
    establishmentCode:  "code de l'établissement",
  },
  comptabilite: {
    comptabilite: "Comptabilité",
    fournisseur: "Fournisseur",
    typeDepense: "Type Dépense",
    tabDepenseTypes: "Types de dépense",
    tabDepenseCategories: "Catégories",
    tabDepenseSubcategories: "Sous-catégories",
    tabAssociates: "Associés",
    tabUnites: "Unités",
    tabCompanies: "Sociétés",
    companyLegalName: "Raison sociale",
    companyCode: "Code",
    companyArchiveConfirm: "Archiver cette société ?",
    companyArchived: "Société archivée",
    tabDebiteurs: "Débiteurs",
    tabDocumentDisplay: "Affichage reçus / factures",
    documentDisplayIntro:
      "Configurez l'affichage des reçus et des factures pour cet établissement. Les options non configurées conservent le comportement par défaut.",
    documentDisplayHeader: "En-tête",
    documentDisplayFooter: "Pied de page",
    documentDisplayPayment: "Paiement et réductions",
    documentDisplayPrint: "Impression",
    documentDisplayPreview: "Prévisualisation",
    previewDocument: "Prévisualiser",
    previewHint: "Cliquez sur Prévisualiser pour voir le rendu avec les options actuelles (non enregistrées).",
    showLogo: "Afficher le logo",
    titleMode: "Titre de l'établissement",
    titleModeDefault: "Titre par défaut",
    titleModeCustom: "Titre personnalisé",
    customTitle: "Titre personnalisé",
    includeSchoolTypeInTitle: "Inclure le type d'école dans le titre",
    showClass: "Afficher la classe",
    showFooterText: "Afficher un texte personnalisé en bas",
    footerText: "Texte personnalisé",
    showCachetSignatureLabel:
      "Afficher « Cachet et signature » (masqué si le cachet image est affiché)",
    showStamp: "Afficher le cachet (image)",
    stampScale: "Taille du cachet",
    stampScaleHint:
      "Ajuste la taille de l'image du cachet sur le PDF (de 0,5x a 2,5x).",
    showSignature: "Afficher la zone signature",
    showTuitionSummary: "Afficher le résumé de paiement scolarité",
    showActivitySummary: "Afficher le résumé de paiement activités",
    paymentSummaryHint:
      "Total à payer, mois / tranches payés (débit) et impayés (crédit) de l'année scolaire.",
    showTableNote: "Afficher un texte personnalisé sous les tableaux",
    tableNoteHint:
      "Texte affiché tel quel dans l'espace blanc juste sous les tableaux de paiement / résumé (pas dans le pied de page).",
    tableNoteText: "Texte personnalisé",
    tableNoteColor: "Couleur du texte",
    tableNoteFontSize: "Taille du texte",
    tableNoteAlign: "Position du texte",
    tableNoteAlignAuto: "Automatique (selon la langue)",
    tableNoteAlignLeft: "Gauche",
    tableNoteAlignCenter: "Centre",
    tableNoteAlignRight: "Droite",
    showPaymentMethodDetails: "Afficher le détail des moyens de paiement",
    showOnTransReduction: "Afficher la remise sur le total",
    baseReductionDisplay: "Affichage des réductions de base",
    baseReductionHidden: "Ne pas afficher",
    baseReductionTotal: "Afficher le total des réductions",
    baseReductionPercentPerLine: "Afficher le % par élément",
    copiesPerPage: "Format d'impression",
    copiesPerPage1: "1 reçu / facture par page (portrait)",
    copiesPerPage2:
      "2 copies sur une page paysage (même document à gauche et à droite)",
    autoPrint: "Impression automatique du reçu après paiement",
    documentDisplayFiscal: "Fiscalité (facture)",
    tvaApplicable: "TVA applicable",
    showTva: "Afficher la TVA sur la facture",
    tvaRate: "Taux de TVA (fraction)",
    tvaRateHint:
      "Exemple : 0.07 pour 7 %. Laisser vide pour utiliser la valeur d'environnement par défaut.",
    timbreApplicable: "Timbre fiscal applicable",
    showTimbre: "Afficher le timbre sur la facture",
    timbreAmount: "Montant du timbre fiscal",
    timbreAmountHint:
      "Laisser vide pour utiliser la valeur d'environnement par défaut.",
    retenueApplicable: "Retenue à la source applicable",
    showRetenue: "Afficher la retenue sur la facture",
    retenuePercent: "Retenue à la source (%)",
    retenuePercentHint:
      "Pourcentage du TTC (même logique que la retenue fournisseur).",
    documentNumbering: "Numérotation du document",
    numberFormatCustom: "Format personnalisé",
    numberFormatCustomHint:
      "Désactivé = format actuel (YYYYMM + 3 chiffres, ex. 202609001). Activé = préfixe / date / séquence configurables, indépendamment pour reçus et factures.",
    numberFormatPrefix: "Préfixe",
    numberFormatDatePattern: "Format de date",
    numberFormatDateNone: "Sans date",
    numberFormatSeparator: "Séparateur",
    numberFormatPadding: "Chiffres de la séquence",
    numberFormatPattern: "Motif libre (optionnel)",
    numberFormatPatternHint:
      "Tokens : {PREFIX} {YYYY} {YY} {MM} {DD} {YYYYMM} {SEQ}. Si le champ est VIDE, le numéro est construit avec préfixe + date + séparateur + séquence. Le texte grisé dans le champ n'est qu'un exemple (placeholder), pas une valeur enregistrée — utilisez les boutons ci-dessous pour appliquer un motif.",
    numberFormatExample: "Prochains numéros : {example}",
    numberFormatStartNumber: "Numéro de départ",
    numberFormatStartNumberHint:
      "Pour continuer une numérotation existante (ex. dernière facture FACT-2026-000598 → saisir 599). Le format et le remplissage de zéros sont respectés. Si des documents existent déjà au-delà de ce numéro, la séquence continue après le dernier, sans doublon.",
    numberFormatTabReceipt:
      "Numérotation des REÇUS uniquement. Passez à l'onglet Facture pour configurer les factures.",
    numberFormatTabInvoice:
      "Numérotation des FACTURES uniquement. Passez à l'onglet Reçu pour configurer les reçus.",
    numberFormatSeparatorHint:
      "Utilisé seulement si le motif libre est vide. Laissez vide pour coller préfixe+date+séquence (ex. ZOUI26001).",
    numberFormatPatternPlaceholder:
      "Vide = utiliser préfixe / date / séparateur ci-dessus",
    numberFormatPresetParts: "Utiliser préfixe + date",
    numberFormatPresetYyyy: "Appliquer {PREFIX}-{YYYY}-{SEQ}",
    numberFormatPresetYyyymm: "Appliquer {PREFIX}-{YYYYMM}-{SEQ}",
    numberFormatSeqRequired:
      "Le motif doit contenir {SEQ} pour que chaque document ait un numéro unique. Il sera ajouté automatiquement à l'enregistrement (ex. …-{SEQ}).",
    numberFormatUnsafeChars:
      "Les caractères / \\ : * ? \" < > | ne peuvent pas figurer dans un nom de fichier PDF : ils seront remplacés par « - » (ex. ZOUI/x → ZOUI-x).",
    reference: "Référence",
    expenseKind: "Type",
    expenseKindOpex: "OPEX",
    expenseKindCapex: "CAPEX (Amortissement)",
    expenseKindOther: "Autre",
    capexFormula: "Formule d'amortissement",
    description: "Description",
    category: "Catégorie",
    categoryDeactivatedCascade:
      "Catégorie archivée. {subcategories} sous-catégories liées ont également été passées en inactif.",
    categoryDeactivateConfirm:
      "Archiver cette catégorie ? Toutes les sous-catégories actives rattachées le seront aussi (inactif).",
    subcategory: "Sous-catégorie",
    parentSubcategory: "Sous-catégorie supplémentaire",
    direction: "Direction",
    directionNormal: "Normal",
    directionInverse: "Inverse",
    visibility: "Visibilité",
    visibilityHint: "Personnes ou rôles concernés (texte libre)",
    associateType: "Type d'associé",
    associateInternal: "Interne",
    associateExternal: "Externe",
    fullName: "Nom et prénom",
    unitKind: "Type d'unité",
    unitPrincipal: "Principal",
    unitSecondary: "Secondaire",
    companyName: "Raison sociale",
    debtorName: "Nom du débiteur",
    depenseTypeDeactivatedCascade:
      "Type de dépense archivé. {categories} catégories et {subcategories} sous-catégories ont également été passées en inactif.",
    depenseTypeDeactivateConfirm:
      "Archiver ce type de dépense ? Toutes les catégories actives et leurs sous-catégories rattachées le seront aussi (inactif).",
    deleteAllowed: "Supprimer",
    optional: "(optionnel)",
    typeRecette: "Type Recette",
    nom: "Nom",
    adresse: "Adresse",
    telephone: "Téléphone",
    email: "E-mail",
    codeTVA: "Code TVA",
    depenseParametrageNotice:
      "Utilisez Supprimer pour archiver un élément (statut inactif). Il disparaît de ces listes ; les données sont conservées pour la traçabilité.",
    noDeleteHint:
      "Supprimer archive la ligne (inactif) ; elle n'apparaît plus dans cette liste.",
    planComptable: "Plan comptable",
    accountingClass: "Classe",
    accountingParentClass: "Classe parente",
    accountingClassReference: "Classe (Référence)",
    accountingClassPlaceholder: "Choisir une classe…",
    accountingClassHint:
      "Optionnel. Sélectionne une classe du Plan Comptable Tunisien (ex. 60 – Achats).",
    accountingClassChildHint:
      "La classe finale est générée automatiquement à partir de la classe parente.",
    accountingClassParentMissing:
      "La catégorie parente n'a pas encore de classe. Renseigne-la d'abord pour générer une classe automatique.",
    accountingClassParentMissingShort:
      "Sélectionne d'abord une classe parente.",
    accountingClassChangeBlocked:
      "Impossible de modifier la classe : des sous-catégories ont déjà une classe générée. Réinitialise-les avant.",
    accountingClassAutoGenerated: "Généré automatiquement",
    accountingClassAutoGeneratedHint:
      "Le code enfant est attribué à la création à partir de la classe de la catégorie.",
    accountingClassNotAssigned: "Aucune classe",
    serviceClassMissing:
      "Le service parent n'a pas encore de classe. Renseigne-la d'abord pour générer une classe automatique.",
    accountingClassAssign: "Attribuer une classe",
    subCategory: "Sous-catégorie",
  },
  decaissement: {
    expenseMode: "Type de dépense",
    normal: "Normale",
    declaree: "Déclarée",
    beneficiaryType: "Type de bénéficiaire",
    beneficiaryName: "Nom du bénéficiaire",
    companyEntity: "Société de groupe",
    amortizationEmpty:
      "Aucune facture fournisseur avec amortissement CAPEX pour cette année scolaire.",
    amortizationFilterCategories: "Catégories CAPEX",
    amortizationFilterCategoriesPlaceholder: "Toutes les catégories CAPEX",
    amortizationFullyAmortizedCount: "Biens entièrement amortis",
    amortizationKpiRemaining: "Quelle valeur nette reste-t-il ?",
    amortizationKpiThisMonth: "Amortissement du mois en cours ?",
    amortizationStatusActive: "En cours",
    amortizationStatusComplete: "Amorti intégralement",
    amortizationTab: "Amortissement",
    amortizationTableCost: "Base amortissable",
    amortizationTableRemaining: "Valeur résiduelle",
    amortizationTableThisMonth: "Ce mois-ci",
    amortizationTableStatus: "Statut",
    capexAmountColumn: "Montant",
    capexDepreciationPeriodMonths: "Période d'amortissement (mois)",
    capexInvoiceDate: "Date de facture (amortissement)",
    capexJulyJuneHint:
      "L'amortissement est calculé par fenêtres d'année scolaire (juillet à juin).",
    capexMonthsColumn: "Mois",
    capexSchedulePreview: "Tableau d'amortissement (aperçu)",
    capexSchoolYearColumn: "Année scolaire",
    capexSectionTitle: "Amortissement CAPEX",
    capexCompleteAmountsFirst:
      "Saisissez d'abord les montants facture (HT, TVA, TTC) ; l'amortissement s'affiche ensuite une fois le montant à payer calculé.",
    invoiceNumber: "Numéro de facture",
    invoiceDate: "Date de facture",
    invoiceDateNotInFuture: "La date de facture ne peut pas être dans le futur.",
    depenseCreatedAt: "Date de création (saisie)",
    entryDateNotInFuture: "La date de saisie ne peut pas être dans le futur.",
    description: "Description",
    amountTTC: "Montant TTC",
    amountTVA: "Montant TVA",
    amountAfterRetention: "Montant après retenue",
    applyRetention: "Appliquer la retenue",
    attachment: "Pièce jointe",
    paymentManagement: "Gestion du paiement",
    planPayment: "Planifier le paiement",
    payNow: "Paiement immédiat",
    totalToPay: "Total à payer",
    addSchedule: "Ajouter une échéance",
    fundSource: "Source de fonds",
    myCaisse: "Ma caisse",
    otherCaisse: "Autre caisse",
    caisseBank: "Caisse banque",
    cashName: "Nom de caisse",
    availableForThisPayment: "Montant disponible pour ce mode de paiement",
    caisseBalanceExceedsAvailWarning:
      "Ce montant dépasse le solde disponible pour le compte sélectionné (pour ce mode de paiement).",
    receiptNumber: "Numéro reçu (souche)",
    methodReference: "Référence de méthode",
    paymentSaved: "Paiement enregistré avec succès",
    missingRequiredFields: "Veuillez renseigner tous les champs requis",
    activityOrServiceRequired: "Sélectionnez une activité ou un service",
    formSectionGeneral: "Informations générales",
    formSectionDetails: "Détails de la dépense",
    formSectionAttachments: "Justificatifs et notes",
    formSectionPayment: "Paiement ou échéances",
    formSectionPaymentHint:
      "Choisissez un paiement immédiat ou au moins une échéance. Pour les dépenses déclarées associé/salarié, la somme des échéances doit égaler le montant.",
    paymentTotalInvalid:
      "Saisissez un montant de dépense valide ci-dessus avant le mode de paiement.",
    validation: {
      expenseModeRequired: "Le mode de dépense est requis",
      invoiceDateRequired: "La date de facture est requise",
      entryDateRequired: "La date de saisie est requise",
      subCategoryRequired: "La sous-catégorie est requise",
      amountRequired: "Le montant est requis",
      amountMustBePositive: "Le montant doit être supérieur à zéro",
      beneficiaryTypeRequired: "Le type de bénéficiaire est requis",
      beneficiaryRequired: "Le bénéficiaire est requis",
      invoiceNumberRequired: "Le numéro de facture est requis",
      amountHTRequired: "Le montant HT est requis",
      amountHTMustBePositive: "Le montant HT doit être supérieur à zéro",
      amountTTCRequired: "Le montant TTC est requis",
      amountTTCMustBePositive: "Le montant TTC doit être supérieur à zéro",
      amountTVARequired: "Le montant TVA est requis",
      capexPeriodRequired: "La durée d'amortissement (mois) est requise",
      capexInvoiceDateRequired: "La date de facture d'immobilisation est requise",
      paymentCaisseRequired:
        "Sélectionnez une caisse pour la ligne de paiement {n}",
      paymentBankRequired:
        "Sélectionnez un compte banque/caisse pour la ligne de paiement {n}",
      scheduleDateRequired: "La date de l'échéance {n} est requise",
      scheduleAmountRequired:
        "Le montant de l'échéance {n} doit être supérieur à zéro",
      selectCaisse: "Sélectionner une caisse",
      selectCaisseBank: "Sélectionner un compte banque/caisse",
      checkHighlightedFields:
        "Vérifiez les champs en surbrillance dans le formulaire.",
    },
    duplicateInvoiceTitle: "Facture en doublon",
    viewExistingInvoice: "Voir la facture existante",
    invoiceNotFoundForRedirect: "La facture existante est introuvable.",
    schedulesMustMatchInvoice:
      "Les montants des échéances doivent totaliser exactement le montant de la dépense (identique au montant de la facture).",
    formSubsectionBeneficiary: "Bénéficiaire",
    formSubsectionProvider: "Détails fournisseur",
    formSubsectionAmount: "Détails du montant",
    activityPercent: "Répartition (%)",
    activityPercentTotal: "Total alloué",
    activityPercentSumMustBe100:
      "Les pourcentages par activité doivent totaliser 100 %.",
    activityDuplicate: "Chaque activité ne peut apparaître qu'une seule fois.",
    addActivityAllocation: "Ajouter une activité",
    activitySingleFullAmount:
      "100 % de la dépense est affecté à cette activité.",
    activityAllocations: "Activités (répartition)",
    activityPlaceholder: "Sélectionner une activité (optionnel)",
    classRoom: "Scolarité (classe)",
    classRoomAllocations: "Scolarité (répartition)",
    levels: "Niveaux",
    classRoomPlaceholder: "Sélectionner une classe (optionnel)",
    addClassRoomAllocation: "Ajouter une classe",
    classRoomPercentTotal: "Total alloué (classes)",
    classRoomPercentSumMustBe100: "Les pourcentages par classe doivent totaliser 100 %.",
    classRoomDuplicate: "Chaque classe ne peut apparaître qu'une seule fois.",
    classRoomSingleFullAmount: "100 % de la dépense est affecté à cette classe.",
    combinedAllocationPercentTotal: "Total Scolarité + Activité",
    combinedAllocationPercentSumMustBe100:
      "La somme des pourcentages Scolarité et Activité doit être égale à 100 %.",
    combinedAllocationSingleHint: "100 % attribués à cet élément.",
    paymentMethod: {
      cash: "Espèces",
      cheque: "Chèque",
      virement: "Virement",
      prelevement: "Prélèvement",
      traite: "Traite",
      tpe: "TPE",
      mixed: "Paiement mixte",
    },
    directionInverse: "Inverse",
    directionInverseHint:
      "Cette sous-catégorie est de type inverse : l'école avance de l'argent et le bénéficiaire remboursera plus tard. Seul le paiement immédiat est possible. L'avance n'est déduite de la caisse qu'après validation par le responsable (réconciliation).",
    repaymentSchedule: "Échéancier de remboursement",
    repaymentScheduleHint:
      "Définissez quand le bénéficiaire remboursera le montant avancé par l'école.",
    methodDetailsSumError:
      "La somme des montants détaillés doit correspondre au montant total du paiement",
    chequeNum: "N° chèque",
    traiteNum: "N° traite",
    chequeBank: "Banque",
    chequeTitulaire: "Titulaire",
    traiteRib: "RIB",
    virementNum: "N° virement",
    addCheque: "Ajouter un chèque",
    addTraite: "Ajouter une traite",
    addVirement: "Ajouter un virement",
    placeholderChequeNum: "Numéro",
    placeholderTraiteNum: "Numéro",
    placeholderDueDate: "JJ/MM/AAAA",
    placeholderBank: "Banque",
    placeholderTitulaire: "Titulaire",
    placeholderRib: "20 chiffres",
    placeholderAmount: "0,000",
    placeholderVirementRef: "Référence",
    legendDebtRow: "Dette",
    legendDebtRowHint: "Les lignes avec ce fond sont liées à une dette.",
  },
  fournisseur: {
    title: "Fournisseurs",
    companyName: "Nom de la société",
    codeTVA: "Code TVA",
    retenue: "Retenue appliquée",
    website: "Site web",
    category: "Catégorie",
    subCategory: "Sous-catégorie",
    archiver: "Archiver",
    archived: "Archivé",
    active: "Actif",
    archivedNotice:
      "Ce fournisseur est archivé et ne peut plus être sélectionné pour de nouvelles dépenses.",
    confirmArchive: "Êtes-vous sûr de vouloir archiver ce fournisseur ?",
    invoiceHistory: "Historique des factures",
    creditNotesTitle: "Factures d'avoir fournisseur",
    creditNotesEmpty: "Aucune facture d'avoir pour ce fournisseur",
    schedulingStatus: "Planification",
    invoiceStatus: "Statut de la facture",
    paid: "Payée",
    partial: "Partiellement payée",
    unpaid: "Impayée",
    scheduled: "Planifiée",
    notScheduled: "Non planifiée",
    addSchedule: "Ajouter une planification",
    editSchedule: "Modifier la planification",
    deleteSchedule: "Supprimer la planification",
    confirmDeleteSchedule:
      "Êtes-vous sûr de vouloir supprimer cette planification ?",
    scheduleExceedsRemaining: "Le total planifié dépasse le montant restant",
    cannotEditPaidSchedule:
      "Les planifications payées ou annulées ne peuvent pas être modifiées",
    dueDate: "Date d'échéance",
    scheduledAmount: "Montant planifié",
    totalAmount: "Montant total",
    totalPaid: "Total payé",
    remaining: "Restant",
    invoiceSummary: "Résumé de la facture",
    noSchedules: "Aucune planification pour cette facture",
    scheduleCreated: "Planification créée avec succès",
    scheduleUpdated: "Planification mise à jour avec succès",
    scheduleDeleted: "Planification supprimée avec succès",
    schedulesDisabledInvoicePaid:
      "Impossible d’ajouter des planifications : le statut de la facture est « payée ».",
    supplierArchived: "Fournisseur archivé avec succès",
    allSuppliers: "Tous les fournisseurs",
    showArchived: "Afficher les archivés",
    searchPlaceholder: "Rechercher par nom, code TVA...",
    totalInvoices: "Total des factures",
    totalRemaining: "Total restant",
    contactInfo: "Coordonnées",
    businessInfo: "Informations commerciales",
    financialOverview: "Aperçu financier",
    paymentBreakdown: "Répartition des paiements",
    paymentProgress: "Progression des paiements",
    scheduleProgress: "Progression de planification",
    scheduleDueToday: "prochaine échéance aujourd'hui",
    scheduleDueInDays: "prochaine échéance dans {n} jours",
    scheduleDueInMonths: "prochaine échéance dans {n} mois",
    scheduleOverdueByDays: "en retard de {n} jours",
    noData: "Aucune donnée disponible",
  },
  factures: {
    title: "Factures",
    filtersTitle: "Filtres",
    searchPlaceholder:
      "Rechercher libellé, référence, n° facture, description…",
    filterInvoiceStatus: "Statut de paiement",
    filterSchedulingStatus: "Planification",
    filterBeneficiaryType: "Type de bénéficiaire",
    filterExpenseMode: "Type de dépense",
    filterProvider: "Fournisseur",
    filterDateRange: "Date de facture",
    resetFilters: "Réinitialiser les filtres",
    detailTitle: "Détail de la facture",
    reference: "Référence",
    manageSchedules: "Échéances",
    goToPaymentEntry: "Saisie de paiement",
    viewSupplier: "Fiche fournisseur",
    attachments: "Pièces jointes",
    attachmentCount: "{n} fichier(s)",
    noAttachments: "Aucune pièce jointe",
    beneficiaryProvider: "Fournisseur",
    beneficiaryAssociate: "Associé",
    beneficiaryEmployee: "Employé",
    beneficiaryCompany: "Société de groupe",
    beneficiaryDebiteur: "Débiteur",
    tableLabel: "Libellé",
    paginationTotal: "{total} facture(s)",
    createNewDepense: "Nouvelle dépense",
    backToInvoiceList: "Retour aux factures",
  },
  saisiePaiement: {
    title: "Saisie de paiement",
    pending: "En attente",
    pendingSchedules: "Planifications en attente",
    unplannedExpenses: "Dépenses non planifiées",
    paySelected: "Payer la sélection",
    groupPayment: "Paiement groupé",
    duplicateSchedule: "Dupliquer la planification",
    paymentExecuted: "Paiement effectué avec succès",
    selectAtLeastOne: "Sélectionnez au moins une planification",
    beneficiary: "Bénéficiaire",
    invoiceRef: "Référence facture",
    dueDate: "Date d'échéance",
    amount: "Montant",
    selectFundSource: "Sélectionner la source",
    selectMethod: "Sélectionner le mode de paiement",
    confirmPayment: "Confirmer le paiement",
    totalSelected: "Total sélectionné",
    addScheduleFromHere: "Ajouter une planification",
    noUnplannedExpenses: "Aucune dépense non planifiée",
    noPendingSchedules: "Aucune planification en attente",
    filterBeneficiaryType: "Type de bénéficiaire",
    filterExpenseMode: "Mode de dépense",
    filterDueDateRange: "Période d'échéance",
    expenseLabel: "Dépense",
    expenseMode: "Mode",
    splitPaymentsHint:
      "Ajoutez une ligne par mode. Les espèces utilisent uniquement votre caisse principale ; chèque, virement, traite et TPE utilisent un compte bancaire (caisse). La somme doit égaler le total.",
    tableSearch: "Recherche",
    tableSearchPlaceholder:
      "Dépense, bénéficiaire, n° de facture, type, mode ou montant…",
    paymentLine: "Ligne de paiement {n}",
    addPaymentLine: "Ajouter une ligne de paiement",
    removePaymentLine: "Supprimer cette ligne",
    splitsTotal: "Total réparti",
    splitsSumMismatch: "Le total réparti doit être égal au montant sélectionné",
    lineAmountRequired: "Chaque ligne doit avoir un montant positif",
    manageSchedules: "Gérer les échéances",
    cannotLoadDepenseForSchedules:
      "Impossible d'ouvrir l'éditeur d'échéances (données dépense manquantes).",
    drawerDepenseSchedulesTitle: "Dépense et échéances de paiement",
    depenseDetailsSection: "Détails facture / dépense",
    schedulesEditHint:
      "Modifiez les échéances en attente, ajoutez des lignes ou supprimez-les. Le total planifié ne doit pas dépasser le montant de la dépense.",
    clickedScheduleBadge: "Depuis la liste",
    batchPendingTotal: "Total des échéances en attente",
    batchRequiredRemaining: "Montant requis (total facture − déjà payé)",
    batchSchedulesEmptyHint:
      "Ajoutez une ou plusieurs lignes. Le total doit égaler le montant requis avant enregistrement.",
    unsavedSchedulesHint:
      "Enregistrez ou annulez pour pouvoir sélectionner des échéances à payer.",
    batchSchedulesSaved: "Plan d'échéances enregistré.",
    selectToPaySection: "Payer maintenant (sélectionner les échéances)",
  },
  paiementHistory: {
    title: "Historique des paiements",
    paymentDetail: "Détail du paiement",
    date: "Date",
    paymentMode: "Mode de paiement",
    immediate: "Immédiat",
    scheduled: "Planifié",
    status: "Statut",
    validationStatus: "Statut de validation",
    method: "Méthode",
    fundSource: "Source",
    createdBy: "Créé par",
    rejectedBy: "Rejeté par",
    rejectedAt: "Rejeté le",
    validatedBy: "Validé par",
    validatedAt: "Validé le",
    rejectionReasonMissing: "Aucun motif de rejet enregistré",
    searchReceipt: "Recherche par N° de reçu",
    dateRange: "Période",
    noPayments: "Aucun paiement trouvé",
    relatedInvoices: "Factures liées",
    schedules: "Échéances liées",
    schedulesThisPayment: "Échéances réglées par ce paiement",
    otherSchedules: "Autres planifications",
    otherSchedulesHint:
      "Autres échéances sur les mêmes dépenses (en attente ou déjà réglées ailleurs).",
    debtLabel: "Libellé de la dette",
    debtRepaymentStatus: "Remboursement de la dette",
    debtRemainingInstallments: "Échéances restantes sur cette dette",
    debtNoRemainingInstallments:
      "Aucune échéance en attente sur cette dette (tout payé ou aucune planification).",
    expenseOrInvoice: "Dépense / réf.",
    statuses: {
      completed: "Complété",
      pending: "En attente",
      cancelled: "Annulé",
      awaiting_validation: "En attente de validation",
    },
    validationStatuses: {
      pending_validation: "En attente",
      validated: "Validé",
      rejected: "Rejeté",
    },
  },
  encaissementValidation: {
    title: "Validation de réception (inverse)",
    detailTitle: "Détail de l'échéance inverse",
    searchPayeur: "Rechercher par payeur / libellé",
    filterBenType: "Type de bénéficiaire",
    filterDateRange: "Période d'échéance",
    colPayeur: "Payeur",
    colLibelle: "Libellé",
    colMontant: "Montant",
    colDueDate: "Date d'échéance",
    colCreatedBy: "Créé par",
    colDepensePaymentStatus: "Statut décaissement",
    colStatut: "Statut",
    statusPending: "En attente",
    statusReceived: "Reçu",
    statusCancelled: "Annulé",
    confirm: "Confirmer",
    confirmDisabledHint:
      "Le décaissement doit être validé en réconciliation avant de confirmer la réception.",
    outboundPaymentNone: "Aucun décaissement",
    confirmTitle: "Confirmer la réception du paiement",
    paymentMethod: "Mode de paiement",
    fundDestination: "Destination des fonds",
    receivedBy: "Reçu par",
    receivedAt: "Reçu le",
    noSchedules: "Aucune échéance inverse trouvée",
    depenseInfo: "Informations de la dépense",
    paymentInfo: "Détails du paiement reçu",
    otherSchedules: "Autres échéances sur cette dépense",
    repaymentSchedules: "Échéances de remboursement (inverse)",
    repaymentComplete: "Le remboursement est complet",
    scheduleTotal: "Montant de l'échéance à encaisser",
    splitPaymentsHint:
      "Ajoutez une ligne par mode de paiement. La somme des montants doit égaler le total de l'échéance. Chaque ligne peut avoir une caisse ou un compte bancaire différent.",
    paymentLine: "Ligne de paiement {n}",
    addPaymentLine: "Ajouter une ligne de paiement",
    removePaymentLine: "Supprimer cette ligne",
    splitsTotal: "Total réparti",
    splitsSumMismatch:
      "Le total réparti doit être égal au montant de l'échéance",
    lineAmountRequired: "Chaque ligne doit avoir un montant positif",
    pendingInverseSchedules: "Échéances en attente",
    editRepaymentSchedulesSection: "Échéances de remboursement",
  },
  reconciliation: {
    title: "Réconciliation",
    pendingValidation: "En attente de validation",
    validated: "Validé",
    rejected: "Rejeté",
    rejectionReason: "Motif du rejet",
    rejectionReasonRequired: "Le motif du rejet est obligatoire",
    paymentValidated: "Paiement validé avec succès",
    paymentRejected: "Paiement rejeté avec succès",
    validatePayment: "Valider",
    rejectPayment: "Rejeter",
    confirmValidation: "Êtes-vous sûr de vouloir valider ce paiement ?",
    createdBy: "Créé par",
    noPaymentsPending: "Aucun paiement en attente de validation",
    noPaymentsRejected: "Aucun paiement rejeté",
    noPaymentsValidated: "Aucun paiement validé",
    noPaymentsFound: "Aucun paiement trouvé",
    filterValidationStatus: "Statut de validation",
    filterPendingValidation: "En attente de validation",
    filterValidatedOnly: "Validés uniquement",
    filterRejectedOnly: "Rejetés uniquement",
    filterAllPayments: "Tous (en attente, validés, rejetés)",
    colPaymentType: "Type",
    colCaisseDebit: "Débit caisse",
    paymentTypeNormal: "Sortant",
    paymentTypeInverse: "Inverse",
    caisseDebitPending: "À la validation",
    caisseDebitAlreadyApplied: "Déjà déduit",
    validateModalTitle: "Valider le paiement",
    validateModalPaymentType: "Type de paiement",
    validateModalAmount: "Montant",
    validateModalInverseIntro:
      "Dépense inverse : les montants seront déduits des caisses lors de cette validation.",
    validateModalInverseDebitList: "Détail des déductions qui seront appliquées :",
    validateModalInverseAlreadyDebited:
      "Le montant a déjà été déduit de la caisse. Cette validation confirme l'opération.",
    validateModalNormalIntro:
      "Ce paiement a déjà été déduit de la caisse lors de sa saisie. La validation confirme l'opération comptable.",
    splitLineSummary: "{method} — {amount} depuis {caisse}",
  },
  avoir: {
    title: "Factures d'avoir",
    newCreditNote: "Nouvelle facture d'avoir",
    pendingReception: "En attente de réception",
    received: "Reçu",
    cancelled: "Annulé",
    confirmReception: "Confirmer la réception",
    amountExceedsInvoice: "Le montant dépasse le total de la facture",
    creditNoteCreated: "Facture d'avoir créée avec succès",
    receptionConfirmed: "Réception confirmée avec succès",
    selectInvoice: "Sélectionner une facture",
    selectProvider: "Sélectionner un fournisseur",
    receptionMethod: "Mode de réception",
    noCreditNotes: "Aucune facture d'avoir",
    depenseMissingForDetail:
      "La facture liée n'a pas pu être chargée pour le détail.",
    invoiceAlreadyHasAvoir:
      "Cette facture a déjà une facture d'avoir. Une seule facture d'avoir par facture est autorisée.",
    invoiceNotFullyPaid:
      "Vous ne pouvez créer une facture d'avoir que pour une facture entièrement réglée.",
    detailDrawerTitle: "Détail de la facture d'avoir",
    detailSectionCreditNote: "Facture d'avoir",
    detailSectionReception: "Réception",
    detailSectionOriginalInvoice: "Facture fournisseur d'origine",
    detailSupplierLabel: "Fournisseur",
    detailSchoolYear: "Année scolaire",
    receptionValidatedAt: "Date de réception",
    receptionValidatedBy: "Réception enregistrée par",
    totalReceived: "Total reçu",
    transferDestinationCaisse: "Caisse de destination (après transfert)",
    receptionSplitLines: "Réception par mode de paiement",
    splitDestination: "Destination",
    detailPendingReception:
      "Cette facture d'avoir est en attente de réception ; les modes de paiement apparaîtront après confirmation.",
  },
  dette: {
    title: "Gestion des engagements",
    newDebt: "Nouvelle dette",
    credit: "Crédit",
    engagement: "Engagement",
    loan: "Emprunt",
    debtType: "Type de dette",
    beneficiary: "Bénéficiaire",
    beneficiaryType: "Type de bénéficiaire",
    associate: "Associé",
    debiteur: "Débiteur",
    installmentAmount: "Montant de la tranche",
    numberOfInstallments: "Nombre de tranches",
    firstInstallmentDate: "Date de la 1ère tranche",
    generateInstallments: "Générer les tranches",
    sumMismatch: "La somme des tranches doit être égale au montant total",
    debtCreated: "Dette créée avec succès",
    depenseTemplate: "Modèle de dépense",
    installments: "Tranches",
    debtInfo: "Informations sur la dette",
    totalAmount: "Montant total",
    noDebts: "Aucune dette",
    debtDetail: "Détail de la dette",
    schedulePending: "En attente",
    schedulePaid: "Payé",
    scheduleCancelled: "Annulé",
    paidOn: "Payé le",
    noSchedulesDetail: "Aucune échéance pour cette dette.",
    nextPaymentEta: "Prochaine échéance",
    initialReceiptStep: "Réception des fonds",
    initialReceiptHint:
      "Indiquez comment le montant emprunté entre dans vos caisses (espèces, chèque, banque). Le total doit égaler le montant de la dette ; les lignes apparaissent dans l’historique encaissement de chaque caisse.",
    initialReceiptDetail: "Réception initiale des fonds",
    receivedAt: "Reçu le",
    receivedBy: "Reçu par",
    encaissementLines: "Lignes de paiement (répartition)",
  },
  scolarite: {
    affichageParametrage: "Paramètre d'affichage",
    matieres: "Matières",
    modules: "Les modules",
    modulesSpec: "Les modules pilote",
    moduleType: "Type de module",
    moduleName: "Module",
    nomModule: "Nom module",
    affectationDansClasses: "Affectation dans les classes",
    affectationEnseignants: "Affectation des enseignants",
    enseignants: "Enseignants",
    typePunitions: "Type de punitions",
    typeStudentDiscipline: "Type de discipline de l'élève",
    nom: "Nom",
    customName: "Nom personnalisé",
    coefficient: "Coefficient",
    listeMatieres: "Liste des matières",
    listeModules: "Liste des modules",
    infoModule:
      "Affecté des matiéres a des modules a fin d'organiser les gestion des notes !",
    listeModulesSpec: "Liste des modules pilote",
    infoModuleSpec:
      "Affecté des matiéres a des modules pilote a fin d'organiser les gestion des notes !",
    ajouterModule: "Ajouter un module ",
    ajouterMatiere: "Ajouter une matière",
    affectes: "Affectés",
    nonAffectes: " Non Affectés",
    recherche: "Recherche",
    element: "élément",
    aucunDonnee: "Aucun Donnée",
    modifierListeMatieres: "Modifiez la liste des matiéres du module : {name}",
    modifierListeEnseignants:
      "Modifiez la liste des enseignants de la classe : {name}",
    supprime: "Supprimé",
    aucuneClasseTrouvee: "Aucune classe trouvée",
    charcherParClasse: "Chercher par nom de classe",
    afficherClassesSupprimees: "Afficher les classes supprimées",
    deletedClasses: "Les classes supprimées",
    activeClasses: "Les classes actives",
    other: "Autre",
    confirmDeleteModule:
      "Toutes les sessions relatives à ce module seront supprimées. Ce module est utilisé dans les classes ci-dessous",
    certification: "Certificat",
    appreciation: "Appréciation",
    modulesVerySpec: "Module spécifique",
    subsubjects: "Les sous-matières",
    subsubject: "Sous-matière",
    ajouterSubsubject: "Ajouter une sous-matière",
    addNewSubsubject: "Gérer les sous-matières",
    choisirSubsubject: "Choisir une sous-matière",
    mark: "Note maximale",
    listeModulesVerySpec: "Liste de modules spécifiques",
    infoModuleVerySpec:
      "Affecté des matiéres a des modules spécifique a fin d'organiser les gestion des notes !",
    totalMarksMustBe20:
      "{subject} : le total des notes des sous-matières doit être de 20",
    schoolYear: "Année scolaire",
    selectSchoolYear: "Sélectionner l'année scolaire",
    subjectDejaExiste: "Cette matière existe déjà",
    SubModuleDejaExiste: "Ce sous-module existe déjà",
    SubSubjectDejaExiste: "Ce sous-matière existe déjà",
    cloneParam: "Dupliquer un paramétrage",
    fromSchoolYear: "Année scolaire source",
    toSchoolYear: "Année scolaire cible",
    selectParamToClone: "Sélectionner le paramétrage à dupliquer",
    duppModules: "Dupliquer",
    nombreElevesManquants: "Nombre d'élèves manquants des notes",
    adminAppreciation: "Appréciation de l'admin",
    incompleteDataWarning:
      "Certaines matières ont une configuration incomplète. Les valeurs par défaut ont été appliquées. Veuillez vérifier et enregistrer pour corriger.",
  },
  autorisation: {
    accueil: "accueil",
    admin: "Admin",
    designation: "Désignation",
    compteAdmin: "Compte Admin",
    dossierMedical: "Dossier médical",
    listeEleves: "Liste des élèves",
    parametrage: "Paramétrage",
    activite: "Activité",
    administration: "Administration",
    scolarite: "Scolarité",
    personnel: "Personnel",
    personnels: "Personnels",
    comptabilite: "Comptabilité",
    declarations: "Déclarations",
    paiements: "Paiements",
    medicalNote: "Note médicale",
    medicalNoteContext:
      "Les parents peuvent consulter et modifier les notes médicales de leurs enfants.",
    noteForTeachers: "Notes médicales pour les enseignants",
    noteForTeachersContext:
      "Les parents peuvent consulter et modifier les notes de leurs enfants pour les enseignants.",
    modifierFraisClasse: "Modifier les frais des classes",
    modifierFraisClasseHint:
      "Autorise à modifier les frais d'une classe normale (sinon hérités du niveau).",
    decaissementLegacyAccess: "Décaissement — accès complet (hérité)",
  },
  utilisateur: {
    listeUtilisateur: "Liste des Utilisateurs",
    nom: "Nom",
    role: "Rôle",
    acces: "Accès aux établissements",
    actif: "Actif",
    nonActif: "Non actif",
    mdp: "Mot de passe",
    activerDesactiver: "Activer/Désactiver",
    confirmerMdp: "Confirmer mot de passe",
    changerMdp: "Vous pouvez changer la mot de passe",
    active: "Activé",
    nonActive: "Non activé",
    desactiverAlert: "Voulez-vous désactiver cet utilisateur ?",
    activerAlert: "Voulez-vous Activer ce utilisateur?",
    userDesactive: "Utilisateur désactivé!",
    userActive: "Utilisateur activé!",
    passwordAgain: "Veuillez entrer le mot de passe à nouveau",
    passwordMatch: "Les entrées ne correspondent pas!",
    sessions: "Sessions",
    sessionOnline: "En ligne",
    sessionOffline: "Hors ligne",
    viewSessions: "Voir ({count})",
    activeSessionsFor: "Sessions actives — {user}",
    device: "Appareil",
    unknownDevice: "Appareil inconnu",
    ipAddress: "Adresse IP",
    sessionSource: "Source",
    lastActive: "Dernière activité",
    expiresAt: "Expire le",
    actions: "Actions",
    withActiveSessions: "Avec sessions",
    allUsersFilter: "Tous",
    restricted: "Restreint",
    sessionScopeDenied:
      "Vous devez avoir accès à tous les établissements de cet utilisateur.",
    revokeSession: "Révoquer",
    revokeSessionConfirm: "Révoquer cette session ?",
    revokeSessionSuccess: "Session révoquée.",
    revokeAllSessions: "Révoquer toutes les sessions",
    revokeAllSessionsConfirm:
      "Révoquer toutes les sessions et déconnecter immédiatement cet utilisateur ?",
    revokeSessionsSuccess: "Toutes les sessions ont été révoquées.",
    revokeSessionsError: "Impossible de révoquer les sessions.",
    loadSessionsError: "Impossible de charger les sessions.",
  },
  parentalControl: {
    changeUserName: "Changer le nom d'utilisateur",
    disableAccount: "Désactiver le compte parent",
    enableAccount: "Activer le compte parent",
    parentQrCode: "Code QR du parent",
    accountActive: "Compte activé, l'utilisateur peut accéder à l'application.",
    accountInactive:
      "Compte désactivé, l'utilisateur ne peut pas accéder à l'application.",
  },
  liste: {
    searchStudent: "Rechercher un élève",
    searchBy: "Vous pouvez rechercher par",
    listeElevesArchive: "Liste des élèves archivés",
    reactive: "Réactiver",
    showSchoolLogo: "Afficher le logo du l'ecole",
    showGovLogo: "Afficher le logo du la ministère",
    reasonArchive: "Raison d'archive",
    addFiles: "Ajouter des fichiers",
    studentPhoto: "Avatar de l'élève",
    studentFiles: "Dossiers d'élève",
    consulterProfil: "Consulter le profil pour plus de détails",
    nomPrenom: "Nom et prénom",
    photoMediaConsent: "Consentement photo & médias (parent)",
    photoMediaConsentFilterLabel:
      "Consentement photo & médias de l’élève (compte parent)",
    photoMediaConsentAll: "Tous",
    photoMediaConsentAccepted: "Accepté",
    photoMediaConsentRefused: "Refusé",
    photoMediaConsentPending: "Sans réponse",
    scolarite: "Scolarité",
    ficheParent: "Fiche Parent",
    attestation: "Attestation de présence",
    inscription: "Inscription",
    supprimerAnnuler: " Supprimer / Annuler",
    inscriSupprimer: "Inscri / Supprimer",
    filles: "Filles",
    garcons: " Garçons",
    total: "Total",
    nonInscrits: "Non-inscrits",
    inscrits: " Inscrits",
    parents: "Parents",
    pere: "Père",
    mere: "Mère",
    guardian: "Tuteur",
    enfants: "Enfants",
    email: "Email",
    ajouterEleve: " Ajouter un élève",
    nouveauPaiement: "Nouveau paiement",
    ajouterDossier: "Ajouter un dossier",
    ajouterPersonnel: "Ajouter un personnel",
    ajouterEnseignant: "Ajouter un enseignant",
    listeEleves: "Liste des élèves",
    administration: "Administration",
    tranches: "Tranches",
    toutesTranches: "Toutes les tranches",
    nom: "Nom",
    prenom: "Prénom",
    notes: "Notes",
    dateNaissance: "Date de Naissance",
    sexe: "Sexe",
    adresse: "Adresse",
    telephone: "Téléphone",
    classes: "Les classes",
    ajouterParent: "Ajouter nouveau parent",
    ajouterParentSansEleveHint:
      "Créez un parent sans ajouter d'élève. Vous pourrez ensuite l'associer à un élève depuis sa fiche.",
    parentsExis: "Les parents existants",
    ficheParents: "Fiche parents",
    nomMere: " Nom de la mère",
    prenomMere: "Prénom de la mère",
    emailMere: "Email de la mère",
    adresseMere: "Adresse de la mère",
    adressePere: "Adresse du père",
    prenomPere: "Prénom du père",
    telMere: "Téléphone de la mère",
    nomPere: " Nom du père",
    emailPere: "Email du père",
    telPere: "Téléphone du père",
    metierPere: "Métier du père",
    metierMere: "Métier de la mère",
    cinPere: "CIN du père",
    cinMere: "CIN de la mère",
    cinGardian: "CIN du tuteur",
    gardianName: "Nom du tuteur",
    gardianFirstName: "Prénom du tuteur",
    gardianAdress: "Adresse du tuteur",
    gardianPhone: "Téléphone du tuteur",
    gardianJob: "Métier du tuteur",
    adresseParents: "Adresse des parents",
    emailParents: "E-mail des parents",
    reduction: "Réduction sur le frais d'inscription",
    reductionMensuel: "Réduction sur le frais mensuel",
    identifiantUnique: "Identifiant unique",
    regionalEducation: "Commissariat Régional de l'education",
    recuEn: "Reçu en",
    nonInscrit: "NON INSCRIT",
    freresSoeurs: "Liste des frères et sœurs",
    studentFullName: "Nom de l'élève",
    brotherSister: "Frère / Sœur",
    brother: "Frère",
    sister: "Sœur",
    parentFullName: "Nom du parent",
    classe: "Classe",
    siblingGroups: "groupes familiaux",
    noSiblingGroups: "Aucun groupe de frères et sœurs trouvé",
    changementNonEffectue: "Changement non effectué",
    champsVides: "Les champs de saisis ne peut pas être vide",
    imprimerLoginsEnsg: "Logins enseignants",
    fichePersonnel: "Fiche Personnelle",
    nombreEnfants: "Nombre d'enfants",
    situationFamiliale: "Situation financière",
    dateEntree: "Date d'entrée",
    etablissementPrecedent: "Previous institution",
    dateSortie: "Date de sortie",
    motifSortie: "Motif de sortie",
    documents: "Documents",
    motivation: "Motivation",
    nombreInscriptions: "Nombre d'inscriptions",
    accompanyingDocuments: "Documents accompagnants",
    secondarySchool: "Lycée",
    previousInstitution: "Établissement précédent",
    behavior: "Comportement",
    attendance: "Présence",
    includePhoto: "Photo de l'élève",
    generatePdfAnyway: "Générer PDF quand même",
    studentsWontAppearInPdf:
      "Les élèves suivants n'apparaîtront pas dans le PDF car leurs parents n'ont pas d'identifiants de connexion :",
    studentsWithoutLogin: "Élèves sans identifiants de connexion",
    studentsWithoutLoginInfo:
      "Les élèves suivants n'ont pas d'identifiants de connexion mais apparaîtront dans le PDF :",
    qrCodeErrorWarning: "Problème de génération de codes QR",
    qrCodeErrorDescription:
      "Ces utilisateurs ont eu des problèmes lors de la génération de leur code QR. Vous pouvez les imprimer individuellement depuis leur profil.",
    parentLogins: "Logins parents",
    printSelectionMode: "Imprimer par",
    fraisTranches: "Frais des tranches",
    paymentMode: "Le mode de paiement selectionné est",
    tranches: "par tranches",
    mensuelle: "mensuelle",
    generated: "Géneré le :",
    listBadges: "Liste des badges",
    concInfo: "Informations de connexion",
    elevesAssocies: "Les élèves associés",
    linkConnection: "Lien de connexion",
    linkConnectiontext: "ou application Mobile EdParent",
    attestationInscription: "Attestation d'inscription",
  },
  cantine: {
    modifierMenu: "Modifier le menu ",
    cantine: "Menu cantine",
    dateChoisie: "Date choisie",
    choisirDate: "Choisir une date pour insérer le menu ",
    ajouterRepas: "Ajouter un repas",
    ajouterMenu: " Ajouter un nouveau menu pour",
    choisirJour: "Choisir les jours",
    mealName: "Nom du repas",
    type: " Type",
    repeter: "Répéter",
    saisirNom: " Saisir le nom du repas",
    saisirType: "Choisir le type du repas",
    saisirEndDate: "Saisir la date de fin",
    plat: "Plat Principal",
    entree: "Entrée",
    goute: "Goûté",
    boissons: "Boissons",
    autre: "Autres",
    dessert: "Dessert",
    menuIntrouvable: "Menu introuvable, merci d'ajouter des repas !",
    ajouterNewMenu: "Ajouter nouveaux menu pour {date}",
    modifierMenu: "Modifier le menu {name}",
    saisirDateFin: "Saisir la date de fin",
    addSuccessMessage: "Un repas est ajouté.",
    editSuccessMessage: "Un repas est modifié.",
    errorMessage: "Une erreur est survenue dans la modification !",
    errorMessageAdd: "Une erreur est survenue dans l'ajout !",
    ajouterMenuHebdo: "Ajouter un menu hebdomadaire",
    nomMenu: "Nom du menu",
    saisirNomMenu: "Saisir le nom du menu",
    descriptionMenu: "Description",
    saisirDescriptionMenu: "Saisir une description du menu",
    dateDebut: "Date de début",
    saisirDateDebut: "Saisir la date de début",
    endDateAvantDebut:
      "La date de fin doit être égale ou postérieure à la date de début",
    joursWeekend: "Jours du week-end",
    inclureSamedi: "Inclure le samedi",
    inclureDimanche: "Inclure le dimanche",
    imageMenu: "Image du menu",
    menusHebdo: "Menus hebdomadaires",
    repasDuJour: "Repas du jour",
    aucunMenuHebdo: "Aucun menu hebdomadaire pour cette date",
    samediEtDimancheInclus: "Samedi et dimanche inclus",
    modifierMenuHebdo: "Modifier le menu hebdomadaire {name}",
    menuHebdoAjoute: "Menu hebdomadaire ajouté.",
    menuHebdoModifie: "Menu hebdomadaire modifié.",
    menuHebdoSupprime: "Menu hebdomadaire supprimé.",
    erreurSuppressionMenuHebdo:
      "Une erreur est survenue lors de la suppression du menu hebdomadaire !",
    apercu: "Aperçu",
    samediInclus: "Samedi inclus",
    dimancheInclus: "Dimanche inclus",
    joursSemaineSeulement: "Jours de semaine uniquement",
  },
  paiement: {
    activiteSupprimee: "Les activités supprimées",
    activiteActive: "Les activités actives",
    reducation: "Réducation",
    reducationRep: "Réduction répétitive",
    reductionBase: "Réduction de base",
    selectMonths: "Sélectionner les mois",
    reducationDefault: "Réduction par défaut",
    avoir: "Avoir",
    note: "Note",
    paiementClasse: "Paiement/Classe",
    nom: "Nom de l'élève",
    prenom: "Prénom de l'élève",
    classe: "Classe",
    parents: "Parents",
    tels: "Téléphones des parents",
    etat: "Etat de paiement",
    fraisInscri: "Frais d'inscription",
    fraisMensuel: "Frais Mensuels",
    dateDebut: " Date de début",
    dateFin: "Date de fin",
    tousMois: "Tous les mois",
    mois: "Mois",
    tousClasses: "Toutes les classes",
    order: "Order",
    service: "Service",
    nbEleves: "Nombre d'élèves",
    listeClasses: " Liste des classes",
    listeEleves: "Liste des élèves",
    imprimerTab: "Imprimer le tableau",
    selectionnerMois: "Sélectionner le mois",
    paye: "Payé",
    inscriPaye: "Inscription payé",
    inscriNonPaye: "Inscription non payé",
    impaye: "Non payé",
    partiel: "Partiellement payé",
    selectionnerDate: "Sélectionner une date",
    reduction: "Réducation sur l'inscription",
    reductionMensuel: "Réduction mensuelle",
    activite: "Activité",
    annulation: "Annulation",
    annulationSuccess: "Annulation effectuée avec succès",
    listeActivites: "Liste des activités",
    filtrerParStatut: "Filtrer par statut:",
    actives: "Actives",
    toutes: "Toutes",
    dt: " DT",
    non: "Non",
    chercher: "Chercher",
    annulerInscri: "voulez-vous annuler l'inscription?",
    eleveRequis: "Un élève au moins est requis",
    classRequis: "Une classe au moins est requis",
    activiteRequis: "L'activité est requis",
    activitesTypeDifferent:
      "Vous ne pouvez sélectionner que des activités de même type (Journalière ou Mensuelle/Tranche)",
    tagActiviteJournaliere: "Journalière",
    tagActiviteMensuelleTranche: "Mensuelle/Tranche",
    inscriptionEchecPourActivite: "Échec de l'inscription pour l'activité",
    inscriptionReussitePourActivites:
      "Inscription réussie pour {count} activité(s)",
    dateDebutRequis: "La date de début est requis",
    dateFinRequis: "La date de fin est requis",
    msgReduction:
      "Réglez la réduction à zéro si vous ne souhaitez pas ajouter de réduction",
    typeDepense: "Le type de dépense est requis",
    eleve: "L'élève est requis",
    totalPaiements: "Total des paiements",
    totalMontant: "Total des montants",
    lignes: "lignes",
    paymentMode: "Selectionner le mode de paiement",
    etatPaiementsPourMois: "Etat des paiements pour le mois",
    etatPaiementsTousMois: "Etat des paiements pour tous les mois",
    num: "Num",
    paymentStatusActivity: "Etat_paiements_activité",
    impaye: "Impayé",
    paye: "Payé",
    paymentStatusScolarite: "Etat_paiements_scolarité",
    totalInscriptions: "Nombre total d'inscriptions",
    trancheLabel: "Tranche",
    inscriptionLabel: "Inscription",
    title: "Saisie de paiement",
    pendingSchedules: "Échéances en attente",
    unplannedExpenses: "Dépenses non planifiées",
    invoiceRef: "Réf. facture",
    beneficiary: "Bénéficiaire",
    dueDate: "Date d'échéance",
    amount: "Montant",
  },
  inscription: {
    nom: "Nom complet",
    dateNaissance: "Date de naissance",
    sexe: "Sexe",
    tels: "Téléphones des parents",
    parent: "Parent",
    nouvInscri: "Nouvelle inscription",
    nbEleves: "Nombre d'élèves: {number}",
    ficheParentClasse: "Fiche classe / parent",
    ficheClasse: "Fiche classe",
    confirmEnrollmentTooltip:
      "L'inscription des élèves de la classe {name} sera disponible pour les parents",
    cancelEnrollmentConfirmationTooltip:
      "L'inscription des élèves de la classe {name} ne sera plus disponible pour les parents",
    enrollmentVisibleTag: "Disponible pour les parents",
    enrollmentHiddenTag: "Indisponible pour les parents",
    enrollmentVisibleTooltip:
      "L'inscription des élèves de la classe {name} est disponible pour les parents",
    enrollmentHiddenTooltip:
      "L'inscription des élèves de la classe {name} est indisponible pour les parents",
    enrollmentAllVisibleTooltip:
      "L'inscription de toutes les classes est disponible pour les parents",
    enrollmentAllHiddenTooltip:
      "L'inscription de toutes les classes est indisponible pour les parents",
    confirmAllClassesBtn: "Mettre toutes les classes disponibles pour les parents",
    cancelAllConfirmationBtn:
      "Mettre toutes les classes indisponibles pour les parents",
    confirmAllClassesContent:
      "L'inscription de toutes les classes sera disponible pour les parents.",
    cancelAllConfirmationContent:
      "L'inscription de toutes les classes ne sera plus disponible pour les parents.",
    enrollmentConfirmedMsg:
      "L'inscription de la classe {name} est maintenant disponible pour les parents",
    enrollmentUnconfirmedMsg:
      "L'inscription de la classe {name} n'est plus disponible pour les parents",
    allClassesConfirmedMsg:
      "L'inscription est maintenant disponible pour les parents pour toutes les classes",
    allClassesUnconfirmedMsg:
      "L'inscription n'est plus disponible pour les parents pour toutes les classes",
    inscription: "Inscription",
    enfant: "Enfant",
    fraisInscri: "Frais d'inscription",
    fraisMensuel: "Frais mensuels",
    remise: "Remise ",
    remiseInscri: "Remise à l'inscription",
    remiseMensuel: "Remise mensuelle",
    rechercher: "Rechercher",
    mensuel: "Mensuel",
    chercherParActivite: "Chercher par nom d'activité",
    sureToInscri: "Êtes-vous sûr d'inscrire cet Élève ?",
    downloadTitle: "Télécharger la liste des élèves par activité",
    activityListSelectColumnsHint:
      "Choisissez les informations des élèves à inclure dans la liste de l'activité.",
    noStudentInActivity: "Aucun élève inscrit dans les activités suivantes",
    unableToGeneratePdf:
      "Impossible de générer le PDF - Aucun élève inscrit dans les activités sélectionnées",
    selectionnerModePaiement: "Sélectionner le mode de paiement",
    fraisDesTranches: "Frais des tranches",
    tranche: "Tranche",
    lesFraisAPayer: "Les frais à payer",
    modePaiementSelectionne: "Le mode de paiement sélectionné est",
    parTranches: "par tranches",
    mensuelle: "mensuelle",
    selectionnerJours: "Sélectionner les jours",
    datesSelectionnees: "Dates sélectionnées",
    toutEffacer: "Tout effacer",
    aucuneDateSelectionnee: "Aucune date sélectionnée",
    frais: "Frais",
    inclus: "Inclus",
    selectionnerAuMoinsUnJour:
      "Veuillez sélectionner au moins un jour pour cette activité journalière",
    ajouterDate: "Ajouter une date",
    ajouter: "Ajouter",
    selectionnerTranches: "Sélectionner les tranches",
    tranchesSelectionnees: "Tranches sélectionnées",
    selectionnerMois: "Sélectionner les mois",
    moisSelectionnes: "Mois sélectionnés",
    elementsSelectionnes: "Éléments sélectionnés",
    changeClassroom: "Changer de classe",
    studentsList: "Liste des élèves inscrits à l'activité",
    activityList: "Liste_des_activités",
    num: "N°",
    ecolePrimairePrivee: "École primaire privée",
    formulaireParent: "Formulaire du parent",
    anneeScolaireLabel: "Année scolaire",
    numero: "Numéro",
    nomPrenom: "Nom et prénom",
    dateNaissance: "Date de naissance",
    nomParent: "Nom du parent",
    telephone: "Téléphone",
    delegeRegionalEducation: "Délégation régionale à l'éducation",
    ficheParentPDF: "Fiche_Parent",
    nonDisponible: "Non disponible",
    classe: "Classe",
    pere: "Père",
    mere: "Mère",
    identifiantUnique: "Identifiant unique",
    nomComplet: "Nom complet",
    sexe: "Sexe",
    garcon: "Garçon",
    fille: "Fille",
    nombreTotal: "Nombre total",
    nombreGarcons: "Nombre de garçons",
    nombreFilles: "Nombre de filles",
    listeElevesPDF: "Liste_des_élèves",
    installmentFees: "Frais des tranches",
    installment: "Tranche",
    selectedPaymentMode: "Le mode de paiement sélectionné est ",
    byInstallments: "par tranches",
    monthly: "mensuelle",
    fees: "Frais",
    included: "Inclus",
    discount: "Réduction",
    changeGroup: "Changer Groupe",
    monthlyPayment: "Paiement mensuel",
    installmentPayment: "Paiement par tranche",
    paymentMode: "Mode de paiement",
    monthly: "Mensuelle",
    byInstallment: "Par tranche",
    globalStatus: "État global",
    notSpecified: "Non précisé",
    sureToCancel: "Êtes-vous sûr d'annuler?",
    sureToDelete: "Êtes-vous sûr de supprimer?",
  },
  buildingType: {
    // Tunisia types
    jardinEnfantsPrive: "Jardin d'enfants privé",
    ecolePrimairePrivee: "École primaire privée",
    collegePrive: "Collège privé",
    lyceePrive: "Lycée privé",
    collegeLyceePrives: "Collège et Lycée privés",
    collegeEcolePrives: "École primaire et Collège privés",
    jardinEnfantEcolePrives: "Jardin d'enfants et École primaire privés",
    jardinEnfantCollegePrives: "Jardin d'enfants et Collège privés",
    jardinEnfantLyceePrives: "Jardin d'enfants et Lycée privé",
    ecoleLyceePrives: "École primaire et Lycée privés",
    jardinEnfantEcoleCollegePrives:
      "Jardin d'enfants, École primaire et Collège privés",
    jardinEnfantCollegeLyceePrives: "Jardin d'enfants, Collège et Lycée privés",
    jardinEnfantEcoleLyceePrives:
      "Jardin d'enfants, École primaire et Lycée privés",
    jardinEnfantEcoleCollegeLyceePrives:
      "Jardin d'enfants, École primaire, Collège et Lycée privés",
    collegeEcoleLyceePrives: "École primaire, Collège et Lycée privés",
    ecolePrivee: "École privée",
    // Kenya types
    preSchoolPrive: "Préscolaire privé",
    prePrimaryPrive: "Pré-primaire privé",
    middlePrive: "École moyenne privée",
    juniorPrive: "Secondaire inférieur privé",
    seniorPrive: "Secondaire supérieur privé",
    middleJuniorPrives: "École moyenne et Secondaire inférieur privés",
    middleSeniorPrives: "École moyenne et Secondaire supérieur privés",
    juniorSeniorPrives: "Secondaire inférieur et Secondaire supérieur privés",
    prePrimaryMiddlePrives: "Pré-primaire et École moyenne privés",
    prePrimaryJuniorPrives: "Pré-primaire et Secondaire inférieur privés",
    prePrimarySeniorPrives: "Pré-primaire et Secondaire supérieur privés",
    prePrimaryMiddleJuniorPrives:
      "Pré-primaire, École moyenne et Secondaire inférieur privés",
    prePrimaryMiddleSeniorPrives:
      "Pré-primaire, École moyenne et Secondaire supérieur privés",
    prePrimaryJuniorSeniorPrives:
      "Pré-primaire, Secondaire inférieur et Secondaire supérieur privés",
    middleJuniorSeniorPrives:
      "École moyenne, Secondaire inférieur et Secondaire supérieur privés",
    prePrimaryMiddleJuniorSeniorPrives:
      "Pré-primaire, École moyenne, Secondaire inférieur et Secondaire supérieur privés",
    preSchoolPrePrimaryPrives: "Préscolaire et Pré-primaire privés",
    preSchoolMiddlePrives: "Préscolaire et École moyenne privés",
    preSchoolJuniorPrives: "Préscolaire et Secondaire inférieur privés",
    preSchoolSeniorPrives: "Préscolaire et Secondaire supérieur privés",
    preSchoolPrePrimaryMiddlePrives:
      "Préscolaire, Pré-primaire et École moyenne privés",
    preSchoolPrePrimaryJuniorPrives:
      "Préscolaire, Pré-primaire et Secondaire inférieur privés",
    preSchoolPrePrimarySeniorPrives:
      "Préscolaire, Pré-primaire et Secondaire supérieur privés",
    preSchoolMiddleJuniorPrives:
      "Préscolaire, École moyenne et Secondaire inférieur privés",
    preSchoolMiddleSeniorPrives:
      "Préscolaire, École moyenne et Secondaire supérieur privés",
    preSchoolJuniorSeniorPrives:
      "Préscolaire, Secondaire inférieur et Secondaire supérieur privés",
    preSchoolPrePrimaryMiddleJuniorPrives:
      "Préscolaire, Pré-primaire, École moyenne et Secondaire inférieur privés",
    preSchoolPrePrimaryMiddleSeniorPrives:
      "Préscolaire, Pré-primaire, École moyenne et Secondaire supérieur privés",
    preSchoolPrePrimaryJuniorSeniorPrives:
      "Préscolaire, Pré-primaire, Secondaire inférieur et Secondaire supérieur privés",
    preSchoolMiddleJuniorSeniorPrives:
      "Préscolaire, École moyenne, Secondaire inférieur et Secondaire supérieur privés",
    preSchoolPrePrimaryMiddleJuniorSeniorPrives:
      "Préscolaire, Pré-primaire, École moyenne, Secondaire inférieur et Secondaire supérieur privés",
  },
  punition: {
    eventTime: "Heure de l'événement",
    createdBy: "Créé par",
    eleve: "Elève",
    nom: "Nom",
    prenom: "Prénom",
    details: "Détails",
    seenByParents: "Vu par les parents",
    noParentSeen: "Aucun parent n'a encore consulté cette punition.",
    notVisibleToParents: "Non visible aux parents",
    notVisibleToParentsHint:
      "Seules les punitions validées sont visibles par les parents.",
    punition: "Punition",
    studentDiscipline: "Discipline de l'élève",
    studentDisciplineList: "Liste de discipline de l'élève",
    temps: "Temps",
    raison: "Raison",
    description: "Description",
    validation: "Validation",
    valides: "Validé",
    rejetes: "Rejeté",
    nonEvalues: "Non évalué",
    dateAjout: "Date d'ajout",
    dateEvalution: "Date d'évalution",
    valider: "Valider",
    rejeter: "Rejeter",
    rejectReason: "La raison du rejet de la punition",
    rejectReasonDiscipline: "La raison du rejet de la discipline de l'élève",
    reasonRequired: "La raison du rejet est requise",
    typeRequired: "Le type de punition est requis",
    typeRequiredDiscipline: "Le type de discipline de l'élève est requis",
    autoValidationMessage:
      "Cette punition sera automatiquement validée. Voulez-vous continuer?",
    autoValidationMessageDiscipline:
      "Cette discipline de l'élève sera automatiquement validée. Voulez-vous continuer?",
    pendingValidationMessage:
      "Cette punition restera en attente jusqu'à sa validation par un administrateur. Voulez-vous continuer?",
    pendingValidationMessageDiscipline:
      "Cette discipline de l'élève restera en attente jusqu'à sa validation par un administrateur. Voulez-vous continuer?",
    errorLoadingPunishments: "Erreur lors du chargement des punitions",
    errorLoadingDisciplines:
      "Erreur lors du chargement des disciplines de l'élève",
    noPunishmentTypeFound: "Aucun type de punition trouvé",
    noDisciplineTypeFound: "Aucun type de discipline de l'élève trouvé",
    timeRequired: "La date et l'heure sont requises",
  },
  days: {
    sunday: "Dimanche",
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
  },
  emploi: {
    hideTeacherUpdated: "L'enseignant a été masqué avec succès",
    hideEmploi: "L'emploi de temps ne sera plus disponible pour les parents",
    validateEmploi: "L'emploi de temps sera disponible pour les parents",
    validatedClassroom: "L'emploi de temps sera disponible pour les parents",
    unvalidatedClassroom:
      "L'emploi de temps ne sera plus disponible pour les parents",
    hideTeacher: "Masquer l'enseignant",
    validated: "L'emploi est maintenant disponibles pour la classe {name}",
    unvalidated: "L'emploi ne est plus disponibles pour la classe {name}",
    hideEmploin:
      "L'emploi de cette classe  ne sera plus disponibles pour les parents",
    validateEmploin:
      "L'emploi de cette classe sera disponibles pour les parents",
    emplois: "Emplois de temps",
    temps: "Temps",
    choisirTemps: "Choisir l'heure",
    trimestre: "Triméstre",
    listeClasses: "Liste des classes",
    listeEnseignants: "Liste des enseignants",
    emploiEnseignants: " Emplois de temps des enseignants ",
    imprimerEmploi: "  Imprimer l'emploi ",
    imprimerEmploiAdministrative: "Imprimer l'emplois administrative",
    pdfRepublique: "République Tunisienne - Ministère de l'Education",
    pdfDelegation: "Délégation Régionale de {delegation}",
    pdfDelegationKE: "Localisation du pays : {delegation}",
    pdfAnnee: "Année Scolaire: {year}",
    pdfImprime: "Imprimé le : {date}",
    pdfEcole: "École primaire privée : {name}",
    pdfEmploi: "Emplois de {className}",
    pdfEmploiTeacher: "Emplois de {teacher}",
    pdfEmploiAdmin: "Emploi administratif",
    enseignant: "Enseignant",
    matiere: "Matière",
    salle: "Salle",
    duree: "Durée",
    classe: "Classe",
    choisirEnseignant: "Choisir un enseignant ",
    choisirMatiere: "Choisir une matière",
    chooseSubmodule: "Choisir un sous-module",
    choisirSalle: "Choisir une salle",
    choisirDuree: "Choisir une durée",
    choisirClasse: "Choisir une classe",
    ajouterSeance: "Ajouter une séance ",
    addSession: "Ajouter une séance",
    modifierSeance: "Modifier une séance ",
    disponible: "Disponible",
    indisponible: "Indisponible",
    modeModif: "Mode modification est activé !",
    desc: "Vous pouvez modifer l'emplacement et la durée des séances !",
    totaleHeures: "Totale des Heures",
    moyenneHeuresJour: "Moyenne des Heures/jour",
    maximunHeuresJour: "Maximum des Heures/jour",
    totaleClasses: "Totale des classes",
    totaleTeachers: "Totale des enseignants",
    seance: "Séance",
    seanceListe: "Liste des séances",
    choisirName: "Choisir un nom pour la séance",
    name: "Nom de la séance",
    includedSubjects: "L'enseignant peut accéder",
    selectedTime: "Heure sélectionnée",
    selectedDay: "Jour sélectionné",
    selectedClass: "Classe sélectionnée",
    group: "Groupe",
    groupOption: "Sélectionner un groupe",
    fullClass: "Classe entière",
    week: "Semaine",
    weekLabel: "Semaine",
    weekOption: "Sélectionner une semaine",
    weekBoth: "Les deux semaines",
    weekA: "Semaine A",
    weekB: "Semaine B",
    modulesPedagogiques: "Modules Pédagogiques",
    modulesPilotes: "Modules Pilotes",
    additionalSubject: "Matière Supplémentaire",
    pedagogicalModule: "Module Pédagogique",
    pilotModule: "Module Pilote",
    today: "Aujourd'hui",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    startTime: "Heure de début",
    duration: "Durée",
    subject: "Matière",
    teacher: "Enseignant",
    room: "Salle",
    group: "Groupe",
    notes: "Notes",
    minutes: "minutes",
    hour: "heure",
    hours: "heures",
    durationFormat: "{hours} H {minutes} m",
    pleaseSelectDay: "Veuillez sélectionner un jour",
    pleaseSelectStartTime: "Veuillez sélectionner l'heure de début",
    pleaseSelectDuration: "Veuillez sélectionner la durée",
    pleaseSelectSubject: "Veuillez sélectionner une matière",
    pleaseSelectTeacher: "Veuillez sélectionner un enseignant",
    pleaseSelectRoom: "Veuillez sélectionner une salle",
    selectDay: "Sélectionner un jour",
    selectStartTime: "Sélectionner l'heure de début",
    selectDuration: "Sélectionner la durée",
    selectSubject: "Sélectionner une matière",
    selectTeacher: "Sélectionner un enseignant",
    selectRoom: "Sélectionner une salle",
    selectGroup: "Sélectionner un groupe",
    addNotes: "Ajouter des notes",
    deleteSession: "Supprimer la séance",
    deleteSessionQuestion: "Voulez-vous supprimer cette séance ?",
    deleteSessionOptions: "Choisissez une option :",
    deleteOnlyThis: "Supprimer seulement cette séance",
    deleteRecurring:
      "Supprimer cette séance et toutes les séances récurrentes similaires (passées et futures)",
    updateSessionOptions: "Options de mise à jour",
    updateSessionQuestion: "Comment voulez-vous mettre à jour cette séance ?",
    updateSessionDescription:
      "Choisissez si vous voulez mettre à jour seulement cette séance ou toutes les séances similaires.",
    updateOnlyThis: "Mettre à jour seulement cette séance",
    updateOnlyThisDescription: "Seule cette séance sera modifiée.",
    updateAllSimilar: "Mettre à jour toutes les séances similaires",
    updateAllSimilarDescription:
      "Toutes les séances avec les mêmes caractéristiques seront mises à jour.",
    updateDuration: "Durée de mise à jour",
    untilEndOfYear: "Cette séance et toutes les suivantes",
    untilEndOfYearDescription:
      "Mettre à jour cette séance et toutes les séances suivantes jusqu'à la fin de l'année scolaire.",
    wholeSchoolYear: "Toutes les séances de l'année scolaire",
    wholeSchoolYearDescription:
      "Mettre à jour toutes les séances de l'année scolaire, y compris les séances passées.",
    customDuration: "Durée personnalisée",
    customDurationDescription: "Choisissez une durée spécifique en mois.",
    enterDurationMonths: "Entrez la durée en mois",
    durationInMonths: "Durée en mois (1-12)",
    enterValidDuration: "Veuillez entrer une durée valide",
    sessionPreview: "Aperçu de la séance",
    sessionName: "Nom de la séance",
    sessionTime: "Heure de la séance",
    teacher: "Enseignant",
    selectEndDate: "Sélectionner la date de fin",
    selectEndDateDescription:
      "Choisissez la date de fin pour les mises à jour en lot",
    selectedDate: "Date sélectionnée",
    restoreSession: "Restaurer la séance",
    restoreSessionConfirm: "Êtes-vous sûr de vouloir restaurer cette séance ?",
    cancelSessionWarning: "Annuler la séance",
    cancelSessionDescription:
      "Cela annulera la séance et toutes ses occurrences",
    cancellationReason: "Raison de l'annulation",
    cancelUntil: "Annuler jusqu'au",
    cancelUntilDescription:
      "Choisissez la date jusqu'à laquelle annuler la séance",
    sessionDetails: "Détails de la séance",
    confrimCancel: "Confirmer l'annulation",
    cancellationReasonRequired: "La raison de l'annulation est requise",
    deleteRecuring: "Supprimer les séances récurrentes",
    cancelSession: "Annuler la séance",
    confirmCancel: "Confirmer l'annulation",
    enterCancellationReason: "Entrez la raison de l'annulation",
    selectCancelUntilDate:
      "Choisissez la date jusqu'à laquelle annuler la séance",
    sessionCanceled: "La séance a été annulée",
    cancelUntilRequired: "La date de fin de l'annulation est requise",
    cancelUntilCannotBePast:
      "La date de fin de l'annulation ne peut pas être dans le passé",
    sessionCanceled: "La séance a été annulée",
  },
  bulletin: {
    ConsielClass: "Conseil du Classe",
    bulletins: "Bulletins",
    annualReport: "Rapport annuel",
    displayOptions: "Options d'affichage",
    teachersByClassroom: "Enseignants (par classe)",
    showDate: "Afficher la date",
    configSaved: "Configuration enregistrée",
    pvAnnuel: "PV Annuel",
    ficheNotes: "Fiche des notes",
    exporterExcel: "Exporter Excel",
    imprimerPV: "Imprimer PV",
    imprimerConseilClasse: "Imprimer PV conseil de classe",
    imprimerPVParNiveau: "Imprimer PV par niveau",
    notesWillBeDeleted: "Ces notes seront supprimées",
    loading: "Chargement...",
    deletingNotes: "Suppression des notes...",
    classroom: "Classe",
    numberOfAffectedNotes: "Nombre des notes affectées",
    student: "Élève",
    subjects: "Matières",
    duplicateSettings: "Dupliquer les paramètres",
    source: "Source",
    targets: "Cible(s)",
    parameters: "Paramètres",
    templates: "Templates",
    schoolYear: "Année scolaire",
    selectSchoolYear: "Sélectionner l'année scolaire",
    selectTemplate: "Sélectionner un template",
    selectTypes: "Sélectionner les types",
    selectLevels: "Sélectionner les niveaux",
    selectTrimesters: "Sélectionner les trimestres",
    allDataDuplicatedSuccess:
      "Toutes les données ont été dupliquées avec succès",
    pleaseRefreshPage: "veuillez actualiser la page pour voir l'effet complet",
    duplicationHappened:
      "Une action de duplication des paramètres s'est produite, veuillez actualiser la page pour voir l'effet complet",
    configureDisplay: "Configurer l'affichage",
    generalConfiguration: "Configuration générale",
    studentName: "Nom de l'élève",
    className: "Nom du classe",
    trimesterName: "Nom du trimestre",
    schoolYear: "Année scolaire",
    orientation: "Orientation",
    positionX: "Position X",
    font: "Font",
    size: "Taille :",
    color: "Couleur :",
    vertical: "Vertical",
    horizontal: "Horizontal",
    centered: "Centré",
    atBeginning: "Au début",
    selectFont: "Select a font",
    textSize: "Taille du text",
    arabicAndFrench: "Arabe et français",
    arabicOnly: "Arabe seulement",
    amiriNormal: "Amiri (Normal)",
    amiriBold: "Amiri (Bold)",
    notoNaskhArabicNormal: "Noto Naskh Arabic (Normal)",
    notoSansArabicBold: "Noto Sans Arabic (Bold)",
    alJazeeraArabicBold: "Al Jazeera Arabic (Bold)",
    imprimerPVNiveaux: "Imprimer PV niveaux",
    changePositions: "Changer les positions",
    fuseSubSubject: "Fusionner les sous-matières",
    showSubModule: "Non de sous-modules",
    hideDate: "Masquer la date",
    hideSubject: "Masquer  les matières",
    useSubModule: "Utiliser sous-modules",
    subModule: "Sous-modules",
    managerSubModule: "Gérer les sous-modules",
    manageCertType: "Gérer les certificates pour :",
    pvSortBy: "Trier par",
    pvSortOrder: "Ordre de tri",
    pvSortAverage: "Moyenne",
    pvSortName: "Nom",
    pvSortAsc: "Croissant",
    pvSortDesc: "Décroissant",
    defaultModule: "Modules par défaut",
    defaultModuleConfirm:
      "Cette action supprimera le module existant. Voulez-vous continuer avec le paramétrage des modules par défaut ?",
    defaultDone: "Les modules par défaut sont enregistrés avec succès",
    alert:
      "Impossible de modifier: veuillez éditer dans le bulletin spécifique",
    avg: "Moyenne Module",
    coefTrimester1: "Coefficient du trimestre 1",
    coefTrimester2: "Coefficient du trimestre 2",
    coefTrimester3: "Coefficient du trimestre 3",
    moyenneGeneral: "Moyenne générale",
    moyenneTrimestreGeneral: "Moyenne du trimestre général",
    moyenneTrimestreGeneralMatieresBase:
      "Moyenne du trimestre général dans les matières de base",
    bulletinCoefs: "Coefficients des bulletins",
    coefBulletinsSaved:
      "Les coefficients des bulletins enregistrés avec succès",
    exempt: "Dispensé",
    alreadyExempt: "Déjà dispensé",
    confirmExemptStudent: "Êtes-vous sûr de vouloir dispenser cet élève ?",
    confirmUnexemptStudent:
      "Êtes-vous sûr de vouloir annuler la dispense de cet élève ?",
    decisionConseil: "Décision du conseil",
    finalBulletin: "Bulletin annuel",
    syncClass: "Synchroniser par classe",
    syncSubject: "Synchroniser par matiére",
    syncMarks: "Synchroniser les notes",
    sureToSync: "Voulez vous écraser les notes ?",
    syncDone: "Notes synchronisées avec succès",
    date: "Date d'impression",
    parametrageSaved: "Le bulletin paramètres enregistrés avec succès",
    label: "Libellé",
    moyennePersonalized: "Moyenne personnalisé par école",
    moyenneSpecifique: "Moyenne Pilote",
    moyennePedagogique: "Moyenne Pédagogique",
    moyenneVerySpecifique: "Moyenne spécifique",
    formulePersonalized: "Formule personnalisé",
    imprimerFichModuleVide: "Fiche vide",
    imprimerFichModule: "Fiche remplie",
    imprimerFichModuleVideAll: "Toutes les fiches vides",
    imprimerFichModuleAll: "Toutes les fiches remplies",
    imprimerFichModuleVideexcel: "Fiche vide Excel",
    imprimerFichModuleexcel: "Fiche remplie Excel",
    certByMoyenne: "Certificats selon moyens éléves",
    imprimerBulletin: "Imprimer le bulletin",
    note: "Note",
    nom: "Nom de l'élève",
    bulletin: "Bulletin Collège / Lycée",
    bulletinV1: "Bulletin (Ancienne version)",
    notes: "Notes",
    matieres: "Matières",
    bulletinPedagogique: "Bulletin Pédagogique",
    bulletinSpecifique: "Bulletin Pilote",
    bulletinVerySpecifique: "Bulletin Spécifique",
    performancesMatiere: "Performances des matière",
    plus15: "Plus de 15 ",
    plus12: "Plus de 12 ",
    plus9: "Plus de 9 ",
    mois9: "Moins de 9 ",
    listeClasses: "Liste des classes",
    classesActives: "Classes actives",
    nombreClassesNonNote: "Nombre de classes non noté",
    tousClassesSontNotes: "Toutes les classes sont notées !",
    nombreMatieresNonNote: "Nombre de matières non noté",
    tousMatieresSontNotes: "Toutes les matières sont notées !",
    nombreElevesNonNotes: "Nombre de élève non noté",
    tousElevesSontNotes: "Toutes les élèves sont notées !",
    classes: "classes",
    toutMatieres: "Toutes les matières",
    toutEleves: "Tous les élèves",
    activeStudents: "Élèves actifs",
    archivedStudents: "Élèves archivés",
    enregistrerTout: "Enregistrer tout",
    parEleve: "Par élève",
    parMatiere: "Par matière",
    typeIntrouvable: "Type introuvable",
    saisirSchoolType:
      "Merci de saisir le type de votre établissement dans le paramétrage - établissement !",
    aucuneDonnee: "Aucune donnée disponible pour ce trimestre",
    confirmPrintMatieres:
      "Les notes des matières ci-dessous ({count}) doit être remplis pour générer le bulletin des notes !",
    confirmPrintEleves:
      "Les notes des élèves ci-dessous ({count}) doit être remplis pour générer le bulletin des notes !",
    generateAnyway: "Générer quand même",
    listeClassesNonNote: "Liste de classes non noté",
    listeMatiereNonNote: "Liste de matières non noté",
    listeEleveNonNote: "Liste d'élève non noté",
    performancesNotes: "Performances des notes",
    notePlusHaute: "Note la plus haute",
    noteEleve: "Note d'élève",
    notePlusBasse: "Note la plus basse",
    moyennesModules: "Moyennes des modules",
    maximaleMoyenne: "Maximale moyenne",
    moyenne: "Moyenne",
    minimaleMoyenne: "Minimale Moyenne",
    imprimerTout: "Imprimer tout",
    moyenneTrimestre: "Moyenne de trimestre : {moyenne}",
    moyenneMax: "Moyenne la plus haute : {moyenne}",
    moyenneMin: "Moyenne la plus basse : {moyenne}",
    validated:
      "Les bulletins sont maintenant disponibles pour la classe {name}",
    unvalidated: "Les bulletins ne sont plus disponibles pour la classe {name}",
    hideBulletin:
      "Les bulletins de cette classe  ne seront plus disponibles pour les parents",
    validateBulletin:
      "Les bulletins de cette classe seront disponibles pour les parents",
    cancelValidation: "Mettre indisponible pour les parents",
    validatedClassroom: "Mettre disponible pour les parents",
    deleteMark: "Voulez-vous supprimer la note ?",
    markDeletedSucc: "Note a éte supprimé avec succès",
    markDeletedFail: "On ne peut pas supprimer cette note, merci de résseyer !",
    showStamp: "Afficher le cachet",
    PersonalizedAverage: "Utiliser la moyenne personnalisée",
    notesManquantes: "Notes manquantes",
    Module: "Module",
    SubModule: "Sous-module",
    noTemplateFound:
      "Le bulletin n'est pas configuré, veuillez ajouter une configuration d'abord",
    showNbrStudents: "Afficher le nombre d'élèves inscrits",
    bulletinNotDispo: "Bulletin non disponible",
    bulletinDispo: "Bulletin disponible",
    parentVisibility: "Visibilité parent",
    directorNotesOnBehaviorAndAttendance:
      "Notes du directeur sur le comportement et l'assiduité",
    destination: "Destination",
    pleaseSelectOrTypeAppreciation:
      "Veuillez sélectionner ou saisir une appréciation",
    pv: "PV",
    pvExcel: "PV (Excel)",
    format: "Format",
    formatAnnuel: "Format annuel",
    cannotModifyEditIn:
      "Impossible de modifier: veuillez éditer dans le {type}, module: {name}",
    module: "module",
    noLevelsAvailable: "Aucun niveau disponible pour ce type de établissement",
  },
  markHistory: {
    action: "Action",
    action_create: "Création",
    action_delete: "Suppression",
    action_update: "Modification",
    after: "Après",
    before: "Avant",
    date: "Date",
    empty: "Aucune modification de note enregistrée",
    role: "Rôle",
    title: "Historique des modifications de notes",
    user: "Utilisateur",
    viewHistory: "Historique",
  },
  bulletinStatistics: {
    totalWithoutAverage: "Total des non-propriétaires d'une moyenne",
    totalWithAverage: "Total des propriétaires d'une moyenne",
    schoolStatistics: "Statistiques scolaires",
    level: "Niveau",
    equalsOrExceeds16: "Égal ou supérieur à 16",
    between15And1599: "Entre 15 et 15.99",
    between10And1499: "Entre 10 et 14.99",
    lessThan10: "Moins de 10 sur 20",
    exceeds15: "Supérieur à 15",
    exceeds10To15: "Supérieur à 10 jusqu'à 15",
    equals10: "Égal à 10 sur 20",
    from5ToLessThan10: "De 5 à moins de 10 sur 20",
    lessThan5: "Moins de 5 sur 20",
    student: "Élève",
    levelSuffix: "e",
  },
  personnel: {
    nom: "Nom",
    prenom: "Prénom",
    adresse: "Adresse",
    telephone: "Téléphone",
    qualification: "Qualification",
    dateNaissance: "Date de naissance",
    typeContrat: "Type du contrat",
    salaire: "Salaire",
    cin: "CIN",
    idCard: "Numéro de carte d'identité",
    etatCivil: "Etat civil",
    niveau: "Niveau",
    experiences: "Expériences",
    dateEntretien: "Date de l'entretien",
    qualifications: "Qualifications",
    tauxHoraire: "Taux horaire",
    detailPaiement: "Détails de paiement",
    jourSemaine: "Jours par semaine",
    expectedHoursPerDay: "Heures attendues / jour",
    daysOff: "Jours de repos",
    daysOffPlaceholder: "Sélectionner les jours off",
    weekday_0: "Dimanche",
    weekday_1: "Lundi",
    weekday_2: "Mardi",
    weekday_3: "Mercredi",
    weekday_4: "Jeudi",
    weekday_5: "Vendredi",
    weekday_6: "Samedi",
    expectedTeachingHours: "Heures d'enseignement / matière / semaine",
    expectedTeachingHoursHint: "Choisissez une matière et saisissez les heures par semaine",
    hoursPerWeek: "Heures / semaine",
    addSubjectHours: "Ajouter une matière",
    attendanceConfig: "Configuration assiduité",
    cnss: "CNSS",
    rib: "RIB",
    pin: "PIN (Impôt)",
    sha: "SHA (Santé)",
    nssf: "NSSF (Fonds National de Sécurité Sociale)",
    bankAccountNo: "Numéro de compte bancaire",
    bankName: "Nom de la banque",
    bankBranch: "Agence bancaire",
    autre: "Autre",
    notes: "Notes",
    infoBase: "Informations de base",
    infoContrat: "Informations sur le contrat",
    chercher: "Chercher",
    listeQualifications: "Liste des qualifications",
    staff: "Staff",
    gestionPaiements: "Gestion des paiements du personnel",
    chercherParNom: "Chercher par nom",
    nbPersonnel: "Nombre de personnel",
    infoPersonnel: "Informations du personnel",
    type: "Type",
    personnel: "Personnel",
    enseignant: "Enseignant",
    personalList: "Liste du personnel",
    totalSalary: "Total des salaires",
    listPersonnelPDF: "Liste_personnel",
    etatPaiePersonnels: "Etat de paie personnels",
  },
  enseignant: {
    advisorAddExercice: "Possibilité d'ajouter des exercices",
    advisorAddNews: "Possibilité d'ajouter des actualités",
    advisorValidateNews: "Possibilité de valider les actualités",
    newsPermissions: "Permissions des actualités",
    addAccess: "Ajouter des accès à l'enseignant",
    selectClassMessage:
      "Veuillez choisir une classe parmi celles affectées à l'enseignant",
    nom: "Nom",
    prenom: "Prénom",
    adresse: "Adresse",
    telephone: "Téléphone",
    qualification: "Qualification",
    dateNaissance: "Date de naissance",
    typeContrat: "Type du contrat",
    salaire: "Salaire",
    cin: "CIN",
    etatCivil: "Etat civil",
    niveau: "Niveau",
    experiences: "Expériences",
    dateEntretien: "Date de l'entretien",
    qualifications: "Qualifications",
    tauxHoraire: "Taux horaire",
    detailPaiement: "Détails de paiement",
    jourSemaine: "Jours par semaine",
    cnss: "CNSS",
    rib: "RIB",
    autre: "Autre",
    notes: "Notes",
    infoBase: "Informations de base",
    infoContrat: "Informations sur le contrat",
    chercher: "Chercher",
    listeQualifications: "Liste des qualifications",
    matiere: "Matière",
    specialite: "Spécialité",
    grade: "Grade",
    email: "Email",
    mdp: "Acceés",
    compte: "Compte",
    detailPedagogiques: "Détails pédagogiques",
    usernameEmail: "Nom d'utilisateur/email",
    photo: "Photo",
    conseillersPedagogiques: "Les conseillers pédagogiques",
    ajouterConseillerPedagogique: "Ajouter un conseiller pédagogique",
    enterInfoConseillerPedagogique:
      "Entrez les informations du conseiller pédagogique dans les champs ci-dessous",
    niveauxSuperviser: "Les niveaux a supervisés",
    niveauxRequis: "Les niveaux sont requis",
    listeNiveaux: "Liste des niveaux",
    aucunConseillerPedagogique: "Aucun Conseiller pédagogique est trouvé",
    needValidation: "validation automatique des cours et des exercises",
    needValidation2: " et des exercises",
    needNewsValidation: "Validation automatique des actualités",
    teacherAddNews: "Possibilité d'ajouter des actualités",
    permissionsValidation: "Permissions de validation",
    listeEnseignantsPDF: "Liste_Enseignants",
    listeConseillersPedagogiquesPDF: "Liste_Conseillers_Pedagogiques",
    listeConseiller: "Liste des Conseiller pédagogiques",
    deactivateOrActivateTeacherAccount:
      "Désactiver ou activer compte enseignant",
    teacherQrCode: "QR code enseignant",
    modifyTeacherAccessSubtitle:
      "Modifier les accès des enseignants pour faciliter la gestion des notes et du contenu pédagogique dans EdTeacher.",
    educationalAdvisor: "Conseiller pédagogique",
    duplicate: "Dupliquer",
    duplicateAccessForTeacher: "Dupliquer l'accès pour l'enseignant",
    duplicateAllTeachers: "Dupliquer tous les enseignants",
    duplicateAccessForAllTeachers:
      "Dupliquer l'accès pour tous les enseignants",
    accessLevelAddedSuccessfully: "Niveau d'accès ajouté avec succès",
    accessLevelNotAdded: "Niveau d'accès non ajouté",
    revokedAccessFrom: "Accès révoqué de",
    onModules: "sur les modules",
    unknownModule: "Module inconnu",
  },
  etatPaiement: {
    personnel: "Personnel",
    salaire: "Salaire",
    avance: "Avance",
    nbJours: "Nombre de jours",
    mois: "Mois",
    etatPaiement: "Etat de paiement",
    virementBancaire: "Virement bancaire",
    paiementAction: "Paiement",
    selectionnerMois: "Sélectionner un mois",
    selectionnerFrais: "Sélectionnez les frais à payer",
    totalAvances: "Total des avances",
    frais: "Frais",
    montant: "Montant",
    fraisAPayer: "Frais à payer",
    inscription: "Inscription",
    tranche: "Tranche",
    toutAfficher: "Tout afficher",
    toutMasquer: "Tout masquer",
    payerAvecAvance: "Payer avec avance",
    sansAvance: "Sans avance",
    activerPaiementAvance: "Activer le paiement avec avance",
    montantAvance: "Montant avance (TND)",
    saisirMontant: "Saisir le montant",
    fraisNonPayes: "frais non payés",
    reste: "Reste",
    avanceAppliquee: "Avance appliquée",
    restePayer: "Reste à payer",
    paiementPartiel: "Paiement partiel - montant restant à payer",
    montantInvalide:
      "Le montant d'avance saisi ne permet pas de couvrir ce frais. Veuillez saisir un montant d'avance supérieur.",
    montantInvalide:
      "Le montant d'avance saisi ne permet pas de couvrir ce frais. Veuillez saisir un montant d'avance supérieur.",
    selectionnerTout: "Sélectionner tout",
    deselecTout: "Désélectionner tout",
    montantSupTotal:
      "Le montant d'avance saisi est supérieur au montant total des frais à payer. montant avance doit être inférieur ou égal à",
    montantInsuffisant:
      "Le montant d'avance saisi ne permet pas de couvrir tous les frais. Veuillez saisir un montant d'avance supérieur.",
    paiementsPersonnels: "Paiements Personnels",
    attendanceReference: "Référence assiduité (enseignant)",
    attendanceReferenceHint:
      "Informations indicatives pour le mois sélectionné. Les champs jours/heures ne sont pas remplis automatiquement.",
    noAttendanceData: "Aucune donnée d'assiduité pour ce mois.",
    attendanceDetails: "Détails",
    attendanceDetailsTitle: "Détail des séances",
    attendanceSource: "Source",
    attendanceSourceCheckin: "Pointage",
    attendanceSourceManual: "Manuel",
    reste: "Reste",
    scolarite: "Scolarité",
    activite: "Activité",
  },
  hr: {
    nbHeures: "Nb hrs/semaine",
    nbJours: "Nb jrs/semaine",
    espece: "Espèce",
    cheque: "Chèque",
    modePaiement: "Mode de paiement",
    modifierPaiement: "Modifier le paiement",
    paiementModifie: "Le paiement a été modifié avec succès",
    paiementSupprime: "Le paiement a été supprimé avec succès",
  },
  virement: {
    rib: "RIB",
    nom: "Nom",
    prenom: "Prénom",
    etatPaiement: "Etat de paiement",
    salaire: "Salaire",
    mois: "Mois",
    nbJours: "Nombre de jours",
    chercher: "Chercher",
  },
  recette: {
    fournisseurProfil: "Profil du fournisseur",
    checksDueThisWeek: "Les chèques qui échéance cette semaine",
    anneeScolaire: "Année scolaire",
    dateAjout: "Date d'ajout",
    doneBy: "Ajouté par",
    cancelledBy: "Annulé par",
    actions: "Actions",
    detailsReglement: "Détails du règlement",
    infosGenerales: "Informations générales",
    repartitionMontants: "Répartition des montants",
    lignesReglement: "Lignes du règlement",
    periodeHint:
      "La période n'est prise en compte que pour les années scolaires sélectionnées. Les factures et reçus des autres années ne sont pas inclus, même s'ils tombent dans l'intervalle de dates.",
    montantRequis: "Le montant est requis et doit étre un chiffre",
    montantCheque: "Montant chèque",
    montantEspece: "Montant espèce",
    montantTraite: "Montant traite",
    montantTPE: "Montant TPE",
    montantVirement: "Montant virement",
    montantTotal: "Montant total",
    typePaiement: "Type de paiement",
    montant: "Montant",
    nom: "Nom du client",
    typeRecete: "Type du recette",
    typeReglement: "Type du règlement",
    modePaiement: "Mode de paiement",
    receiptType: "Type Recette",
    montantHT: "Montant HT",
    montantTTC: "Montant TTC",
    type: "Type",
    datePaiement: "Date de paiement",
    numCheque: "Numéro du chèque",
    imprimer: "Imprimer ",
    csv: "CSV",
    tous: "Tous",
    cheque: "Chèque",
    espece: "Espèce",
    chequeEtEspece: "Chèque et espèce",
    detailsPaymentDist: "Détails de distribution des payments",
    numero: "Numéro",
    titulaire: "Titulaire",
    banque: "Banque",
    dateEcheance: "Date d'échéance",
    chequeMontantTotal: "Montant total des chèques",
    relatedPayments: "Paiements liés",
    fermer: "Fermer",
    ok: "Ok",
    typeJournal: "Type du journal",
    selectionnerDate: "Sélectionner une date",
    motCles: "Mots clés",
    chercher: "Chercher",
    bouillard: "Bouillard caisse",
    annule: "Annulé",
    personnel: "Personnel",
    salaire: "Salaire",
    avance: "Avance",
    avanceAPayer: "Avance à payer",
    invoicesCanOnlyBeCredited:
      "Les factures ne peuvent être que créditées (avoir)",
    listeReglements: "Liste de règlements",
    nbJours: "Nombre de jours",
    mois: "Mois",
    etatPaiement: "Etat de paiement",
    virementBancaire: "Virement bancaire ?",
    typeDepense: "Type de dépense",
    date: "Date",
    dateDebutPlaceholder: "Sélectionner la date de début",
    dateFinPlaceholder: "Sélectionner la date de fin",
    fournisseur: "Fournisseur",
    numSerie: "Numéro de série",
    nomParent: "Nom du parent",
    dateAnnulation: "Date d'annulation",
    facture: "Facture ?",
    impression: "Impression",
    annulation: "Annulation",
    paiementQuoi: "Frais",
    selectionnerParent: "Sélectionner le parent",
    selectionnerEnfant: "Sélectionner l'enfant",
    titre: "Titre",
    valider: "Valider",
    recuPaiement: "Reçu de paiement",
    facturePaiement: "Facture de paiement",
    paiementTotal: "Paiement Total ?",
    paiementPour: "Paiement pour ",
    restePayer: "Reste à payer",
    payer: "Payer",
    payerMain: "Payer maintenant ?",
    reducRepet: "Réduction par défaut",
    reducFact: "Réduction Sur cette facture",
    reducRecu: "Réduction Sur ce recu",
    reducInscri: "Réduction sur Inscription",
    reductionMensuel: "Réduction mensuelle",
    fraisInscri: "Frais d'inscription",
    fraisMensuel: "Frais mensuels",
    ajouterPaiement: "Ajouter un paiement",
    montantRestant: "Montant restant",
    inscription: "Inscription",
    telephone: "Téléphone",
    frais: "Frais",
    enfant: "Enfant",
    activite: "Activité",
    tousMois: "Tous les mois",
    montantHTVA: "Montant HTVA",
    nonSeule: "Non (une seule fois)",
    payeQues: "Payé ?",
    recus: "Récus",
    factureTag: "Facture",
    traite: "Traite",
    virement: "Virement",
    TPE: "TPE",
    avantReduction: " Avant réduction",
    apresReduction: " Aprés réduction",
    reduction: " Réduction",
    saisirInfoCheque: "Saisir les informations du chèque",
    saisirInfoChequeEtEspace: "Saisir les informations des chèques et espéce",
    timbreFiscal: "Timbre Fiscal",
    associatedCheques: "Chèques associés",
    associatedTraites: "Traites associées",
    associatedTPE: "TPE associé",
    associatedVirements: "Virements associés",
    saisirInfoTraite: "Saisir les informations des traites",
    saisirInfoTPE: "Saisir les informations TPE",
    versable: "Versable ?",
    transactionId: "ID de transaction",
    nonTransfere: "Non collectés",
    transfere: "Collectés",
    paiementEffectue: "Paiement effectué",
    saisirInfoVirement: "Saisir les informations de virement",
    replacedCheques: "Chèques remplacés par espèce",
    chequeTraite: "Chèques et Traites",
    borderaux: "Bordereaux",
    stat: "Statistiques",
    file: "Fichier",
    replacedBy: "Remplacé par",
    viewFile: "Voir le fichier",
    uploadFile: "Télécharger un fichier",
    erreurChargementDonnees: "Erreur lors du chargement des données",
    selectionnerModePaiement: "Selectionner le mode de paiement",
    montantsNonEgaux: "Les montants saisis ne sont pas égaux au montant total",
    paiementAjoute: "Paiment ajouté",
    paiementNonEffectuer: "Paiement non effectuer",
    typeFactureFeesRestants:
      "Vous ne pouvez pas choisir le type 'Facture' lorsque des frais sélectionnés ont des montants restants à payer. Veuillez d'abord régler les montants restants ou choisir le type 'Reçu'.",
    sommeMontantsEgal: "La somme des montants doit être égale à {amount}",
    montantEgal: "Le montant doit être égale à {amount}",
    parentAnd: "Et",
    nonValid: "vous ne pouvez pas valider un paiement d'un montant égal à zéro",
    payWithAvance: "Payer avec avance",
    payWithoutAvance: "Payer sans avance",
    selectAdvances: "Selectionnez les avances a utilisier",
    parentBalance: "Solde parent",
    advanceAmountLabel: "Montant avance",
    advanceAmountPlaceholder: "Montant de l'avance",
    remainingToPay: "Reste a payer",
    index: "Indice",
    payable: "Versable",
    nonPayable: "Non versable",
    addCheque: "Ajouter un chéque",
    chequeAmount: "Montant chèque",
    cashAmount: "Montant espèce",
    incorrectAmountsInfo:
      "Les informations sur les montants des chèques et le montant en espèces sont incorrectes, veuillez les corriger avant de distribuer les montants",
    totalAmountMustBe: "Le montant total doit être",
    selectFeesToPay: "Selectionnez les frais a payer",
    education: "Scolarité",
    addDate: "Date d'ajout",
    chequeAmountColumn: "Montant chèque",
    advanceAmountColumn: "Montant avance",
    invoiceNumber: "Facture N.",
    receiptNumber: "Reçue N.",
    fullName: "Nom et Prénom",
    child: "Enfant",
    baseReduction: "réduction de base",
    totalAmountIs: "Le montant total est",
    page: "Page",
    advanceDebited: "Avance débiter du solde parent avec succées",
    sumChequeCashEqual:
      "La somme des montants chèque et espèce doit être égale à {amount}",
    tranche: "Tranche",
    paymentMethod: {
      ESPESE: "Espèce",
      CHEQUE: "Chèque",
      TPE: "TPE",
      TRAITE: "Traite",
      VIREMENT: "Virement",
      VERSEMENT: "Versement",
    },
    fluxType: {
      ALIMENTATION_P: "Alimentation caisse principale",
      ALIMENTATION_SOUS_CAISSES: "Alimentation sous caisses",
      VERSEMENT: "Versement",
      COLLECTE_SOUS_CAISSES: "Collecte sous caisses",
      CHEQUE_TRAITE_BANQUE: "Transfert de chèque/traite vers banque",
      CHEQUE_TRAITE_CASH_REPLACEMENT:
        "Remplacement de chèque/traite par espèce",
    },
    stats: {
      financialDashboard: "Statistiques Chèques, Traites et Virements",
      paymentsOverview: "Vue d'ensemble des paiements et transactions",
      bankStatus: "Statut Bancaire",
      generalStatus: "Statut Général",
      rejectedChequesAlert: "Attention : Paiements rejetés non résolus",
      rejectedPayments: "paiements rejetés",
      rejectedPayment: "paiement rejeté",
      forTotalAmount: "pour un montant total de",
      elements: "éléments",
      transactions: "transactions",
      loadingStatsError: "Erreur lors du chargement des statistiques",
    },
    pdfGenerationError: "Une erreur est survenue lors de l'impression",
    pdfDailyFeesCount: "{count} séances",
    effectuePar: "Effectué par",
    parent: "Parent",
    nSerie: "N° Série",
    toutesDates: "Toutes les dates",
    depensesAnnule: "Dépenses annulées",
    montantTotalText: "Le montant total est",
    tags: "Tags",
    totalSansReduction: "Total sans réduction",
    totalHTVA: "Total HTVA",
    tva: "TVA",
    totalTTC: "Total TTC",
    dateRangeFrom: "du",
    dateRangeTo: "au",
    csvLabelTypeDepense: "Type de dépense",
    csvLabelDate: "Date",
    csvLabelMontantTTC: "Montant TTC",
    csvLabelFournisseur: "Fournisseur",
  },
  encaissement: {
    paymentMethod: "Mode de paiement",
    cash: "Espèce",
    cheque: "Chèque",
    tpe: "TPE",
    draft: "Traité",
    transfer: "Virement",
    cashRegister: "Caisse",
    selectCashRegister: "Sélectionner une caisse",
    period: "Période",
    monthlyPayment: "Paiement mensuel",
    singlePayment: "Paiement unique",
    installmentPayment: "Paiement par tranche",
    activity: "Activité",
    schooling: "Scolarité",
    fees: "Frais",
    monthly: "Mensuelle",
    installments: "Par tranche",
    stateOfReceipts: "Etat des recettes",
    creditNote: "Avoir",
    summaryByPaymentMethod: "Résumé par mode de paiement",
    totalGeneral: "TOTAL GÉNÉRAL",
    stateOfUnpaid: "Etat des impayés",
    schoolingStateOfUnpaid: "Scolarité : Etat des impayés",
    activitiesStateOfUnpaid: "Activités : Etat des impayés",
    invoicesCanOnlyBeCredited:
      "Les factures ne peuvent être que créditées (avoir)",
    quantite: "Quantité",
    eleve: "Élève",
    pdfTableHeaders: {
      clientName: "Nom client",
      telephone: "Téléphone",
      child: "Enfants",
      fees: "Frais",
      amount: "Montant",
      total: "Total",
    },
    pdfTotal: "Total",
    pdfCurrencySuffix: "DT",
    pdfFileName: "Etat_des_impayés",
  },
  scolaritePdf: {
    total: "Total",
    registration: "Inscription",
    schooling: "Scolarité",
    activities: "Activités",
    levels: "Les niveaux",
    allLevels: "Tous les niveaux",
    installment: "Tranche {number}",
    legendPaid: "Payé",
    legendUnpaid: "Impayé",
    legendPaidPartially: "Payé partiellement",
    legendPaidWithDiscount: "Payé avec réduction",
    totalDiscountAmount: "Montant total des réductions",
    totalAdvancePayments: "Total des avances",
  },
  caisse: {
    caisse: "Caisse",
    SUBCAISSE: "Sous-caisse",
    BANK: "Banque",
    PRINCIPAL: "Principale",
    fermerCaisse: "Fermer la caisse",
    ouvrirCaisse: "Ouvrir la caisse",
    caisseOuverte: "Caisse ouverte avec succès",
    caisseFermee: "Caisse fermée avec succès",
    caisseFermeeMessage: "Caisse fermée",
    caisseOuvertureAutomatique:
      "La caisse sera ouverte automatiquement après le paiement",
    erreurOuverture: "Erreur lors de l'ouverture de la caisse",
    erreurFermeture: "Erreur lors de la fermeture de la caisse",
    confirmationOuverture: "Confirmation d'ouverture",
    confirmationFermeture: "Confirmation de fermeture",
    messageOuverture: "Voulez-vous vraiment ouvrir la caisse ?",
    messageFermeture: "Voulez-vous vraiment fermer la caisse ?",
    erreurAlimentation: "Erreur lors de l'alimentation de la caisse",
    aucuneCaisseAssigne: "Aucune caisse assignée",
    aucuneCaisseAssigneDesc:
      "Vous n'avez aucune caisse assignée pour le moment.",
    ajouterCaisse: "Ajouter une caisse",
    modifierCaisse: "Modifier la caisse",
    gererCaisses: "Gérer les caisses",
    detailsCaisse: "Détails de la caisse",
    proprietaire: "Propriétaire",
    proprietaires: "Propriétaires",
    selectionnerCaisse: "Sélectionner une caisse",
    toutesLesAnnees: "Toutes les années",
    anneeScolaireColonne: "Année scolaire",
    balance: "Solde",
    statut: "Statut",
    type: "Type",
    nom: "Nom",
    reference: "Référence",
    banque: "Banque",
    disponibilite: "Disponibilité",
    actif: "Actif",
    inactif: "Inactif",
    ouverte: "Ouverte",
    fermee: "Fermée",
    enregistrer: "Enregistrer",
    desactiver: "Désactiver",
    activer: "Activer",
    general: "Général",
    modifier: "Modifier",
    acces: "Accès",
    transfers: "Transferts",
    historique: "Historique",
    totalDebits: "Total des débits",
    totalCredits: "Total des crédits",
    debit: "Débit",
    credit: "Crédit",
    nombreCheques: "Nombre de chèques",
    montantCheques: "Montant des chèques",
    montantTotalCheques: "Montant total des chèques",
    nombreTraites: "Nombre de traites",
    montantTraites: "Montant des traites",
    montantTotalTraites: "Montant total des traites",
    nombreTPE: "Nombre TPE",
    montantTPE: "Montant TPE",
    montantTotalTPE: "Montant total TPE",
    nombreVirements: "Nombre de virements",
    montantVirements: "Montant des virements",
    montantTotalVirements: "Montant total des virements",
    montantEspeces: "Montant espèces",
    alerteGestionTransactions:
      "La gestion des transactions entre caisses est uniquement disponible dans le profil de la caisse principale.",
    nomRequis: "Nom requis",
    referenceRequise: "Référence requise",
    typeRequis: "Type requis",
    nomBanque: "Nom de la banque",
    caisseAjouteeSucces: "Caisse ajoutée avec succès",
    erreurAjoutCaisse: "Erreur lors de l'ajout de la caisse",
    erreurChargementCaisses: "Erreur lors du chargement des caisses",
    erreurChargementCaisse: "Erreur lors du chargement de la caisse",
    settings: "Paramètres",
    label: "Libellé",
    lePorteur: "Le porteur",
    disponibiliteUpper: "DISPONIBILITÉ",
    typeUpper: "TYPE",
    statutUpper: "STATUT",
    actions: "ACTIONS",
    caisseModifieeSucces: "Caisse modifiée avec succès",
    erreurModificationCaisse: "Erreur lors de la modification de la caisse",
    caisseDesactiveeSucces: "Caisse désactivée avec succès",
    erreurDesactivationCaisse: "Erreur lors de la désactivation de la caisse",
    caisseActiveeSucces: "Caisse activée avec succès",
    erreurActivationCaisse: "Erreur lors de l'activation de la caisse",
    utilisateursAutorises: "Utilisateurs autorisés",
    accesALaCaisse: "Accès à la caisse",
    selectionnerUtilisateur: "Sélectionner un utilisateur",
    roles: "Rôles",
    lire: "LIRE",
    ecrire: "ECRIRE",
    proprietaireRole: "PROPRIETAIRE",
    roleDepense: "DÉPENSE",
    roleDepenseEncaissement: "Dépense — encaissement (réceptions, avoirs)",
    ajouterUtilisateur: "Ajouter un utilisateur",
    enregistrerAcces: "Enregistrer les accès",
    veuillezRemplirChamps: "Veuillez remplir tous les champs requis",
    exactementUnProprietaire:
      "Il doit y avoir exactement un propriétaire (OWNER)",
    auMoinsUnProprietaire:
      "La caisse doit avoir au moins un propriétaire (OWNER)",
    utilisateurEnDouble:
      "Un utilisateur ne peut apparaître qu'une seule fois dans les accès",
    accesMisAJour: "Accès mis à jour",
    erreurMiseAJourAcces: "Erreur lors de la mise à jour des accès",
    erreurChargementUtilisateurs: "Erreur lors du chargement des utilisateurs",
    nouveauTransfert: "Nouveau transfert",
    reglesCollectePartielle: "Règles de collecte",
    montantDemande: "Montant demandé",
    especesDisponibles: "Espèces disponibles",
    collectePartielleEspecesUniquement:
      "Le montant demandé dépasse les espèces disponibles.",
    collecteTotaleTousModes:
      "La collecte totale peut inclure tous les modes de paiement sans restriction.",
    modesNonEspecesCollecteTotale:
      "Le TPE et les autres modes de paiement ne peuvent pas être collectés partiellement. Ils doivent être collectés intégralement.",
    pourMontantPrecis: "Pour obtenir un montant précis",
    etapeCollecterTout:
      "Effectuez une collecte totale avec « Tout collecter ».",
    etapeTransfererMontant:
      "Transférez ensuite le montant souhaité vers une sous-caisse.",
    typeDeFlux: "Type de flux",
    libelle: "Libellé",
    montant: "Montant",
    toutCollecterBtn: "Tout collecter",
    veillezSelectionnerTypeFlux:
      "Veuillez d'abord sélectionner le type de flux pour continuer la saisie du transfert.",
    veillezSelectionnerTypeFluxMessage: "Veuillez sélectionner le type de flux",
    veillezSaisirLibelle: "Veuillez saisir un libellé",
    veillezSaisirMontant: "Veuillez saisir un montant",
    selectionnerTypeAlimentation: "Sélectionnez le type d'alimentation",
    veillezSelectionnerType: "Veuillez sélectionner un type",
    caisseSource: "Caisse source",
    caisseDestination: "Caisse destination",
    selectionnerCaisseSource: "Sélectionnez la caisse source",
    selectionnerCaisseDestination: "Sélectionnez la caisse destination",
    veillezSelectionnerCaisseSource: "Veuillez sélectionner une caisse source",
    veillezSelectionnerCaisseDestination:
      "Veuillez sélectionner une caisse destination",
    commentaire: "Commentaire",
    ajouterCommentaire: "Ajoutez un commentaire (optionnel)",
    commentaireMaxCaracteres:
      "Le commentaire ne doit pas dépasser 500 caractères",
    paymentsEffectues: "Payements effectués",
    valider: "Valider",
    transactionsDeLaCaisse: "Transactions de la caisse",
    alimentationEffectueeSucces: "Alimentation effectuée avec succès",
    alimentationCaissePrincipale: "Alimentation du caisse principale",
    alimentationSousCaisses: "Alimentation des sous-caisses",
    versement: "Versement",
    collecteSousCaisses: "Collecte sous-caisses",
    caisseBanque: "Caisse Banque",
    augmentationCapital: "Augmentation de capital",
    fonds: "Fonds",
    historiqueTransactions: "Historique des transactions",
    dateColonne: "Date",
    typeDeFluxColonne: "Type de flux",
    montantColonne: "Montant",
    sourceColonne: "Source",
    destinationColonne: "Destination",
    utilisateurColonne: "Utilisateur",
    actionsColonne: "Actions",
    details: "Détails",
    detailsTransaction: "Détails de la transaction",
    utilisateurTransaction: "Utilisateur",
    typeDeCollecte: "Type de collecte",
    totale: "Totale",
    partielle: "Partielle",
    etatCaisses: "État des caisses au moment de la transaction",
    etatCaisseSource: "État Caisse Source",
    etatCaisseDestination: "État Caisse Destination",
    erreurChargementTransactions: "Erreur lors du chargement des transactions",
    erreurRecuperationSolde:
      "Erreur lors de la récupération du solde de la caisse",
    transactions: "Transactions",
    erreurChargementStatistiques: "Erreur lors du chargement des statistiques",
    nombrePaiementEspeces: "Nombre de paiment en espèces",
    montantTotalPaiementEspeces: "Montant total des paiment en espèces",
    nombrePaiementTPE: "Nombre de paiment TPE",
    montantTotalPaiementTPE: "Montant total des paiment TPE",
    typeEncaissement: "Encaissement",
    typeInverseEncaissement: "Encaissement inverse",
    typeAvoirCredit: "Encaissement avoir fournisseur",
    inverseDetailMissing:
      "Aucun échéancier de réception n'est lié à ce paiement pour afficher le détail.",
    typeDecaissement: "Décaissement",
    typeColonne: "Type",
    descriptionColonne: "Description",
    journalCaisseTitle: "Journal Caisse",
    dateImpression: "Date d'impression",
    dateHeure: "Date et heure",
    touteLaPeriode: "Toute la période",
    statutCollecte: "Statut collecte",
    totalRecettes: "Total recettes",
    totalDepenses: "Total dépenses",
    balanceTable: "Balance",
    totalEncaissements: "Total encaissements",
    totalDecaissements: "Total décaissements",
    facturesAnnulees: "Factures / reçus annulés",
    depenseLabel: "Paiement dépense",
    beneficiary: "Bénéficiaire",
  },
  tresorerie: {
    chequeTraitePdf: "cheques-traites",
    bordereauPdf: "Bordereau",
    avoirs: "Avoirs",
    chequesTraites: "Chèques et traites",
    bordereaux: "Les Bordereaux",
    statistiques: "Statistiques",
    listeReglementAnnule: "Liste des règlements annulés",
    recherche: "Recherche globale",
    type: "Type",
    statut: "Statut",
    statutDepot: "Statut Dépôt",
    numero: "Numéro",
    description: "Description",
    montant: "Montant",
    date: "Date",
    dateCreation: "Date création",
    dateDepotPrevue: "Date dépôt prévue",
    dateDepotEffective: "Date dépôt effective",
    caisse: "Caisse",
    banque: "Banque",
    titulaire: "Titulaire",
    note: "Note",
    selectionnerType: "Sélectionner type",
    filtrerParNom: "Filtrer par nom",
    recherchreParNumeroDescription: "Rechercher par numéro ou description",
    statutBanque: "Statut Banque",
    statutGeneral: "Statut Général",
    statutDuDepot: "Statut du dépôt",
    statutDuBordereau: "Statut du bordereau",
    selectionnerTypeBordereau: "Sélectionner le type de bordereau",
    dateDepotPrevuePlaceholder: "Date de dépôt prévue",
    dateDepotEffectivePlaceholder: "Date de dépôt effective",
    nomTitulaire: "Nom du titulaire",
    noteOptionnelle: "Note optionnelle",
    descriptionBordereau: "Description du bordereau",
    selectionnerCaisse: "Sélectionner une caisse",
    nouveauBordereau: "Nouveau Bordereau",
    toutSelectionner: "Tout sélectionner",
    toutDeselectionner: "Tout désélectionner",
    modifier: "Modifier",
    supprimer: "Supprimer",
    voir: "Voir",
    details: "Détails",
    gererCheques: "Gérer les chèques",
    enAttente: "En attente",
    valide: "Validé",
    rejete: "Rejeté",
    nonDepose: "Non déposé",
    depose: "Déposé",
    traite: "Traité",
    annulation: "Annulation",
    avoir: "Avoir",
    cheque: "Chèque",
    traiteType: "Traite",
    numSerie: "Numéro de série",
    nomParent: "Nom parent",
    nomClient: "Nom client",
    typeReglement: "Type réglement",
    facture: "Facturé",
    dateAnnulation: "Date annulation",
    annulePar: "Annulé par",
    typesReglement: "Types de règlement",
    anneeScolaire: "Année scolaire",
    detailsBordereau: "Détails du bordereau",
    modifierBordereau: "Modifier le bordereau",
    creerBordereau: "Créer un bordereau",
    modifierCheque: "Modifier le chèque",
    gestionCheques: "Gestion des chèques",
    oui: "Oui",
    non: "Non",
    erreurChargementDonnees: "Erreur lors du chargement des données",
    erreurSauvegarde: "Erreur lors de la sauvegarde",
    erreurSuppression: "Erreur lors de la suppression",
    erreurCreation: "Erreur lors de la création",
    bordereau: {
      creeSucces: "Bordereau créé avec succès",
      modifieSucces: "Bordereau modifié avec succès",
      supprimeSucces: "Bordereau supprimé avec succès",
    },
    verificationPermissions: "Vérification des permissions...",
    aucunAcces: "Vous n'avez accès à aucun onglet de cette section.",
    pasAccesOnglet: "Vous n'avez pas accès à cet onglet",
    reglementsAnnules: "Réglements annulés",
    exportCSV: "Export CSV",
    rechercherCheques: "Rechercher des chèques",
    rechercherTraites: "Rechercher des traites",
    periode: "Période",
    factureLabel: "Facture",
    espece: "Espèce",
    remplacerParEspece: "Remplacer par espèce",
    confirmationRemplacement:
      "Êtes-vous sûr de vouloir remplacer le chèque {numero} par un paiement en espèce de {montant} ?",
    chequeRemplaceSucces: "Chèque remplacé par espèce avec succès",
    erreurRemplacementCheque: "Erreur lors du remplacement du chèque",
    chequeNonEligible: "Chèque non éligible pour le remplacement",
    chequeNonTrouve: "Chèque non trouvé",
    remplacementChequeNote:
      "Remplacement du chèque {numero} par paiement en espèce",
    elements: "éléments",
    sur: "sur",
    modifierLe: "Modifier le",
    numeroChequeTraite: "Numéro du chèque/traite",
    dateEcheance: "Date d'échéance",
    informationsNonModifiables: "Informations non modifiables",
    modification: "Modification...",
    numeroRequis: "Le numéro est requis",
    banqueRequis: "La banque est requise",
    dateEcheanceRequis: "La date d'échéance est requise",
    titulaireRequis: "Le titulaire est requis",
    virement: "Virement",
    actif: "Actif",
    inactif: "Inactif",
    chequeModifieSucces: "Chèque modifié avec succès",
    erreurModification: "Erreur lors de la modification",
    cheques: "Chèques",
    traites: "Traites",
    chequesPluriel: "chèque(s)",
    traitesPluriel: "traite(s)",
    valides: "validé(s)",
    gererLesCheques: "Gérer les chèques",
    aucunCheque: "Aucun chèque",
    confirmationSuppressionBordereau:
      "Êtes-vous sûr de vouloir supprimer ce bordereau ?",
    impossibleSupprimerBordereau:
      "Impossible de supprimer un bordereau contenant des chèques validés",
    selectionnes: "sélectionné(s)",
    aucunSelectionne: "Aucun",
    modificationEnCours: "Modification...",
    creationEnCours: "Création...",
    creer: "Créer",
    typeBordereauRequis: "Le type de bordereau est requis",
    statutRequis: "Le statut est requis",
    caisseRequise: "La caisse est requise",
    auMoinsUnElementRequis: "Au moins un élément est requis",
    num: "N°",
    rib: "RIB",
    erreurChargementCaisses: "Erreur lors du chargement des caisses",
    erreurChargementElements: "Erreur lors du chargement des éléments",
    erreurCreationBordereau: "Erreur lors de la création du bordereau",
    rechercheParNumeroTitulaireBanque:
      "Rechercher par numéro, titulaire, banque...",
    rechercheParNumeroBanque: "Rechercher par numéro, banque...",
    informationsDuBordereau: "Informations du Bordereau",
    total: "Total",
    montantTotal: "Montant Total",
    listeDes: "Liste des",
    aucuneDescription: "Aucune description",
    fermer: "Fermer",
    erreurGenerationBordereau: "Erreur lors de la génération du bordereau.",
    chequesTraites: "Les chèques et traites",
    echeance: "Échéance",
    nombreTotalElements: "Nombre total d'éléments",
    repartitionParType: "Répartition par type",
    repartitionParStatut: "Répartition par statut",
    virements: "Virements",
    pdfGeneratedSuccessfully: "PDF généré avec succès",
    pdfGenerationError: "Erreur lors de la génération du PDF",
    summary: "Résumé",
    borderaux: "Bordereaux",
    nombreBordereaux: "Nombre de bordereaux",
    nombreTotalCheques: "Nombre total de chèques",
    nombreCheques: "N° Chèques",
    montantTTC: "Montant TTC",
    creationDate: "Date création",
    numberOfElements: "Nombre Éléments",
    actions: "Actions",
    errorLoadingBordereaux: "Erreur lors du chargement des bordereaux",
    errorDuringDeletion: "Erreur lors de la suppression",
    errorRetrievingBordereau: "Erreur lors de la récupération du bordereau",
    errorGeneratingPdf: "Erreur lors de la génération du PDF",
    erreurTelechargementCSV: "Erreur lors du téléchargement du CSV",
  },
  choisir: {
    enseignant: "Choisir un enseignant",
    matiere: "Choisir une matière",
    salle: "Choisir une salle",
    duree: "Choisir une durée",
    classe: "Choisir une classe",
    repas: "Choisir le type du repas",
    jour: "Choisir les jours de ce repas",
    dateDebut: "Choisir la date de début",
    dateFin: "Choisir la date de fin",
    niveauClass: "Choisir le niveau du classe",
    template: "modèle ",
  },
  requis: {
    nameActivite: "Désignation est requis",
    template: "Le modèle est requis",
    smsContenue: "La contenue de votre message est requis.",
    message: "Le message est requis.",
    required: "est requise",
    coefficient: "Le coefficient est requis",
    red: "Réglez la réduction à zéro si vous ne souhaitez pas ajouter de réduction",
    activite: "L'activité est requise",
    cnss: "Le CNSS est requis",
    rib: "Le RIB est requis",
    specialite: "La spécialité est requise",
    niveau: "Le niveau est requis",
    etatCivil: "L'état civil est requis",
    jourSemaine: "Les jours par semaine sont requis ",
    tauxHoraire: "Le taux d'horaire est requis",
    dateEntretien: "La date d'entretien est requise",
    matiere: "La matière est requise",
    typeContrat: "Le type du contrat est requis",
    qualification: "La qualification est requis",
    telephone: "Numéro de téléphone doit étre composer de 8 chiffres",
    telephoneKE: "Numéro de téléphone doit contenir 10 chiffres",
    phoneRequired: "Le numéro de téléphone est requis",
    birthCertificate:
      "Le certificat de naissance est requis pour la 3ème année et plus",
    cin01:
      "Numéro de carte d'identité doit étre composer de 8 chiffres et commencer par 0 ou 1",
    cin8: "Numéro de carte d'identité doit étre composer de 8 chiffres",
    cin: "Numéro de carte d'identité national est requis",
    pourcentage: "Le pourcentage de remise est requis",
    dinar: "Le montant en dinar est requis",
    order: "L'ordre est requis",
    mail: "Saisir votre mail !",
    mois: "Le mois est requis",
    mdp: "Le mot de passe est requis",
    noWhitespace: "Le champ ne peut pas contenir des espaces",
    alphabeticOnly:
      "Ne doit contenir que des caractères alphabétiques et des espaces",
    confirmation: "La confirmation du mot de passe est requise.",
    username: " Le nom d'utilisateur est requis",
    usernameEmail: " Le nom d'utilisateur ou email est requis",
    titre: "Le titre est requis ",
    categorie: "La catégorie est requise",
    designation: "La désignation est requise",
    cible: " Le cible est requis",
    salaire: "Le salaire est requis",
    role: "Le role est requis",
    repas: "Saisir le nom du repas",
    depense: "Le type de dépense est requis",
    fournisseur: "Le fournisseur est requis",
    nom: " Le nom est requis ",
    min: " La note minimale est requise ",
    max: " La note maximale est requise",
    nomPersonnel: "Le nom du personnel est requis",
    date: "La date est requise",
    selection: "La sélection des parents est requise",
    nomPere: "Le nom du père est requis",
    nomMere: "Le nom de la mère est requise",
    prenom: "Le prénom est requis",
    prenomPere: "Le prénom du père est requis",
    prenomMere: "Le prénom de la mère est requis",
    telPere: "Le téléphone du père est requis",
    telMere: "Le téléphone de la mère est requis",
    email: "E-mail non valide ! ",
    activite: "L'activité est requise ",
    carac: "4 caractère au minimum pour le mot de passe ",
    genre: "Le genre est requis",
    adresse: "L'adresse est requise",
    service: "Un service doit etre séléctionné",
    fraisInscri: "Le frais d'inscription est requis",
    fraisMensuel: "Les frais mensuel sont requis.",
    fraisParJour: "Les frais par jour sont requis.",
    ajoutLogo: "Ajouter le nouveau logo ",
    coefficient: "Le coefficient est requis",
    dateNaissance: "La date de naissance est requise",
    nbJours: "Le nombre de jours est requis",
    montant: "Le montant est requis et doit étre un chiffre",
    modePaiement: "Le mode de paiement est requis",
    avance: " L'avance est requise",
    selectionEnfant: "La sélection de l'enfant est requise",
    etatPaiement: "L'état de paiement est requise",
    specification: "La spécification est requise",
    observation: "L'observation est requise",
    reductionInscro:
      "Réduction sur le frais d'inscription est requis (mettre zéro si il n'y a pas de reduction",
    reductionMensuel:
      "Réduction sur le frais mensuel est requis (mettre zéro si il n'y a pas de reduction)",
    supp: "Êtes-vous sûr de supprimer ?",
    supp2:
      "Si vous supprimez un élève son état de paiement sera mis à jour, tous les mois non payé seront supprimés. Sûr de supprimer?",
    annu: "Si vous annulez l'inscription, l'état de l'inscription de l'Ève le pour l'année scolaire courante sera mis à jour. Sûr de d'annuler l'inscription?",
    appreciation: "L'appréciation est requise",
    subject: "Le sujet est requis",
    grade: "Le grade est requis",
    reqcoverpicture: "Une image de couverture est requise",
    reqdescription: "Une description est requise",
    reqtags: "Au moins un tag est requis",
  },
  phoneInput: {
    countryCodeLabel: "Code pays",
    countrySelectorError: "Choisir un pays",
    phoneNumberLabel: "Numéro de téléphone",
    example: "Exemple :",
    descriptionTN: "8 chiffres (Tunisie)",
    descriptionKE: "10 chiffres (Kenya)",
    required: "Le numéro de téléphone est requis",
  },
  success: {
    niveauAjout: "Le niveau a été ajouté",
    niveauxCrees: "Les niveaux ont été créés",
    niveauMSA: "Le niveau a été mis à jour",
    niveauSupp: "Le niveau a été supprimé",
    studentExemptionRemoved: "Dispense de l'élève annulée avec succès",
    appreciationOptionAjout: "L'appréciation a été ajoutée",
    appreciationOptionMSA: "L'appréciation a été mise à jour",
    appreciationOptionSupp: "L'appréciation a été supprimée",
    ajout: "ajoutée avec succès",
    modification: " modifiée avec succès",
    suppression: " supprimée avec succès",
    certificationAjout: "La certification a été ajoutée",
    certificationMSA: "La certification a été mise à jour",
    certificationSupp: "La certification a été supprimée",
    modification: " modifiée avec succès",
    suppression: " supprimée avec succès",
    ajout: "ajoutée avec succès",
    decisionConseilAjout: "La décision du conseil a été ajoutée",
    decisionConseilMSA: "La décision du conseil a été mise à jour",
    decisionConseilSupp: "La décision du conseil a été supprimée",
    decisionConseilApplied:
      "La décision du conseil a été appliquée avec succès",
    noteEnregistre: "La note est enregistrée avec succès ",
    noteToutesEnregistre: "Toutes les notes sont enregistrées avec succès",
    noteRemoved: "La note a été supprimée avec succès",
    notesRemoved: "Les notes ont été supprimée avec succès",
    smsEnvoye: "SMS envoyé avec succès",
    modificationsEnseignantsEffectue:
      "La modifications des enseignants est efféctué!",
    modificationsMatieresEffectue:
      "La modifications des matiéres est efféctué!",
    operationEffectue: "Opération effectuée avec succès",
    cacheAjout: "Le caché téléchargé avec succès.",
    cacheSupp: "Le caché a été supprimé avec succès",
    inscriAjout: "L'inscription a été ajoutée",
    eleveInscrit: "élèves inscrits avec succès",
    inscriSupp: "L'inscription a été supprimée",
    inscriAnnule: "L'inscription a été annulée",
    pubAjout: "La publication a été ajoutée",
    pubModif: "La publication a été modifiée",
    pubSupp: "La publication a été archivée",
    pubModif: "La publication a été modifiée",
    photoAjout: "La photo a été ajoutée",
    compte: "Le type de compte a été ajouté",
    autorisationMSA: "L'autorisation a été mise à jour",
    autorisationSupp: "L'autorisation a été supprimée ",
    utilisateurAjout: " L'utilisateur a été ajouté",
    utilisateurMSA: " L'utilisateur a été modifié",
    utilisateurSupp: " L'utilisateur a été archivé",
    utilisateurDesac: "L'utilisateur a été désactivé ",
    utilisateurActiv: " L'utilisateur a été activé",
    repasAjout: "Le repas a été ajouté",
    repasMSA: "Le repas a été modifié",
    repasSupp: "Le repas a été supprimé",
    depenseMSA: "La dépense a été mise à jour",
    depenseSupp: "La dépense a été archivée",
    reglementSupp: "Le réglement a été supprimé",
    paiementAjout: "Le paiement a été ajouté",
    paiementModifie: "Le paiement a été modifié avec succès",
    paiementSupprime: "Le paiement a été supprimé avec succès",
    dossierMSA: "Le dossier a été mis à jour",
    dossierSupp: "Le dossier médical a été supprimé",
    buildingMSA: "Le bâtiment {name} a été mis à jour avec succès",
    eleveAjout: "L'élève a été ajouté",
    eleveMSA: "L'élève a été mis à jour",
    bulletinMSA: " Le bulletin a été modifié ",
    typeDepenseAjout: "Le type de dépense a été ajouté",
    typeDepenseModif: "Le type de dépense a été modifié",
    typeDepenseArchiv: "Le type de dépense a été archivé",
    fournisseurAjout: "Le fournisseur a été ajouté",
    fournisseurMSA: "Le fournisseur a été modifié",
    fournisseurArchiv: "Le fournisseur a été archivé",
    typeRecetteMSA: "Le type de recette a été modifié",
    typeRecetteAjout: "Le type de recette a été ajouté",
    typeRecetteArchiv: "Le type de recette a été archivé",
    activiteAjout: " L'activité a été ajoutée",
    activiteSupp: "L'activité a été archivée",
    activiteMSA: "L'activité est modifiée",
    emploiMSA: "L'emplois est modifiée",
    accessRevoked: "Accès révoqué avec succès",
    logoMSA: " Le logo a été modifié",
    fileUploadedPleaseSave:
      "{name} fichier téléchargé avec succès, veuillez sauvegarder!",
    seanceAjout: " La séance a été ajoutée",
    seanceMSA: "La séance a été modifiée",
    seanceSupp: " La séance a été archivée",
    recurringSessionsDeleted:
      "{count} séances récurrentes ont été supprimées avec succès",
    sessionsCanceled: "{count} séances ont été annulées avec succès",
    sessionsRestored: "{count} séances ont été restaurées avec succès",
    punitionValid: " La punition est évalué",
    disciplineValid: " La discipline de l'élève est évaluée",
    personnelAjout: " Le personnel a été ajouté ",
    personnelMSA: "Le personnel a été modifié",
    personnelSupp: "Le personnel a été archivée ",
    personnelNonSupp: "Le personnel n'a pas été supprimé",
    enseignantAjout: "L'enseignant a été ajouté ",
    enseignantMSA: "L'enseignant a été modifié",
    enseignantSupp: "L'enseignant a été supprimé ",
    enseignantNonSupp: "L'enseignant n'a pas été supprimé",
    classeAjout: "La classe a été ajoutée",
    classeMSA: "La classe a été modifiée",
    classeSupp: "La classe a été archivée",
    moduleSupp: "Le module a été supprimé",
    typePunitionAjout: "Le type de la punition a été ajouté",
    typePunitionMSA: "Le type de la punition a été modifié",
    typePunitionArchiv: "Le type de la punition a été archivé",
    typeStudentDisciplineAjout: "Le type de discipline de l'élève a été ajouté",
    typeStudentDisciplineMSA: "Le type de discipline de l'élève a été modifié",
    typeStudentDisciplineArchiv:
      "Le type de discipline de l'élève a été archivé",
    typeQualificationAjout: "Le type de la qualification a été ajouté",
    typeQualificationMSA: "Le type de la qualification a été modifié",
    typeQualificationArchiv: "Le type de la qualificationa été archivé",
    matiereAjout: "La matière a été ajoutée",
    submoduleAdded: "Le sous-module a été ajouté",
    subsubjectAdded: "La sous-matière a été ajoutée",
    matiereMSA: "La matière a été modifiée",
    matiereSupp: "La matière a été archivée",
    anneeAjout: "L'année scolaire a été ajoutée",
    anneeMSA: "L'année scolaire a été modifiée",
    anneeSupp: "L'année scolaire a été archivée",
    serviceAjout: "Le service a été ajouté ",
    serviceMSA: "Le service a été modifié",
    serviceSupp: "Le service a été supprimé ",
    salleAjout: "La salle a été ajoutée",
    salleMSA: "La salle a été modifiée",
    salleSupp: "La salle a été archivée",
    eleveAjout: "L'élève a été ajoutée",
    eleveMSA: "L'élève a été modifiée",
    eleveSupp: "L'élève a été archivée",
    eleveSupp2: "L'élève a été supprimé",
    eleveRective: "L'élève a été réactivée",
    parentAjout: "Le parent a été ajoutée",
    parentMSA: "Le parent a été modifiée",
    parentSupp: "Le parent a été archivée",
    eleveAjoutAuClasse: "La élève ajouté au classe avec succées !",
    eleveDemeangeAuClasse: "La élève déménagé au {name} avec succès",
    InscriptionAnnulee: "Inscription annulée avec succès.",
    imageTelecharge: "{name} fichier téléchargé avec succès.",
    videoAdded: "Vidéo {name} ajoutée avec succès",
    moduleOrderUpdated: "Ordre des modules mis à jour avec succès",
    conseillerPedagogiqueAjout: "Conseiller pédagogique a été ajoutée",
    conseillerPedagogiqueMSA: "Conseiller pédagogique a été modifiée",
    newsValidationSettingUpdated:
      "La validation automatique des actualités a été mise à jour avec succès",
    conseillerPedagogiqueSupp: "Conseiller pédagogique a été archivée",
    productUpdate: "Produit mis à jour avec succès.",
    fetchCommands: "Récupération des commandes...",
    commandSupp: "Commande supprimée avec succès.",
    commandUpdate: "Commande mise à jour avec succès.",
    prodSupp: "Vous avez désactivé le produit avec succès.",
    prodReactivate: "Produit réactivé avec succès",
    libraryAddDoc: "Le document a été ajouté",
    libraryUpdateDoc: "Le document a été mis à jour",
    libraryArchiveDoc: "Le document a été archivé",
    libraryReactiveDoc: "Le document a été réactivé",
    moduleOrderUpdated: "Ordre des modules mis à jour avec succès",
    studentPhotoUploaded: "La photo de l'élève a été téléchargée avec succès",
    studentPhotoDeleted: "La photo de l'élève a été supprimée avec succès",
    studentExempted: "L'élève a été dispensé avec succès",
    sessionsUpdated: "{count} sessions ont été mises à jour avec succès",
    changementEffectue: "Changements effectués avec succès",
    parentMisAJour: "Les informations du parent ont été mises à jour",
    groupUpdated: "Groupe mis à jour",
    studentRemovedFromGroup: "Étudiant retiré du groupe",
    excelGenerated: "Le fichier Excel a été généré avec succès.",
  },
  error: {
    dateFinPlusGrande:
      "La date de fin doit être plus grande que la date de début",
    oops: "Oops! Une erreur s'est produite",
    allSubModuleNeedToBeSelected: "Selectionner tous les sous-modules",
    noSubMoudoleIsfound: "Aucun sous-module is trouvé",
    impoAjoutAppreciationOption: "Impossible d'ajouter une appréciation",
    aucCert: "Aucune certification n'a été trouvée",
    fetchError: "Erreur lors du chargement des données",
    fetchingStudents: "Erreur lors de la récupération de la liste des élèves",
    impoAjoutCertification: "Impossible d'ajouter la certification",
    impoEnregistrerVide: "Impossible d'enregistrer une valeur vide",
    invalidNote: "Note invalide !. Doit être compris entre 0 et 20",
    smsFormat:
      "Format invalide, les numéros de téléphone doivent être séparés par des virgules !",
    noPhoneNumber: "Pas de numéro",
    invalid: "invalide",
    notEnrolled: "Non inscrit",
    noStudentFound: "Aucun élève est trouvé",
    noClassFound: "Aucune classe trouvée pour le niveau sélectionné",
    phoneNumberExists: "Le numéro de téléphone existe déjà dans le système",
    eleveDejaInscritPourMois: "Elève déjà inscrit pour les mois selectionnés",
    impoModifiEleve: "Impossible de mettre à jour l'élève",
    impoModifi: "Impossible de mettre à jour",
    eleveNonAjoutAuClasse:
      "Inscription non ajoutée, veillez annulez l'inscription puis affecter l'eleve à un nouveau classe !",
    InscriptionNonModifi:
      "Inscription non modifiée, veillez annulez l'inscription puis affecter l'eleve à un nouveau classe !",
    matiereNonAffecte:
      "Toutes les matières et leurs coefficients doivent être remplies  !",
    subsubjectNonAffecte:
      "{subject}: Toutes les sous-matières doivent être remplies !",
    capacite: " La capacité de la salle est inférieur aux nombre des élèves",
    fichiers: "Vous ne pouvez télécharger que des fichiers JPG ,JPEG ou PNG!",
    fichiersPNG: "Vous ne pouvez télécharger que des fichiers PNG!",
    fichiersPDFWord:
      "Vous ne pouvez télécharger que des fichiers JPG, JPEG, PNG, PDF, Word (.doc, .docx)!",
    fileTypeNotAllowed:
      "Seuls les images, PDF, fichiers Office (Word, Excel, PowerPoint) et vidéos (MP4, WebM) sont autorisés",
    onlyPDFAllowed: "Vous ne pouvez télécharger que des fichiers PDF!",
    onlyImagesAndPDFAllowed:
      "Vous ne pouvez télécharger que des images (JPEG, PNG, WEBP) ou des fichiers PDF!",
    onlyImagesPDFWordExcel:
      "Vous ne pouvez télécharger que des images (JPEG, PNG, WebP), des PDF, Word ou Excel !",
    onlyAudioFilesAllowed:
      "Seuls les fichiers audio sont autorisés (ex. MP3, WAV, M4A).",
    allowedFileTypes:
      "Seuls les types de fichiers suivants sont autorisés : {types}",
    allowedImageTypes:
      "Seuls les types d'images suivants sont autorisés : {types}",
    classe: "classe non trouvée",
    activite: "Activité non trouvée",
    service: "Service non trouvé",
    inscription: "Inscription ",
    aucScol: "Aucune inscription au scolarité est trouvée",
    aucClasse: "Aucune classe est trouvé",
    aucEleve: "Aucune élève est trouvé",
    aucInscri: "Aucune inscription au activité est trouvé",
    aucPersonnel: "Aucun personnel est trouvé",
    aucService: "Aucun service est trouvé",
    aucActivite: "Aucune activité est trouvée",
    aucActualite: "Aucune actualité est trouvée",
    aucRole: "Aucun rôle est trouvé",
    aucEtablissement: "Aucun établissement est trouvé",
    aucRecette: "Aucun type de recette est trouvé",
    aucMatiere: "Aucune matière est trouvée",
    aucSubsubject: "Aucune sous-matière est trouvée",
    aucUser: "Aucun utilisateur est touvé",
    aucFournisseur: "Aucun fournisseur est trouvé",
    aucDepense: "Aucune dépense est trouvée",
    aucQualification: "Aucun type de qualification est trouvé",
    aucEnseignant: "Aucun enseignant est trouvé",
    aucAnnee: "Aucune année scolaire est trouvée",
    aucSalle: "Aucune salle est trouvé",
    aucModule: "Aucun module est trouvé",
    aucSubsubject: "Aucune sous-matière est trouvée",
    verifier: "Vérifiez les mots de passe",
    modif: "Une erreur dans la modification",
    ajout: "Une erreur dans l'ajout",
    supp: "Une erreur dans la suppression",
    impoInscriSupp: "Impossible de supprimer cette inscription",
    impoPubAjout: "Impossible d'ajouter la publication",
    impoPubModif: "Impossible de modifier la publication",
    impoPubSupp: "Impossible de supprimer la publication",
    impoPubModif: "Impossible de modifier la publication",
    impoAjoutType: "Impossible d'ajouter ce type",
    impoAjoutActivite: "Impossible d'ajouter l'activité",
    impoAjoutAnnee: "Impossible d'ajouter l'années scolaire",
    impoAjoutClasse: "Impossible d'ajouter la classe",
    impoAjoutSalle: "Impossible d'ajouter la salle",
    impoAjoutService: "Impossible d'ajouter la service",
    impoAjoutFournisseur: "Impossible d'ajouter ce fournisseur",
    impoAjoutCeType: "Impossible d'ajouter ce type",
    impoModifiMatieres: "Impossible de modifier les matiéres",
    impoModifiEnseignants: "Impossible de modifier les enseignants",
    image: "L'image doit être inférieure a 5 MO ",
    fileTooLarge: "La taille du fichier doit être inférieure à 5 Mo",
    image50: "Les images doivent être inférieure à 50 MO ",
    maxImage: "Le nombre maximal des images est 15",
    maxFiles: "Le nombre maximal des fichiers est 15",
    videoFormat:
      "Seuls les formats vidéo MP4, MOV, AVI, MKV et WebM sont autorisés",
    maxVideos: "Maximum 5 vidéos autorisées",
    videoSize: "La taille de la vidéo doit être inférieure à 500 Mo",
    nonAjoute: "Non ajouté",
    autorisationNonMSA: "Autorisation n'a pas été mise à jour",
    autorisationNonSupp: "Autorisation non supprimée",
    eleveNonMSA: " L'élève n'a été mis à jour",
    impoTelecharger: " Impossible de télécharger l'image",
    dossier: "Impossible de trouver le dossier de l'élève ",
    dossierNonMSA: " Le dossier n'a pas été mis à jour",
    nonValid: "vous ne pouvez pas valider un paiement d'un montant égal à zéro",
    recetteNonAjoute: "recette non ajouté",
    recetteNonMSA: "recette n'a pas été mis à jour",
    recetteNonSupp: "recette n'a pas été supprimé",
    qualificationNonAjoute: "qualification non ajouté",
    qualificationNonMSA: "Qualification n'a pas été mis à jour",
    qualificationNonSupp: "Qualification n'a pas été supprimé",
    serviceNonSupp: "Cette service ne peut être supprimé",
    erreur: "Une erreur est survenu",
    selectionnerDates: "Veuillez sélectionner une classe et une période",
    dateDebutApresFin: "La date de début doit être antérieure à la date de fin",
    erreurRecuperationSeances: "Erreur lors de la récupération des séances",
    erreurRecuperationAssiduite:
      "Erreur lors de la récupération des données d'assiduité",
    erreurGenerationPdf: "Erreur lors de la génération du PDF",
    depenseNonMSA: "Dépense n'a pas été mise à jour",
    depenseNonSupp: "Dépense non supprimée",
    buildingEchoue: "Le mise à jour bâtiment {name} a échoué",
    inscriEchoue: "L'inscription est échouée",
    personnelNonAjoute: "Personnel non ajouté",
    personnelNonMSA: "Personnel n'a pas été mis à jour",
    enseignantNonAjoute: "Enseignant non ajouté",
    enseignantNonMSA: "Enseignant n'a pas été mis à jour",
    listeNonTrouve: "Liste des élèves non trouvée",
    anneeNonAjoute: "Année non ajouté",
    anneeNonMSA: "Année n'a pas été mis à jour",
    punitionNonAjoute: "Punition non ajouté",
    punitionNonMSA: "Punition n'a pas été mis à jour",
    serviceNonAjoute: "service non ajouté",
    serviceNonMSA: "Ce service ne peut être modifié",
    depenseNonAjoute: "dépense non ajouté",
    depenseNonMSA: "dépense n'a pas été mis à jour",
    fournisseurNonAjoute: "Fournisseur non ajouté",
    fournisseurNonMSA: "Fournisseur n'a pas été mis à jour",
    fournisseurNonSupp: "Cette fournisseur ne peut être supprimé",
    activiteNonMSA: "L'activité ne peut être modifé, veuillez réessayer!",
    moduleNonAjoute: "Module non ajouté",
    moduleNonMSA: "Module n'a pas été mis à jour",
    moduleNonSupp: "Ce module ne peut être supprimé",
    personnelNonMSA: "Personnel n'a pas été mis à jour!",
    matiereNonAjoute: "Matière non ajouté",
    subModuleNonAjoute: "Sous-module non ajouté",
    subsubjectNonAjoute: "Sous-matière non ajouté",
    matiereNonMSA: "Cet matière ne peut être supprimée",
    listeNonTrouve: "Liste des élèves non touvée !",
    inscrEchoue: "L'inscription est échouée",
    activiteNonSupp: "L' activité ne peut pas être supprimée",
    classeNonSupp: "La classe ne peut pas être suppprimée",
    classeIndis: "La classe est indisponible ",
    salleIndis: "La salle est indisponible",
    enseignantIndis: "L'enseignant est indisponible",
    selectEnseignant: "Sélectionner un enseignant",
    selectSeance: "Sélectionner la séance",
    teacherConflictFuture:
      "L'enseignant {teacherName} est déjà programmé pour le même horaire et jour de la semaine dans le futur",
    classConflictFuture:
      "La classe {className} est déjà programmée pour le même horaire et jour de la semaine dans le futur",
    teacherConflictUpdate:
      "L'enseignant {teacherName} est déjà pris à cette heure",
    classConflictUpdate: "La classe {className} est déjà prise à cette heure",
    conflictDetails: "Détails du conflit",
    conflictingTeacher: "Enseignant en conflit",
    conflictingClass: "Classe en conflit",
    conflictTime: "Heure",
    conflictDate: "Date",
    conflictGroup: "Groupe",
    conflictWeek: "Semaine",
    conflictEndTime: "Heure de fin",
    classroomGroupConflict: "Conflit de groupe de classe détecté",
    classroomGroupConflictDesc:
      "Différents groupes ne peuvent pas être programmés en même temps pour la même classe",
    classroomMixedConflict: "Conflit de groupe mixte de classe détecté",
    classroomMixedConflictDesc:
      "Impossible de mélanger les sessions de groupe et régulières pour la même classe en même temps",
    teacherGroupConflict: "Conflit de groupe d'enseignant détecté",
    teacherGroupConflictDesc:
      "L'enseignant ne peut pas enseigner différents groupes en même temps",
    teacherMixedConflict: "Conflit de groupe mixte d'enseignant détecté",
    teacherMixedConflictDesc:
      "Impossible de mélanger les sessions de groupe et régulières pour le même enseignant en même temps",
    selectClasse: "Sélectionner une classe ",
    sallePriseEntre:
      "La salle {room} est prise par la classe {name} entre {start} et {end}",
    classPriseEntre: "La classe {name} est prise entre {start} et {end}",
    enseignantEnseigneClasse:
      "L'enseignant {fullname} enseigne la classe {name} la matiere {subject} entre {start} et {end}",
    conflictingSessionInfo:
      "En conflit avec : {subject} — {teacher} — {className} — {date} {start}-{end}{extra}",
    teacherGroupConflict:
      "Conflit enseignant : Impossible de programmer différents groupes en même temps",
    teacherWeekConflict:
      "Conflit enseignant : Impossible de programmer différentes semaines en même temps",
    teacherMixedConflict:
      "Conflit enseignant : Impossible de mélanger sessions de groupe et sessions régulières en même temps",
    classroomGroupConflict:
      "Conflit salle : Impossible de programmer différents groupes en même temps",
    classroomWeekConflict:
      "Conflit salle : Impossible de programmer différentes semaines en même temps",
    classroomMixedConflict:
      "Conflit salle : Impossible de mélanger sessions de groupe et sessions régulières en même temps",
    teacherGroupConflictDesc:
      "L'enseignant est déjà programmé pour un groupe différent à cette heure. Les enseignants ne peuvent pas être assignés à plusieurs groupes simultanément.",
    teacherWeekConflictDesc:
      "L'enseignant est déjà programmé pour une semaine différente (A/B) à cette heure. Les enseignants ne peuvent pas être assignés à plusieurs semaines simultanément.",
    teacherMixedConflictDesc:
      "L'enseignant est déjà programmé pour une session régulière à cette heure. Impossible de mélanger sessions de groupe avec sessions régulières.",
    classroomGroupConflictDesc:
      "La salle est déjà programmée pour un groupe différent à cette heure. Différents groupes peuvent utiliser la même salle.",
    classroomWeekConflictDesc:
      "La salle est déjà programmée pour une semaine différente (A/B) à cette heure. Différentes semaines peuvent utiliser la même salle.",
    classroomMixedConflictDesc:
      "La salle est déjà programmée pour une session régulière à cette heure. Impossible de mélanger sessions de groupe avec sessions régulières.",
    anneeNonSupp: "L'année ne peut pas être supprimée",
    utilisateurNonAjoutDiff:
      "Utilisateur non ajouté, merci d'essayer avec un nom d'utilisateur different !",
    conseillerPedagogiqueNonAjoute: "Conseiller pédagogique non ajouté",
    conseillerPedagogiqueNonMSA:
      "Conseiller pédagogique n'a pas été mis à jour",
    conseillerPedagogiqueNonSupp: "Conseiller pédagogique n'a pas été supprimé",
    invalidFormat: "Format de fichier invalide",
    maxStudentsReached:
      "Nombre maximum d'élèves atteint. Veuillez mettre à niveau votre abonnement pour ajouter plus d'élèves.",
    maxUsersReached:
      "Nombre maximum d'utilisateurs atteint. Veuillez mettre à niveau votre abonnement pour ajouter plus d'utilisateurs.",
    productUpdate: "Échec de la mise à jour du produit. Veuillez réessayer.",
    autorisationSupp: "Vous n'êtes pas autorisé à supprimer cette commande.",
    prodReactivate: "Échec de la réactivation du produit",
    libraryAddDoc: "Le document n'a pas été ajouté",
    libraryUpdateDoc: "Le document n'a pas été mis à jour",
    libraryArchiveDoc: "Le document n'a pas été archivé",
    libraryReactiveDoc: "Le document n'a pas été réactivé",
    failedToUpdateModuleOrder:
      "Echec de la mise à jour de l'ordre du module. Veuillez réessayer",
    alreadyAssigned: "Déjà associé à",
    studentPhotoUploadError: "Échec du téléchargement de la photo de l'élève",
    studentPhotoDeleteError: "Échec de la suppression de la photo de l'élève",
    fileUploadError:
      "Erreur lors du téléchargement du fichier. Veuillez réessayer.",
    deleteSession: "Erreur lors de la suppression de la séance",
    deleteRecurringSessions:
      "Erreur lors de la suppression des séances récurrentes",
    classNotFound: "Classe non trouvée!",
    studentListNotFound: "Liste des élèves non trouvés",
    unexpectedError: "Une erreur inattendue s'est produite.",
    groupUpdateFailed: "Erreur lors de la mise à jour du groupe",
    noDataToUpdate: "Aucune donnée à mettre à jour",
    updateSessions: "Erreur lors de la mise à jour des séances",
    fetchingData: "Échec de la récupération des données. Veuillez réessayer.",
    usernameExists: "Le nom d'utilisateur n'est pas disponible",
    activiteHasPayments:
      "impossible de modifier l'année scolaire, car l'activité comporte des inscriptions dans l'année scolaire en cours",
    failedToLoadFinancialStats:
      "Échec du chargement des statistiques financières",
    failedToLoadAnalytics: "Échec du chargement de l'analyse {tab}",
    errorLoadingSchoolYears: "Erreur lors du chargement des années scolaires",
  },
  warning: {
    verifieDonnees: "Vérifier les données",
    connectionProblem:
      "Un problème de la connexion, veuillez rafraîchir la page !",
    selectModePaiement: "Selectionner le mode de paiement",
    paiementNonEffectuer: "Paiement non effectuer",
    invalidMarks:
      "Veuillez vous assurer que vos notes sont comprises entre 0 et 20.",
    notCorrectMarks:
      "Veuillez vous assurer que vos notes ont été saisies correctement.",
    missedSubsubjects:
      "Veuillez compléter toutes les notes manquantes pour ({name})",
  },
  stats: {
    userStats: "Statistiques des utilisateurs",
    connectedStats: "Utilisateurs connectés",
    connects: "Connexions",
    connect: "Connexion",
    disconnect: "Déconnexion",
    seen: " vue",
    published: " publiés",
    mainStats: "Nombre d'utilisateurs connectés par date",
    nb_connections: "Nombre de connexions",
    connection_duration: "Durée de la connexion",
    mainStatSelected: "Durée du connection (heurs) pour {name} par date",
    secondaryStatsteacher: "Publication des cours/exercices par jour",
    secondaryStatsparent: "Consultation des cours/exercices par jour",
    secondaryStatSelectedteacher:
      "Publication de cours/exercice par {name} par jour",
    secondaryStatSelectedparent:
      "Consultation des cours/exercices par {name} par jour",
    detailedStats: "Détails des connexions",
    detailedStatSelected: "Détails des connexions pour {name}",
    lastConnection: "Dernière connexion",
    duration: "Durée de la connexion",
    neverLoggedIn: "Jamais connecté",
    hasLoggedIn: "A connecté",
    noConnectionHistory: "Aucun historique de connexion",
    fullName: "Nom et prénom",
    childName: "Nom de l'enfant",
  },
  bulletinBuilder: {
    contradictoryWith: "Cette option est contradictoire avec {option}",
    subjectsOptions: "Options des matières/sous-matières",
    modulesOptions: "Options des modules/sous-modules",
    otherOptions: "Autres options",
    hideSubjectMark: "Masquer les moyennes des matières/sous-matières",
    hideModuleMark: "Masquer les moyennes des modules/sous-modules",
    additionalImages: "Images Additional",
    customGovLogo: "Personnaliser le logo du ministère",
    showSubmodule: "Afficher le nom du sous-module",
    showSubmoduleMoy: "Afficher la moyenne du sous-module",
    noStampFound: "Aucun cachet trouvé",
    errorPrintingBulletin:
      "Une erreur s'est produite lors de l'impression de la bulletin",
    errorGettingBulletinData:
      "Une erreur s'est produite lors de la récupération des données du bulletin",
    selectStudentFirst: "Sélectionnez d'abord un élève",
    scaleImagesTooltip:
      "Cette option permet de réduire ou d'augmenter la taille des images dans le bulletin, utilisez-la avec prudence.",
    scaleImages: "Échelle des images",
    certifUsePersonalizedMoy: "Certificat avec moyenne personnalisée",
    hideSubModuleMark: "Masquer la moyenne du sous-modules",
    certif: "certificat",
    adminAppreciation: "Appréciation de l'admin",
    pedaLike: "Arrondissement des rectangles",
    onlyForForceOnePage:
      "Utile pour forcer une page ou étirer jusqu'à la page entière",
    textuelle: "Éléments textuels",
    images: "Images",
    couleurs: "Couleurs",
    taillesPolice: "Tailles de police",
    optionsAvancees: "Options avancées",
    enTete: "En-tête",
    corps: "Corps",
    cote: "Côté",
    espacement: "Espacement",
    arrierePlanQR: "Arrière-plan et QR",
    schoolName: "Nom de l'école",
    schoolarYear: "Année scolaire",
    className: "Nom de la classe",
    studentName: "Nom de l'élève",
    birthDate: "Date de naissance",
    nbInscription: "Numéro d'inscription",
    uniqueIden: "Identifiant unique",
    schoolLogo: "Logo de l'école",
    studentImage: "Photo de l'élève",
    govLogo: "Logo du ministère",
    subsubjectMark: "Note sous-matière",
    subjectMark: "Note matière",
    moduleMark: "Note module",
    appreciation: "Appréciation",
    minPerClass: "Minimum par classe",
    maxPerClass: "Maximum par classe",
    lineReturn: "Retour à la ligne après le titre",
    normal: "Moyenne générale",
    peda: "Moyenne pédagogique",
    personalized: "Moyenne personnalisée",
    afficherNomEcole: "Afficher le nom de l'école",
    afficherAnneeScolaire: "Afficher l'année scolaire",
    afficherNomClasse: "Afficher le nom de la classe",
    afficherTextMinistere: "Afficher le texte du ministère",
    afficherNomEleve: "Afficher le nom de l'élève",
    afficherDateNaissance: "Afficher la date de naissance",
    afficherNbInscription: "Afficher le numéro d'inscription",
    afficherIdentifiantUnique: "Afficher l'identifiant unique",
    enteteTrimestre: "En-tête du trimestre",
    afficherLogoEcole: "Afficher le logo de l'école",
    afficherImageEleve: "Afficher la photo de l'élève",
    afficherLogoMinistere: "Afficher le logo du ministère",
    personnaliserCouleurs: "Personnaliser les couleurs",
    paletteCouleurs: "Palette de couleurs",
    noteSousMatiere: "Note sous-matière",
    noteMatiere: "Note matière",
    noteModule: "Note module",
    appreciation: "Appréciation",
    minParClasse: "Minimum par classe",
    maxParClasse: "Maximum par classe",
    fusionnerSousMatieres: "Fusionner les sous-matieres",
    masquerMatieres: "Masquer les matières",
    masquerMinParMatiere: "Masquer le minimum par matière",
    masquerMaxParMatiere: "Masquer le maximum par matière",
    pasEncoreDisponible: "Cette fonctionnalité n'est pas encore disponible",
    slowingFactor: "Cette option peut ralentir la génération de PDF",
    nonDisponiblePourEnTeteBas: "Non disponible pour les en-têtes en bas",
    forcerUnePage: "Forcer sur une page",
    sensitiveOption: "Ces options sont sensibles, utilisez-les avec caution",
    etirerPageEntiere: "Étirer sur toute la page",
    margeGauche: "Marge gauche",
    trimersterLineMargin: "Marge d'en-tête",
    margeInferieure: "Marge inférieure",
    ajouterQRCode: "Ajouter un QR code",
    ajouterArrierePlan: "Ajouter un arrière-plan",
    cliquezGlisser: "Cliquez ou glissez-déposez un fichier",
    supportImageUnique: "Supporte uniquement les images",
    apercuBulletin: "Aperçu du bulletin",
    selectionnerEleve: "Sélectionner un élève",
    selectionnerTemplate: "Sélectionner un modèle",
    actualiser: "Actualiser",
    selectionnerEleveDabord: "Veuillez sélectionner un élève d'abord",
    visualiserBulletin: "Visualiser le bulletin",
    configurer: "Configurer",
    titre: "Titre",
    valeur: "Valeur",
    position: "Position",
    centre: "Centre",
    gauche: "Gauche",
    droit: "Droit",
    bas: "Bas",
    ordre: "Ordre",
    changerPositions: "Changer les positions",
    optionsAffichage: "Options d'affichage",
    afficherMinimum: "Afficher le minimum",
    afficherMaximum: "Afficher le maximum",
    afficherRang: "Afficher le rang",
    recommandeActiver:
      "Il est recommandé d'activer seulement 2 sur 3 moyennes au maximen.",
    couleurMoyenne: "Couleur de la moyenne",
    couleurRang: "Couleur du rang",
    couleurMin: "Couleur du minimum",
    couleurMax: "Couleur du maximum",
    legende: "Légende",
    libelle: "Libellé",
    coefficientMoyenne: "Coefficient de la moyenne",
    coefficientMoyennePedagogique: "Coefficient de la moyenne pédagogique",
    modifierCouleurs: "Modifier les couleurs",
    couleurPrincipale: "Couleur principale",
    enteteTrimestreTitres: "En-tête du trimestre et titres",
    bordureCouleurPrincipale: "Bordure de la couleur principale",
    couleurSecondaire: "Couleur secondaire",
    titresMoyennes: "Titres des moyennes",
    bordureCouleurSecondaire: "Bordure de la couleur secondaire",
    couleurTertiaire: "Couleur tertiaire",
    arrierePlanMinMaxRang: "Arrière-plan des min/max/rang",
    bordureCouleurTertiaire: "Bordure de la couleur tertiaire",
    configurerPolice: "Configurer la police",
    taille: "Taille",
    couleur: "Couleur",
    font: "Police",
    veuillezVerifierChamps: "Veuillez vérifier les champs",
    afficherMoyenne: "Afficher la moyenne",
    afficherMoyennePedagogique: "Afficher la moyenne Pédagogique",
    afficherMoyennePersonnalise: "Afficher la moyenne Personnalisé",
    afficherCertif: "Afficher le certif",
    afficherCache: "Afficher le caché",
    afficherDate: "Afficher la date",
    selectFont: "Sélectionner une police",
    positionX: "Position X",
    parametresEnregistres: "Paramètres enregistrés",
    parametresNonEnregistres: "Paramètres non enregistrés",
    checkInputs: "Veuillez vérifier vos saisies",
    positionUsedBy: "Cette position est utilisée par",
    restaureParametres: "Restauré aux paramètres par défaut",
    modeleSelectionne: "Modèle sélectionné",
    arabicAndFrench: "Arabe et français",
    arabicOnly: "Arabe seulement",
    selectionnerElevePourVisualiser:
      "Sélectionnez un élève pour visualiser le bulletin",
    parametresEnregistresAvecSucces: "Paramètres enregistrés avec succès",
  },
  teacherGradePermissions: {
    title: "Permissions de notes des enseignants",
    subTitle:
      "contrôler si les enseignants peuvent modifier les notes des élèves après la soumission",
    gradeEditingEnabled: "La modification des notes est activée",
    gradeEditingDisabled: "La modification des notes est désactivée",
    selectTeachers: "Sélectionner les enseignants",
    allTeachers: "Tous les enseignants",
    specificTeachers: "Enseignants spécifiques",
    permissionSaved: "Permissions de notes enregistrées avec succès",
    chooseTrimester: "Choisir le trimestre",
    gradeEditing: "Modification des notes",
    teacherAccessMode: "Donner accès à",
    canEdit: "Peut modifier les notes",
    searchTeachers: "Rechercher par nom d'enseignant",
    filterAccess: "Filtrer par accès enseignant",
    withAccess: "Enseignants avec accès",
    withoutAccess: "Enseignants sans accès",
    selectTeachersError:
      "Veuillez sélectionner au moins un enseignant lorsque le mode 'Enseignants spécifiques' est activé.",
  },
  aiFeedback: {
    title: "Rapport intelligent",
    lastUpdated: "Dernière mise à jour",
    summary: "Résumé",
    strengths: "Points forts",
    weaknesses: "Points à améliorer",
    recommendations: "Recommandations",
    generalAppreciation: "Appréciation générale",
    noFeedback: "Aucun rapport disponible",
    generateReport: "Générer un rapport avec l'IA",
    initiatedMessage: "Analyse IA en cours",
    initiatedDescription:
      "Nous analysons les performances de l'élève. Cela peut prendre quelques instants.",
    information: "Détails du rapport",
    generatedByAI: "Généré par l'IA",
    generatedAt: "Généré le",
    pdfGenerationError: "Erreur lors de la génération du rapport",
    pdfGeneratedSuccessfully: "Rapport généré avec succès",
  },
  invoice: {
    addressedTo: " adressé à",
    editAddressedTo: "Modifier l'adressé à",
    type: "Type",
    selectType: "Sélectionner le type",
    particular: "Particulier",
    entreprise: "Entreprise",
    MF: "MF",
    representative: "Représentant",
    enterMF: "Entrer le MF",
    selectRepresentative: "Sélectionner le représentant",
    father: "Père",
    mother: "Mère",
    other: "Autre",
    addressedToName: "Nom",
    enterName: "Entrer le nom",
    typeRequired: "Le type est requis",
    nameRequired: "Le nom est requis",
    representativeRequired: "Le représentant est requis",
    MFRequired: "Le MF est requis",
    selectAddressedTo: "Sélectionner l'adressé à",
    loadingParentsInfo: "Chargement des informations des parents...",
    selectParent: "Sélectionner un parent",
    multipleParentsFound: "Plusieurs parents trouvés",
    parentFound: "Parent trouvé",
    selectParentForDocument:
      "Veuillez sélectionner le parent pour l'adressage du document",
    documentAddressedTo: "Document adressé à",
    noParentFound: "Aucun parent trouvé",
    fatherLabel: "Père",
    motherLabel: "Mère",
    parentMissingInfo: "Parent (informations manquantes)",
    errorLoadingParents: "Erreur lors du chargement des parents",
    facture: "Facture",
    factureAvoir: "Facture - Avoir",
    recu: "Reçu",
    recuAvoir: "Reçu - Avoir",
    nomPrenomEleve: "Nom et Prénom ( élève )",
    fullName: "Nom complet",
    designation: "Désignation",
    frais: "Frais",
    quantite: "Quantité",
    prixUnitaireHT: "P. U. HT",
    montantHT: "Montant HT",
    montantTTC: "Montant TTC",
    qte: "Qte",
    prixUnitaire: "Prix unitaire",
    total: "Total",
    totalHTBrut: "Total HT Brut",
    remise: "Remise",
    totalHT: "Total HT",
    totalTVA: "Total TVA",
    timbre: "Timbre",
    retenueALaSource: "Retenue à la source",
    netAPayer: "NET A PAYER",
    reste: "Reste",
    adresseeA: "Adressée à :",
    cachetSignature: "Cachet et signature",
    arreteePresenteFacture: "Arrêtée la présente facture à la somme de :",
    dinarsEt: "dinars et",
    millimes: "millimes",
    ecolePrimairePrivee: "École primaire privée",
    page: "Page",
    mf: "MF",
    tel: "Tel",
    mail: "Mail",
    numeroLabel: "Numéro :",
    dateLabel: "Date :",
    avanceLabel: " ( avance )",
    signature: "Signature",
    paymentMethods: "Moyens de paiement",
    tuitionSummary: "Résumé de paiement scolarité",
    activitySummary: "Résumé de paiement activités",
    summaryTotalToPay: "Total à payer",
    summaryDebitPaid: "Débit – Payé",
    summaryCreditUnpaid: "Crédit – Impayé",
    summaryTotalPaid: "Total payé",
    summaryTotalUnpaid: "Total impayé",
    summaryPartial: "partiel",
    chequeDetail: "Chèque",
    transactionCode: "Code transaction",
    pmNumber: "N°",
    pmReference: "Réf.",
    pmHolder: "Titulaire",
    pmBank: "Banque",
    pmRib: "RIB",
    pmDueDate: "Échéance",
    pmDate: "Date",
    baseReduction: "Réduction de base",
    baseReductionShort: "Réduc.",
    baseReductionTotal: "Total des réductions de base",
    schoolCopy: "Copie établissement",
  },
  promotion: {
    button: "Passage automatique",
    title: "Passage automatique des élèves",
    subtitle:
      "Faites passer les élèves vers l'année scolaire suivante selon leur niveau.",
    back: "Retour",
    fromYear: "Année source",
    toYear: "Année cible",
    noNextYearShort: "Aucune année suivante",
    noNextYearTitle: "Aucune année scolaire suivante",
    noNextYearDesc:
      "Créez d'abord l'année scolaire suivante pour lancer le passage.",
    missingTitle: "Classes virtuelles manquantes",
    missingDesc:
      "Créez les niveaux (classes d'affectation) suivants pour l'année cible avant de lancer le passage :",
    doneTitle: "Passage effectué",
    promoted: "promus",
    kept: "conservés (redoublants)",
    archived: "archivés",
    skipped: "ignorés (déjà placés)",
    noStudents: "Aucun élève à faire passer.",
    toPromote: "À promouvoir",
    toKeep: "À conserver",
    toArchive: "À archiver",
    students: "élèves",
    endOfCycle: "Fin de cycle",
    keptShort: "conservés",
    archivedShort: "archivés",
    terminalHint:
      "Ces élèves seront archivés. Cochez les redoublants à conserver dans la nouvelle année scolaire.",
    terminalHintNoKeep:
      "Ces élèves seront archivés (aucune classe d'affectation de même niveau pour les conserver).",
    alreadyPlaced: "déjà placé",
    confirmText: "Confirmer le passage des élèves vers l'année suivante ?",
    confirmOk: "Confirmer",
    execute: "Lancer le passage",
    notReady: "Corrigez les prérequis avant de lancer le passage.",
  },
  inscriptionStats: {
    tabNormal: "Classes",
    tabAffectation: "Affectations",
    tabIndicators: "Indicateurs",
    total: "Nombre total d'élèves",
    enrolled: "Élèves inscrits",
    affected: "Élèves affectés",
    unplaced: "Élèves non placés",
    repartition: "Répartition des élèves",
    effectifParClasse: "Effectif par classe",
    parNiveau: "Effectifs par niveau",
    bandAffectation: "Affectation (niveau)",
    bandNormal: "Classes",
    eleves: "élèves",
    moyenne: "Moyenne",
    imbalance: "Déséquilibre d'effectifs",
    imbalanceTag: "Déséquilibré",
    imbalanceHint:
      "Un niveau est signalé quand l'écart entre la classe la plus remplie et la moins remplie est important. Rouge = classe la plus remplie, orange = la moins remplie.",
    aucuneDonnee: "Aucune donnée disponible",
    loadError: "Impossible de charger les indicateurs",
  },
  errorCode: {
    LEVEL_REQUIRED_FIRST:
      "Ce niveau doit d'abord être créé dans l'onglet Niveaux avant d'ajouter une classe.",
    LEVEL_ALREADY_EXISTS:
      "Ce niveau existe déjà pour cette année scolaire.",
    LEVEL_HAS_PAYMENTS:
      "Impossible de supprimer ce niveau : des paiements y sont rattachés.",
    LEVEL_HAS_STUDENTS:
      "Impossible de supprimer ce niveau : des élèves y sont encore affectés.",
    EXACTLY_ONE_OWNER_REQUIRED:
      "Il doit y avoir exactement un propriétaire pour la caisse.",
    AT_LEAST_ONE_OWNER_REQUIRED:
      "La caisse doit avoir au moins un propriétaire.",
    DUPLICATE_CAISSE_USER:
      "Un utilisateur ne peut apparaître qu'une seule fois dans les accès d'une caisse.",
    CAISSE_REFERENCE_ALREADY_EXISTS:
      "Une caisse utilise déjà cette référence.",
    PRINCIPAL_CAISSE_ALREADY_EXISTS:
      "Une caisse principale existe déjà. Vous ne pouvez en créer qu'une seule.",
    CAISSE_SELECTION_REQUIRED:
      "Vous avez accès à plusieurs caisses, sélectionnez celle à utiliser.",
    NOT_OWNER_OF_CAISSE:
      "Vous ne pouvez pas effectuer ce paiement car vous n'êtes pas propriétaire d'une caisse.",
    CAISSE_NOT_PERMITTED:
      "Caisse ou compte bancaire introuvable, ou vous n'avez pas l'autorisation de payer depuis cette source.",
    INSUFFICIENT_BALANCE: "Solde insuffisant",
    //config bulletin collége errors
    SUBJECT_REQUIRED: "La matière est requise",
    SUBJECT_ALREADY_EXISTS: "Cette matière existe déjà dans la configuration",
    CONFIG_NOT_FOUND: "Configuration introuvable",
    SUBJECT_NOT_FOUND: "Matière introuvable",
    MISSING_REQUIRED_FIELDS: "Champs requis manquants",
    NO_GRADES_FOR_TRIMESTER:
      "Aucune note n'est enregistrée pour cet élève sur le trimestre sélectionné. Le rapport ne peut pas être généré.",
    CONFIG_DELETE_FAILED: "Échec de la suppression de la configuration",
    CONFIG_CLONE_FAILED: "Échec du clonage de la configuration",
    CONFIG_UPDATE_ORDERS_FAILED:
      "Échec de la mise à jour de l'ordre de la configuration",
    SUBJECT_ORDER_UPDATE_FAILED:
      "Échec de la mise à jour de l'ordre de la matière",
    DUPLICATE_CONFIG:
      "Une configuration existe déjà pour cette combinaison de niveau, trimestre et année scolaire",
    SUBJECT_ADD_FAILED: "Échec de l'ajout de la matière",
    SUBJECT_UPDATE_FAILED: "Échec de la mise à jour de la matière",
    SUBJECT_DELETE_FAILED: "Échec de la suppression de la matière",
    SUBJECTS_QUERY_FAILED: "Échec de la récupération des matières",
    CONFIG_QUERY_FAILED: "Échec de la récupération de la configuration",
    CONFIG_SAVE_FAILED: "Échec de l'enregistrement de la configuration",
    INVALID_CONFIG_OPTIONS: "Options de configuration invalides",
    PACK_PERMISSION_ERROR:
      "Vous n'avez pas la permission d'effectuer cette action",
    NO_AUTO_APPRECIATION:
      "Aucune règle d'appréciation automatique à cloner pour cette matière et cette année scolaire.",
    AUTO_APPRECIATION_MISSING_TEACHER_ACCESS:
      "Impossible d'appliquer l'appréciation automatique pour le module {moduleName}. Accès enseignant manquant pour les classes : {classrooms}.",
    AUTO_APPRECIATION_NO_TEACHER_SUBJECT_ACCESS:
      "L'appréciation automatique n'a pas pu être appliquée car aucun enseignant n'est affecté à cette matière dans certaines classes. Veuillez mettre à jour les accès enseignants puis réessayer.",
    CLUB_ACTIVITY_REQUIRED:
      "Veuillez sélectionner une activité ou saisir un nom de club",
    CLUB_POST_NOT_FOUND: "Publication activité / club introuvable",
    CLUB_JOIN_NOT_FOUND: "Demande d'inscription introuvable",
    CLUB_STUDENT_NOT_FOUND: "Élève introuvable",
    CLUB_CLASSROOM_NOT_FOUND: "Classe introuvable",
    CLUB_REGISTRATION_NOT_STARTED: "Les inscriptions n'ont pas encore commencé",
    CLUB_REGISTRATION_CLOSED: "Les inscriptions sont closes",
    CLUB_NO_PLACES_LEFT: "Plus de places disponibles",
    CLUB_INVALID_STUDENT: "Élève invalide",
    CLUB_ALREADY_REGISTERED: "Déjà inscrit",
    ACTIVITY_GROUP_MISSING_SCHOOLARYEAR: "L'en-tête de l'année scolaire est manquant",
    ACTIVITY_GROUP_ACTIVITY_ID_REQUIRED: "L'activité est obligatoire",
    ACTIVITY_GROUP_ID_REQUIRED: "Le groupe est obligatoire",
    ACTIVITY_GROUP_INVALID_ID: "Groupe invalide",
    ACTIVITY_GROUP_ACTIVITY_NOT_FOUND: "Activité introuvable",
    ACTIVITY_GROUP_NOT_FOUND: "Groupe d'activité introuvable",
    ACTIVITY_GROUP_NAME_EXISTS: "Un groupe avec ce nom existe déjà",
    ACTIVITY_GROUP_PAYMENT_NOT_FOUND: "Inscription à l'activité introuvable",
    ACTIVITY_GROUP_LIST_FAILED: "Impossible de charger les groupes d'activité",
    ACTIVITY_GROUP_CREATE_FAILED: "Impossible de créer le groupe",
    ACTIVITY_GROUP_RENAME_FAILED: "Impossible de renommer le groupe",
    ACTIVITY_GROUP_DELETE_FAILED: "Impossible de supprimer le groupe",
    ACTIVITY_GROUP_ASSIGN_FAILED: "Impossible d'assigner l'élève au groupe",
    ACTIVITY_GROUP_UNASSIGN_FAILED: "Impossible de retirer l'élève du groupe",
    CAISSE_INSUFFICIENT_BALANCE:
      "Le solde total de la caisse sélectionnée est insuffisant pour ce paiement.",
    CAISSE_INSUFFICIENT_MODE_BALANCE:
      "La caisse sélectionnée n'a pas suffisamment de fonds pour ce mode de paiement (espèces, chèques, virements, etc.).",
    CAISSE_NOT_FOUND: "Caisse introuvable",
    INVOICE_NOT_FOUND: "Facture introuvable, veuillez vérifier votre valeur",
    AMOUNT_EXCEEDS_INVOICE_TOTAL: "Le montant dépasse le total de la facture",
    AVOIR_DUPLICATE_DEPENSE:
      "Une facture d'avoir existe déjà pour cette facture. Une seule facture d'avoir par facture est autorisée.",
    AVOIR_INVOICE_NOT_FULLY_PAID:
      "Une facture d'avoir ne peut être créée que pour une facture entièrement réglée.",
    PAYMENT_NOT_FOUND: "Paiement introuvable, veuillez vérifier votre valeur",
    PAYMENT_ID_REQUIRED: "L'identifiant du paiement est requis",
    DUPLICATE_PAYMENT_MONTH:
      "Cet employé a déjà été payé pour ce mois. Veuillez sélectionner un autre mois ou un autre employé.",
    ALREADY_TRANSFERRED:
      "Cette facture est déjà transférée, elle ne peut pas être annulée",
    NOT_AUTHORIZED_TO_CANCEL:
      "Vous n'êtes pas autorisé à annuler ce réglement , seule le propriétaire de la caisse principale peut annuler les réglements transférés",
    ALREADY_CANCELLED: "Cette facture est déjà annulée",
    VALIDATED_CHEQUES_EXIST:
      "Impossible d'annuler la facture : des chéques/traites/virements validés existent",
    BORDEREAU_VALIDATED_CHEQUES_EXIST:
      "Impossible de supprimer un bordereau contenant des chèques validés",
    FACTURE_ONLY_AVOIR:
      "Les factures ne peuvent être annulées qu'avec le type 'Avoir'",
    CHEQUE_TRAITE_ALREADY_REPLACED_OR_CANCELLED:
      "Le chèque/traite est déjà remplacé ou annulé",
    CHEQUE_TRAITE_ALREADY_VALIDATED: "Le chèque/traite est déjà validé",
    DUPLICATE_CHEQUES: "Certains chèques existent déjà !",
    DUPLICATE_CHEQUE_OR_TRAITE_NUMBER:
      "Ce numéro de chèque ou de traite a déjà été utilisé, ou vous l'avez saisi plusieurs fois dans ce paiement.",
    DUPLICATE_PROVIDER_INVOICE_NUMBER:
      "Cette facture existe déjà, veuillez modifier la facture existante",
    DUPLICATE_INPUT_CHEQUES:
      "Certains chèques sont dupliqués dans les données d'entrée",
    TRANCHES_ALREADY_PAID:
      "L'élève a déjà payé des tranches, on ne peut pas annuler l'inscription. vous pouvez annuler le réglement puis réessayez !",
    MONTHS_ALREADY_PAID:
      "L'élève a déjà payé des mois, on ne peut pas annuler l'inscription. vous pouvez annuler le réglement puis réessayez !",
    INSCRIPTION_ALREADY_PAID:
      "L'élève a déjà payé l'inscription, on ne peut pas annuler l'inscription. vous pouvez annuler le réglement puis réessayez !",

    DUP_CIN: "Enseignant avec cette CIN existe déja !",
    DUP_EMAIL: "Enseignant avec ce nom d'utilisateur/email existe déja !",
    DB_NOT_FOUND: "Ecole non trouvée.",
    CREATE_TEACHER_FAILED: "impossible d'ajouter l'enseignant, réessayez !",
    UPDATE_EMPLOYEE_FAILED: "impossible de modifier l'employé, réessayez !",

    //Default system errors
    VALIDATION_ERROR:
      "Certaines informations sont incorrectes, veuillez vérifier vos saisies.",
    TEACHER_INVALID_PHONE: "Le numéro de téléphone est invalide. Utilisez le format international, ex. +21620123456.",
    TEACHER_INVALID_BIRTH_DATE: "La date de naissance est invalide. Choisissez une date valide (JJ/MM/AAAA) ou laissez le champ vide.",
    TEACHER_INVALID_CIN_CREATED_AT: "La date de délivrance de la CIN est invalide. Choisissez une date valide (JJ/MM/AAAA) ou laissez le champ vide.",
    TEACHER_INVALID_INTERVIEW_DATE: "La date d'entretien est invalide. Choisissez une date valide (JJ/MM/AAAA) ou laissez le champ vide.",
    TEACHER_INVALID_START_DATE: "La date de début est invalide. Choisissez une date valide (JJ/MM/AAAA) ou laissez le champ vide.",
    TEACHER_INVALID_END_DATE: "La date de fin est invalide. Choisissez une date valide (JJ/MM/AAAA) ou laissez le champ vide.",
    TEACHER_INVALID_BANK_BRANCH: "L'agence bancaire est invalide. Utilisez uniquement des lettres, espaces, tirets et parenthèses.",
    TEACHER_INVALID_EXPECTED_HOURS: "Les heures prévues par jour sont invalides. Saisissez un nombre entre 0 et 24.",
    TEACHER_CIN_DUPLICATE: "Ce CIN appartient déjà à un autre employé. Saisissez un autre CIN ou laissez le champ vide.",
    AUTHENTICATION_ERROR:
      "Échec de connexion, veuillez vérifier vos identifiants.",
    AUTHORIZATION_ERROR: "Accès non autorisé.",
    NOT_FOUND_ERROR: "La ressource demandée est introuvable.",
    CONFLICT_ERROR: "Cette action est en conflit avec des données existantes.",
    DATABASE_ERROR: "Un problème est survenu, veuillez réessayer.",
    EXTERNAL_SERVICE_ERROR:
      "Un service externe est temporairement indisponible, veuillez réessayer plus tard.",
    CREATE_EMPLOYEE_FAILED: "impossible d'ajouter l'employé, réessayez !",
    UPDATE_EMPLOYEE_FAILED: "impossible de modifier l'employé, réessayez !",
    EMPLOYEE_DUP_CIN: "Employé avec cette CIN existe déja !",
    ENCAISSEMENT_BANK_INCOMPATIBLE_METHOD:
      "Un compte bancaire ne peut pas recevoir d'espèces. Utilisez chèque, traite, virement ou TPE.",
    ENCAISSEMENT_NON_CASH_REQUIRES_BANK:
      "Chèque, traite, virement et TPE doivent être crédités sur un compte bancaire.",
    OUTBOUND_PAYMENT_NOT_READY:
      "Le décaissement doit être validé en réconciliation avant de confirmer la réception.",
    STORAGE_QUOTA_EXCEEDED:
      "Le quota de stockage de votre établissement ne permet pas cet envoi. Contactez l’équipe commerciale pour augmenter le quota, ou libérez de l’espace.",
    UPLOAD_PRESIGN_FAILED:
      "Impossible de préparer l’envoi. Veuillez réessayer.",
    ACTIVITY_SCHEDULE_MISSING_SCHOOLARYEAR:
      "Sélectionnez une année scolaire.",
    ACTIVITY_SCHEDULE_INVALID_DATA:
      "Vérifiez les informations de la séance.",
    ACTIVITY_SCHEDULE_INVALID_ID: "La séance sélectionnée est invalide.",
    ACTIVITY_SCHEDULE_INVALID_RECURRENCE:
      "La répétition doit créer entre 1 et 500 séances.",
    ACTIVITY_SCHEDULE_ACTIVITY_NOT_FOUND: "L’activité est introuvable.",
    ACTIVITY_SCHEDULE_TEACHER_NOT_FOUND: "L’enseignant est introuvable.",
    ACTIVITY_SCHEDULE_ROOM_NOT_FOUND: "La salle est introuvable.",
    ACTIVITY_SCHEDULE_GROUP_NOT_FOUND:
      "Le groupe n’appartient pas à cette activité.",
    ACTIVITY_SCHEDULE_NOT_FOUND: "La séance est introuvable.",
    ACTIVITY_SCHEDULE_CONFLICT:
      "L’enseignant ou la salle est déjà occupé à cette heure.",
    ACTIVITY_SCHEDULE_CANCELED:
      "Rétablissez la séance avant de la modifier.",
    ACTIVITY_SCHEDULE_LIST_FAILED:
      "Impossible de charger les séances de l’activité.",
    ACTIVITY_SCHEDULE_CREATE_FAILED: "Impossible de créer la séance.",
    ACTIVITY_SCHEDULE_UPDATE_FAILED: "Impossible de modifier la séance.",
    ACTIVITY_SCHEDULE_CANCEL_FAILED: "Impossible d’annuler la séance.",
    ACTIVITY_SCHEDULE_RESTORE_FAILED: "Impossible de rétablir la séance.",
    ACTIVITY_SCHEDULE_DELETE_FAILED: "Impossible de supprimer la séance.",
    ACTIVITY_SCHEDULE_HAS_ATTENDANCE:
      "Cette séance a des marques d'assiduité. Annulez-la plutôt que de la supprimer.",
    ACTIVITY_ATTENDANCE_MISSING_SCHOOLARYEAR:
      "Sélectionnez une année scolaire.",
    ACTIVITY_ATTENDANCE_INVALID_ID: "Identifiant d'assiduité invalide.",
    ACTIVITY_ATTENDANCE_INVALID_DATA: "Données d'assiduité invalides.",
    ACTIVITY_ATTENDANCE_SESSION_NOT_FOUND: "Séance d'activité introuvable.",
    ACTIVITY_ATTENDANCE_SESSION_CANCELED:
      "Impossible de marquer l'assiduité sur une séance annulée.",
    ACTIVITY_ATTENDANCE_SESSION_FUTURE:
      "Impossible de marquer l'assiduité sur une séance future.",
    ACTIVITY_ATTENDANCE_FORBIDDEN:
      "Vous n'êtes pas autorisé à marquer cette séance.",
    ACTIVITY_ATTENDANCE_YEAR_LOCKED:
      "L'assiduité des activités est verrouillée pour cette année scolaire.",
    ACTIVITY_ATTENDANCE_VALIDATED_LOCKED:
      "Cette assiduité a été validée par l'administration et est verrouillée.",
    ACTIVITY_ATTENDANCE_NOT_VALIDATED:
      "L'assiduité de cette séance n'est pas encore validée par l'administration.",
    ACTIVITY_ATTENDANCE_REOPEN_FAILED: "Impossible de rouvrir la séance.",
    ACTIVITY_ATTENDANCE_YEAR_NOT_FOUND: "Année scolaire introuvable.",
    ACTIVITY_ATTENDANCE_YEAR_LOCK_FAILED:
      "Impossible de mettre à jour l'accès des enseignants pour cette année scolaire.",
    ACTIVITY_ATTENDANCE_STUDENT_NOT_ON_ROSTER:
      "L'élève n'est pas sur la liste de cette séance.",
    ACTIVITY_ATTENDANCE_ALREADY_EXISTS:
      "Une marque d'assiduité existe déjà pour cet élève.",
    ACTIVITY_ATTENDANCE_NOT_FOUND: "Marque d'assiduité introuvable.",
    ACTIVITY_ATTENDANCE_ROSTER_FAILED:
      "Impossible de charger la liste des élèves.",
    ACTIVITY_ATTENDANCE_CREATE_FAILED:
      "Impossible de créer la marque d'assiduité.",
    ACTIVITY_ATTENDANCE_UPDATE_FAILED:
      "Impossible de modifier la marque d'assiduité.",
    ACTIVITY_ATTENDANCE_DELETE_FAILED:
      "Impossible de supprimer la marque d'assiduité.",
    ACTIVITY_ATTENDANCE_SUMMARY_FAILED:
      "Impossible de générer le résumé d'assiduité.",
    ACTIVITY_ATTENDANCE_ACTIVITY_NOT_FOUND: "Activité introuvable.",
    ACTIVITY_ATTENDANCE_NOT_DAILY:
      "L'indication d'assiduité n'est disponible que pour les activités journalières.",
    ACTIVITY_ATTENDANCE_PAYMENT_NOT_FOUND:
      "Inscription à l'activité introuvable.",
    ACTIVITY_ATTENDANCE_INDICATION_FAILED:
      "Impossible de charger l'indication d'assiduité.",
    ACTIVITY_ATTENDANCE_VALIDATE_FAILED:
      "Impossible de valider l'assiduité de l'activité.",
    ACTIVITY_ATTENDANCE_EMPTY_ROSTER:
      "Aucun élève dans la liste de cette séance.",
    ACTIVITY_ATTENDANCE_ROSTER_INCOMPLETE:
      "Les marques doivent couvrir toute la liste de la séance.",
    ACTIVITY_GROUP_MISSING_SCHOOLARYEAR:
      "Sélectionnez une année scolaire.",
    ACTIVITY_GROUP_INVALID_ID: "Le groupe d’activité sélectionné est invalide.",
    ACTIVITY_GROUP_PAYMENT_INVALID_ID:
      "L’inscription sélectionnée est invalide.",
    ACTIVITY_GROUP_INVALID_DATA:
      "Vérifiez les informations du groupe d’activité.",
    ACTIVITY_GROUP_ACTIVITY_NOT_FOUND: "L’activité est introuvable.",
    ACTIVITY_GROUP_NOT_FOUND: "Le groupe d’activité est introuvable.",
    ACTIVITY_GROUP_PAYMENT_NOT_FOUND:
      "L’inscription à l’activité est introuvable.",
    ACTIVITY_GROUP_NAME_EXISTS:
      "Un groupe actif portant ce nom existe déjà.",
    ACTIVITY_GROUP_LIST_FAILED:
      "Impossible de charger les groupes d’activité.",
    ACTIVITY_GROUP_CREATE_FAILED:
      "Impossible de créer le groupe d’activité.",
    ACTIVITY_GROUP_RENAME_FAILED:
      "Impossible de modifier le groupe d’activité.",
    ACTIVITY_GROUP_DELETE_FAILED:
      "Impossible de supprimer le groupe d’activité.",
    ACTIVITY_GROUP_ASSIGN_FAILED:
      "Impossible d’affecter l’élève au groupe.",
    ACTIVITY_GROUP_UNASSIGN_FAILED:
      "Impossible de retirer l’élève du groupe.",
  },
  upload: {
    failedTitle: "Échec de l’envoi",
  },
  status: {
    VALIDATED: "Validé",
    REJECTED: "Rejeté",
    PENDING: "En attente",
    NON_DEPOSE: "Non déposé",
    DEPOSE: "Déposé",
    TRAITE: "Traité",
    REPLACED: "Remplacé par espèce",
    CANCELLED: "Annulé",
    ACTIVE: "Actif",
    INACTIVE: "Inactif",
    active: "Actif",
    cancelled: "Annulé",
  },
  schedule: {
    weekA: "A",
    weekB: "B",
    unknownClass: "Classe inconnue",
    unknown: "Inconnu",
    teacher: "Enseignant",
    classroom: "Salle de classe",
    session: "Séance",
    scheduleNotFound: "Emploi du temps non trouvé",
    errorCreatingSession:
      "Une erreur s'est produite lors de la création de la séance",
    addSessionFailed: "Échec de l'ajout de la séance",
    timetableExceeded:
      "La fin de la séance ({endTime}) dépasse l'heure de fin de l'emploi du temps ({timetableEnd}) pour {day}",
    time: "Temps",
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    group: "Groupe",
    week: "Semaine",
    sunday: "Dimanche",
  },
  financialStats: {
    title: "Statistiques financières",
    subtitle: "Aperçu financier complet et analyses pour votre établissement",
    refresh: "Rafraîchir",
    startDate: "Date de début",
    endDate: "Date de fin",
    total: "Total",
    totalRevenue: "Revenu total",
    revenueSubtitle: "Provenant de toutes les sources",
    totalExpenses: "Dépenses totales",
    expensesSubtitle: "Coûts et dépenses totaux",
    netProfit: "Bénéfice net",
    profitSubtitle: "Revenu moins les dépenses",
    profitMargin: "Marge bénéficiaire",
    marginSubtitle: "Pourcentage de rentabilité",
    financialHealth: "Santé financière",
    health: {
      excellent: "Excellent",
      good: "Bon",
      fair: "Moyen",
      poor: "Faible",
      unknown: "Inconnu",
    },
    healthDescription: {
      excellent:
        "Performance financière exceptionnelle avec une forte rentabilité",
      good: "Bonne santé financière avec des tendances de croissance positives",
      fair: "Performance financière adéquate avec marge d'amélioration",
      poor: "La performance financière nécessite une attention immédiate",
      unknown: "Impossible d'évaluer la santé financière",
    },
    totalInvoices: "Nombre total des factures/reçus",
    cancellationRate: "Taux d'annulation",
    monthlyTrend: "Tendance mensuelle",
    paymentMethods: "Mode de paiement",
    revenueExpenseComparison: "Revenus vs Dépenses",
    topPerformingMonths: "Mois les plus performants",
    revenueAnalytics: "Analyse des revenus",
    expenseAnalytics: "Analyse des dépenses",
    studentAnalytics: "Analyse des élèves",
    caisseAnalytics: "Analyse des caisses",
    averageInvoiceValue: "Valeur moyenne des factures/reçus",
    growthRate: "Taux de croissance",
    dailyRevenue: "Revenus quotidiens",
    dailyRevenueTrend: "Evolution quotidienne des revenus",
    revenueByType: "Revenus par type",
    factures: "Factures",
    receipts: "Reçus",
    paymentMethodsBreakdown: "Répartition des modes de paiement",
    paymentMethod: "Mode de paiement",
    amount: "Montant",
    percentage: "Pourcentage",
    cash: "Espèces",
    check: "Chèque",
    card: "Carte",
    transfer: "Virement",
    wire: "Virement bancaire",
    employeeExpenses: "Dépenses du personnel",
    generalExpenses: "Dépenses générales",
    cancellations: "Annulations",
    monthlyExpenseBreakdown: "Répartition mensuelle des dépenses",
    expenseDistribution: "Répartition des dépenses",
    expenseCategories: "Catégories de dépenses",
    category: "Catégorie",
    trend: "Tendance",
    employees: "Employés",
    general: "Général",
    totalStudents: "Nombre total d'élèves",
    averagePaymentPerStudent: "Paiement moyen par élève",
    topPayingStudents: "Meilleurs payeurs",
    showAll: "Tout afficher",
    showLess: "Afficher moins",
    rank: "Rang",
    student: "Élève",
    totalPaid: "Total payé",
    invoices: "Factures/Reçus",
    lastPayment: "Dernier paiement",
    actions: "Actions",
    viewDetails: "Voir les détails",
    paymentMethodsDistribution: "Répartition des modes de paiement",
    paymentFrequency: "Fréquence de paiement",
    singlePayment: "Paiement unique",
    multiplePayments: "Paiements multiples",
    frequentPayers: "Payeurs fréquents",
    noData: "Aucune donnée disponible",
    totalCaisses: "Nombre total de caisses",
    averageRevenuePerCaisse: "Revenu moyen par caisse",
    caissePerformance: "Performance de la caisse",
    caisse: "Caisse",
    averageInvoiceValue: "Valeur moyenne des factures/reçus",
    performance: "Performance",
    monthlyTrend: "Tendance mensuelle",
    revenueComparison: "Comparaison des revenus",
    caisseDistribution: "Répartition des caisses",
    principal: "Principale",
    subcaisse: "Sous-caisse",
    bank: "Banque",
    excellent: "Excellent",
    good: "Bon",
    fair: "Moyen",
    poor: "Faible",
    positivePerformance: "Positif",
    negativePerformance: "Négatif",
    monthlyTrends: "Tendances mensuelles",
    revenueExpenseProfit: "Revenus, Dépenses & Bénéfices",
    financialOverview: "Aperçu financier",
    revenueVsExpenses: "Revenus vs Dépenses",
    revenue: "Revenus",
    expenses: "Dépenses",
    profit: "Bénéfice",
    tnd: "TND",
    inscrit: "Inscrit",
    nonInscrit: "Non inscrit",
    categories: "catégories",
    revenueSourcesTitle: "Sources de revenus",
    revenueSourcesSubtitle: "Scolarité vs encaissements module dépenses",
    revenueSource: {
      tuition: "Factures / scolarité",
      inverseEncaissement: "Dépense inversée (réception)",
      avoirFournisseur: "Avoir fournisseur encaissé",
    },
    depenseOutflowTitle: "Décaissements par mode",
    depenseOutflowSubtitle: "Montants réellement payés (dépenses)",
    depenseByTypeTitle: "Répartition des dépenses payées par type",
    depenseByTypeSubtitle:
      "Ventilation selon le type de dépense (montants payés)",
    moneyFlowTitle: "Flux de trésorerie (période)",
    moneyIn: "Entrées",
    moneyOut: "Sorties",
    netCashPosition: "Net (entrées − sorties)",
    tuitionShort: "Scolarité",
    inverseShort: "Inverse",
    avoirShort: "Avoir",
    depensePaidOut: "Dépenses payées (module)",
    otherCategory: "Autre",
  },
  error404: {
    pageInaccessible: "Page inaccessible",
    subscriptionMessage:
      "Votre abonnement actuel ne prend pas en charge cette fonctionnalité.",
    upgradeMessage:
      "Mettez à niveau dès maintenant pour enrichir votre expérience !",
    returnButton: "Retourner",
  },
  reduction: {
    designation: "Désignation",
    reduction: "Réduction",
    reductionTND: "Réduction (TND)",
    reductionKES: "Réduction (KES)",
    reductionPercent: "Réduction (%)",
    amountBeforeReduction: "Montant avant réduction",
    amountAfterReduction: "Montant après réduction",
    actions: "Actions",
    amountInTND: "Montant en TND",
    amountInKES: "Montant en KES",
    percentage: "Pourcentage",
    selected: "sélectionné",
  },
  payment: {
    selectFeesToPay: "Sélectionnez les frais à payer",
    showAll: "Tout afficher",
    hideAll: "Tout masquer",
    payWithAdvance: "Payer avec avance",
    withoutAdvance: "Sans avance",
    enableAdvancePayment: "Activer le paiement avec avance",
    advanceAmountTND: "Montant avance (TND)",
    enterAmount: "Saisir le montant",
    advanceAmountExceedsTotal:
      "Le montant d'avance saisi est supérieur au montant total des frais à payer. montant avance doit être inférieur ou égal à {maxAmount}",
    advanceAmountInsufficient:
      "Le montant d'avance saisi ne permet pas de couvrir tous les frais. Veuillez saisir un montant d'avance supérieur.",
    tuition: "Scolarité",
    activity: "Activité",
    feesToPay: "Frais à payer",
    remaining: "Reste",
    advanceApplied: "Avance appliquée",
    remainingToPay: "Reste à payer",
    partialPaymentRemaining: "Paiement partiel - montant restant à payer",
    advanceInsufficientForFee:
      "Le montant d'avance saisi ne permet pas de couvrir ce frais. Veuillez saisir un montant d'avance supérieur.",
    paid: "Payé",
    deselectAll: "Désélectionner tout",
    selectAll: "Sélectionner tout",
    registration: "Inscription",
    installment: "Tranche",
    fees: "Frais",
    amount: "Montant",
  },
  activityPayment: {
    service: "Service",
    numberOfStudents: "Nombre d'élèves",
    order: "Ordre",
    no: "Non",
    allMonths: "Tous les mois",
    allClasses: "Toutes les classes",
    monthlyPayment: "Paiement mensuel",
    installmentPayment: "Paiement par tranche",
    studentName: "Nom de l'élève",
    classroom: "Classe",
    parents: "Parents",
    parentPhones: "Téléphones des parents",
    paymentMode: "Mode de paiement",
    monthly: "Mensuelle",
    byInstallment: "Par tranche",
    globalStatus: "État global",
    paid: "Payé",
    unpaid: "Non payé",
    noClassFound: "Aucune classe est trouvée",
    activityNotFound: "Activité non trouvée!",
    noActivityRegistrationFound: "Aucune inscription à l'activité est trouvée",
  },
  inscriptionActivites: {
    monthlyPayment: "Paiement mensuel",
    installmentPayment: "Paiement par tranche",
    paymentMode: "Mode de paiement",
    monthly: "Mensuelle",
    byInstallment: "Par tranche",
    globalStatus: "État global",
    paid: "Payé",
    unpaid: "Non payé",
    noClassFound: "Aucune classe est trouvée",
    manageGroups: "Gérer les groupes",
    manageGroupsTitle: "Groupes — {activity}",
    addGroup: "Ajouter",
    groupName: "Nom du groupe",
    renameGroup: "Renommer",
    deleteGroup: "Supprimer",
    noGroupsYet: "Aucun groupe pour cette activité",
    confirmDeleteGroup: "Supprimer ce groupe ?",
    selectActivityFirst: "Sélectionnez d'abord une activité",
    selectActivityToManageGroups:
      "Sélectionnez une activité pour gérer ses groupes",
    filterByGroup: "Filtrer par groupe",
    groupCreated: "Groupe créé avec succès",
    groupRenamed: "Groupe renommé avec succès",
    groupDeleted: "Groupe supprimé avec succès",
    groupAssigned: "Élève assigné au groupe avec succès",
    groupUnassigned: "Élève retiré du groupe avec succès",
    multipleRegistration: "Inscription multiple",
    multipleRegistrationTitle: "Inscription sur plusieurs activités",
    multipleRegistrationStep1Title: "1. Activités et élèves",
    multipleRegistrationStep1Subtitle:
      "Sélectionnez plusieurs activités de même type (toutes Journalière ou toutes Mensuelle/Tranche) puis les élèves à inscrire",
    multipleRegistrationStep2Title: "2. Configuration par activité",
    multipleRegistrationStep2Subtitle:
      "Configurez séparément les dates et le mode de paiement de chaque activité",
    multipleRegistrationNoActivitiesSelected: "Aucune activité sélectionnée",
  },
  emploiActivites: {
    title: "Emploi des activités",
    addSession: "Ajouter une séance",
    editSession: "Modifier la séance",
    selectActivityHint: "Sélectionnez une activité pour gérer son emploi",
    selectActivityEmpty: "Choisissez une activité pour voir les séances",
    filterByGroup: "Filtrer par groupe",
    wholeActivity: "Toute l'activité",
    day: "Jour",
    time: "Heure",
    duration: "Durée (min)",
    selectTeacher: "Choisir un enseignant",
    selectRoom: "Choisir une salle",
    dayRequired: "Le jour est obligatoire",
    timeRequired: "L'heure est obligatoire",
    durationRequired: "La durée est obligatoire",
    cancelSession: "Annuler la séance",
    confirmCancelSession: "Annuler cette séance ?",
    restoreSession: "Rétablir la séance",
    confirmRestoreSession: "Rétablir cette séance annulée ?",
    confirmDeleteSession: "Supprimer cette séance ?",
    canceled: "Annulée",
    active: "Active",
    sessionCreated: "Séance créée",
    sessionUpdated: "Séance modifiée",
    sessionCanceled: "Séance annulée",
    sessionRestored: "Séance rétablie",
    sessionDeleted: "Séance supprimée",
    repeat: "Répéter la séance",
    repeatHint: "Crée plusieurs séances entre deux dates",
    repeatFrequency: "Fréquence",
    repeatDaily: "Quotidien",
    repeatWeekly: "Hebdomadaire",
    repeatMonthly: "Mensuel",
    startDate: "Date de début",
    endDate: "Date de fin",
    dateRangeRequired: "Les dates de début et de fin sont obligatoires",
    endBeforeStart: "La date de fin doit être après la date de début",
    frequencyRequired: "Choisissez une fréquence",
    noOccurrences: "Aucune séance à créer pour cette période",
    sessionsWillBeCreated: "{count} séance(s) seront créées",
    sessionsCreated: "{count} séance(s) créées",
  },
  activityAttendance: {
    title: "Assiduité des activités",
    sessionsTab: "Séances",
    summaryTab: "Résumé",
    period: "Période",
    quickPeriod: "Période rapide",
    weekly: "Cette semaine",
    monthly: "Ce mois",
    student: "Élève",
    studentCount: "{nb} élèves",
    expected: "Prévues",
    attended: "Présentes",
    needDates: "Sélectionnez une période",
    pickActivity: "Sélectionnez une activité pour lister les séances",
    sessionsHint:
      "Ouvrez une séance pour marquer l'assiduité. Rien n'est enregistré tant que vous n'avez pas cliqué sur Valider. Ne validez pas pour un jour férié / jour off.",
    noSessions: "Aucune séance pour ces filtres",
    group: "Groupe",
    teacher: "Enseignant",
    room: "Salle",
    day: "Jour",
    time: "Heure",
    status: "Statut",
    canceled: "Annulée",
    canceledHint: "Cette séance est annulée",
    future: "À venir",
    futureHint:
      "Vous ne pouvez marquer l'assiduité que pour aujourd'hui ou une séance passée",
    adminValidated: "Validée par l'administration",
    pendingAdmin: "Validée par l'enseignant",
    pendingAdminHint:
      "L'enseignant a validé cette assiduité et peut encore la modifier. Vérifiez-la puis cliquez sur Valider pour la verrouiller pour l'enseignant.",
    teacherValidatedAt: "Validation enseignant",
    teacherNotValidated: "Pas encore validée par l'enseignant",
    notRecorded: "Non enregistrée",
    nothingRecordedYet:
      "Aucune assiduité enregistrée pour cette séance. Réglez les statuts (Présent par défaut), puis cliquez sur Valider. Ne validez pas pour un jour férié / jour off.",
    validatedHint:
      "Validée par l'administration : verrouillée pour l'enseignant. Vous pouvez encore modifier puis Valider à nouveau, ou la rouvrir pour l'enseignant.",
    reopen: "Rouvrir pour l'enseignant",
    reopenConfirm:
      "Autoriser l'enseignant à modifier de nouveau l'assiduité de cette séance ? Elle sera verrouillée dès que l'administration la validera.",
    reopenSuccess: "Séance rouverte pour l'enseignant",
    reopened: "Rouverte",
    reopenedHint:
      "Rouverte : l'enseignant peut modifier cette séance jusqu'à ce que l'administration la valide à nouveau.",
    yearLockedForTeachers:
      "Cette année scolaire n'est pas l'année en cours. Les enseignants ne peuvent pas modifier l'assiduité des activités.",
    yearUnlockedForTeachers:
      "Cette année scolaire n'est pas l'année en cours, mais les enseignants sont actuellement autorisés à modifier l'assiduité des activités.",
    allowTeacherEdit: "Autoriser les enseignants à modifier",
    yearLockUpdated: "Accès des enseignants mis à jour",
    validate: "Valider l'assiduité",
    validateConfirm:
      "Enregistrer l'assiduité de tous les élèves pour cette séance ?",
    validateSuccess: "Assiduité validée avec succès",
    openSheet: "Feuille de marque",
    markTitle: "Marquer l'assiduité",
    emptyRoster: "Aucun élève inscrit pour cette séance",
    groupRosterHint:
      "Seuls les élèves du groupe « {group} » sont listés.",
    hint:
      "Seules les séances validées comptent. Sélectionnez une activité pour voir tous les inscrits. Sans activité, seuls les élèves ayant une séance correspondante sur la période apparaissent (une séance de groupe ne compte que son groupe). Videz le filtre classe s'il est actif.",
    empty:
      "Aucun élève pour ces filtres. Choisissez une activité, élargissez les dates ou videz le filtre classe.",
  },
  activityPaymentAttendance: {
    title: "Assiduité sur la période",
    subtitle:
      "Indication uniquement — sélectionnez les jours à payer manuellement ci-dessous. Compte uniquement les séances validées (Présent et Retard = présents).",
    refresh: "Actualiser",
    needDates: "Sélectionnez une période",
    missingIds: "Élève ou activité manquant",
    noSessions: "Aucune séance planifiée sur cette période",
    noSessionsHint:
      "L'emploi de l'activité n'a pas de séance pour cet élève sur les dates sélectionnées.",
    present: "Présent",
    retard: "Retard",
    absence: "Absent",
    exclus: "Exclu",
    none: "Aucun",
    totals:
      "{sessions} séance(s) · Présent {present} · Retard {retard} · Absent {absence} · Exclu {exclus}",
  },
  activityMultiForm: {
    installmentFees: "Frais des tranches",
    installment: "Tranche",
    selectedPaymentMode: "Le mode de paiement sélectionné est ",
    byInstallments: "par tranches",
    monthly: "mensuelle",
    feesToPay: "Les frais à payer",
    fees: "Frais",
    included: "Inclus",
  },
  studentCredentials: {
    deactivateOrActivateAccount: "Désactiver ou activer compte élève",
    accountActivated:
      "Compte activé, l'utilisateur peut accéder à l'application.",
    accountDeactivated:
      "Compte désactivé, l'utilisateur ne peut pas accéder à l'application.",
    deactivate: "Désactiver",
    activate: "Activer",
    studentQrCode: "QR code élève",
    usernameNoWhitespace: "Le nom d'utilisateur ne peut pas contenir d'espaces",
    passwordConfirmationRequired: "Veuillez saisir le mot de passe à nouveau",
    passwordMismatch: "Les deux saisies ne correspondent pas !",
    statusChangeSuccess: "Changement effectué avec succès",
  },

  college: {
    bulletin: {
      config: {
        title: "Configuration du bulletin collège",
        description:
          "Configurez les matières et les types de notes pour les bulletins du collège !",
        subjectOrderUpdated: "Ordre des matières mis à jour avec succès",
        subjectAlreadyExists: "Cette matière existe déjà dans la configuration",
        failedToUpdateSubjectOrder:
          "Échec de la mise à jour de l'ordre de la matière. Veuillez réessayer",
        configClone: "Configuration clonée avec succès",
        ajouterConfigCollege: "Ajouter une configuration collège",
        modifierConfigCollege: "Modifier la configuration collège",
        modifierConfigSubject: "Modifier la configuration de la matière",
        niveau: "Niveau",
        order: "Ordre",
        markTypes: "Types de notes",
        configurerMarkType: "Paramétrer la note",
        aucuneMatiere: "Aucune matière",
        confirmDeleteWithMarks:
          "Cette matière contient des enregistrement(s) pour {count} élève(s). Êtes-vous sûr de vouloir la supprimer ?",
        from: "De",
        to: "Vers",
        niveaux: "Niveaux",
        trimestres: "Trimestres",
        anneeScolaire: "Année scolaire",
        count: "Nombre",
        markType: {
          oral: "Oral",
          cont1: "Contrôle 1",
          cont2: "Contrôle 2",
          synth: "Synthèse",
          written: "Écrit",
          tp: "Travaux pratiques",
        },
      },
    },
  },

  college: {
    bulletin: {
      config: {
        title: "Configuration du bulletin collège",
        description:
          "Configurez les matières et les types de notes pour les bulletins du collège !",
        subjectOrderUpdated: "Ordre des matières mis à jour avec succès",
        subjectAlreadyExists: "Cette matière existe déjà dans la configuration",
        failedToUpdateSubjectOrder:
          "Échec de la mise à jour de l'ordre de la matière. Veuillez réessayer",
        configClone: "Configuration clonée avec succès",
        ajouterConfigCollege: "Ajouter une configuration collège",
        modifierConfigCollege: "Modifier la configuration collège",
        modifierConfigSubject: "Modifier la configuration de la matière",
        niveau: "Niveau",
        order: "Ordre",
        markTypes: "Types de notes",
        configurerMarkType: "Paramétrer la note",
        aucuneMatiere: "Aucune matière",
        confirmDeleteWithMarks:
          "Cette matière contient des enregistrement(s) pour {count} élève(s). Êtes-vous sûr de vouloir la supprimer ?",
        from: "De",
        to: "Vers",
        niveaux: "Niveaux",
        trimestres: "Trimestres",
        anneeScolaire: "Année scolaire",
        count: "Nombre",
        markType: {
          oral: "Oral",
          cont1: "Contrôle 1",
          cont2: "Contrôle 2",
          synth: "Synthèse",
          written: "Écrit",
          tp: "Travaux pratiques",
        },
      },
    },
  },
  footer: {
    copyright: "Copyright ©",
    allRightsReserved: "Tous Droits Réservés.",
    version: "Version :",
  },
  attestationInscription: {
    title: "Attestation d'inscription",
    iUndersigned: "Je soussigné",
    directorMale: "le directeur",
    directorFemale: "la directrice",
    ofThe: "du",
    certifiesThatStudent: "atteste que l'élève",
    bornOn: "né(e) le",
    isEnrolledIn:
      "est insécrit(e) au sein de notre etablissement pour l'année scolaire",
    inClass: "en classe",
    doneAt: "Fait à",
    on: "le",
    signatureAndStamp: "Signature et Cachet",
  },
  ficheClasse: {
    nonDisponible: "Non disponible",
    anneeScolaireLabel: "Année scolaire",
    delegeRegionalEducation: "Délégation régionale",
    date: "Date",
    listeEleves: "Liste des élèves",
    classe: "Classe",
    garcon: "Garçon",
    fille: "Fille",
    total: "Nombre total",
    garcons: "Nombre de garçons",
    filles: "Nombre de filles",
    numero: "Numéro",
    identifiantUnique: "Identifiant unique",
    nomComplet: "Nom complet",
    dateNaissance: "Date de naissance",
    group: "Groupe",
    sexe: "Sexe",
    listeElevesPDF: "Liste_des_élèves",
    formulaireParent: "Formulaire du parent",
    nomPrenom: "Nom et prénom",
    nomPrenomFr: "Nom et prénom en français",
    nomParent: "Nom du parent",
    telephone: "Téléphone",
    pere: "Père",
    mere: "Mère",
    ficheParentPDF: "Fiche_Parent",
    parentSheetSelectAtLeastOneColumn:
      "Veuillez sélectionner au moins une colonne à imprimer.",
    parentSheetSelectColumnsHint:
      "Choisissez les colonnes à inclure dans la fiche parent. Vous pouvez générer une liste complète ou uniquement les champs souhaités (ex. liste d'e-mails, liste d'adresses).",
    parentSheetSelectColumnsTitle: "Sélectionner les colonnes à imprimer",
  },
  attendanceHistoryPdf: {
    classe: "Classe",
    period: "Période",
    num: "Num",
    studentName: "Nom de l'élève",
    page: "Page",
    legend: "Légende",
    present: "Présent",
    absence: "Absence",
    retard: "Retard",
    exclus: "Exclus",
    history: "Historique",
  },
  conseilClass: {
    managerAndTeacher: "Directeur et enseignants",
    options: "Options",
    allow: "Afficher",
    auto: "Automatique",
    useSchoolCode: "Utiliser le code établissement",
    repeatEachPage: "Répéter à chaque page",
    rect: "Encadré",
    orientation: "Orientation",
    landscape: "Paysage",
    portrait: "Portrait",
    govText: "Texte gouvernemental",
    schoolLogo: "Logo établissement",
    schoolYear: "Année scolaire",
    govLog: "Logo gouvernement",
    stats: "Statistiques",
    mainTitle: "Titre principal",
    secondaryText: "Texte secondaire",
    preParagraph: "Paragraphe introductif",
    table: "Tableau des admis",
    tablePostParagraph: "Paragraphe après le tableau des admis",
    postParagraph: "Paragraphe après tableau",
    number: "Numéro",
    fullName: "Nom complet",
    firstName: "Prénom",
    lastName: "Nom",
    birthDate: "Date de naissance",
    birthPlace: "Lieu de naissance",
    uniqueIden: "Identifiant unique",
    prevYears: "Années précédentes",
    trim1: "Trimestre 1",
    trim2: "Trimestre 2",
    trim3: "Trimestre 3",
    moy: "Moyenne",
    decision: "Décision",
    handicape: "Handicap",
    exceptionalStats: "Tableau des admis par exception",
    filled: "Remplir avec les élèves",
    specCount: "Nombre de lignes vides",
    agePass: "Tableau des admis par âge",
    fail: "Tableau des refusés",
    govSpecific: "Bloc région (dernière page)",
    manager: "Directeur",
    teacher: "Enseignants",
    templateName: "Nom du modèle",
    templateNamePlaceholder: "Ex. PV conseil 6ème A",
    selectTemplate: "Modèle enregistré",
    builtinDefault: "par défaut",
    pvMissingKeyBanner: "{count} élève(s) sans décision correspondante (A/C/R)",
    pvMissingKeyHint:
      "Ces élèves n'apparaîtront pas dans les tableaux du PV. Corrigez le paramétrage des décisions du conseil ou assignez une décision par élève.",
    pvMissingKeyMore: "... et {count} autre(s)",
    settingsSaved: "Paramètres enregistrés avec succès",
    templateAssigned: "Modèle assigné à ce niveau",
    checkInputs: "Veuillez vérifier vos saisies",
    selectClassFirst: "Veuillez sélectionner une classe d'abord",
    couldNotGetClassPv: "Impossible de charger les données PV de la classe",
    cloneAlert:
      "Une duplication des paramètres a eu lieu. Actualisez la page pour voir l'effet complet.",
    templateNameRequired: "Veuillez saisir un nom pour le modèle",
    templateNameAlreadyExists:
      "Ce nom de modèle existe déjà. Choisissez un autre nom.",
    nameTemplateTitle: "Nommer le modèle",
    nameTemplatePrompt:
      "Vous partez du modèle par défaut. Donnez un nom unique à ce modèle avant de l'enregistrer pour ce niveau.",
    selectSourceTemplate: "Modèle source à dupliquer",
    cloneSourceHint:
      "Pour dupliquer un autre modèle, sélectionnez-le dans le paramétrage puis enregistrez avant d'ouvrir la duplication.",
    cloneSaveTemplateFirst:
      "Enregistrez d'abord le modèle sélectionné dans le paramétrage avant de le dupliquer.",
    unnamedTemplate: "Sans nom",
    selectCloneTargets: "Veuillez sélectionner au moins une cible",
  },
  pickup: {
    title: "Pickup",
    enabled: "Activer le pickup parent",
    radius: "Rayon autorisé (mètres)",
    location: "Position du pickup",
    locationHint:
      "Laissez vide pour utiliser la position de l'école définie dans les paramètres de l'établissement.",
    noBuildingLocation:
      "Aucune position de l'école n'est définie dans les paramètres de l'établissement. Saisissez la position du pickup.",
    noLocation:
      "Une position est obligatoire pour activer le pickup. Saisissez la position du pickup ou définissez celle de l'école.",
    latLngTogether: "La latitude et la longitude doivent être saisies ensemble.",
    saved: "Paramètres du pickup enregistrés",
    waiting: "En attente",
    history: "Historique",
    noWaiting: "Aucun élève en attente",
    student: "Élève",
    classe: "Classe",
    parent: "Parent",
    requestedAt: "Heure de la demande",
    expiresIn: "Expire dans",
    status: "Statut",
    statusPickedUp: "Récupéré",
    statusExpired: "Expiré (non validé)",
    validatedBy: "Validé par",
    validate: "Valider la sortie",
    confirmValidate: "Confirmer que l'élève est sorti avec le parent ?",
    validated: "Sortie de l'élève validée",
    level: "Niveau",
    sortOldest: "Arrivée : plus ancienne d'abord",
    sortNewest: "Arrivée : plus récente d'abord",
    distance: "Distance de l'école",
    relation: {
      father: "Père",
      mother: "Mère",
      guardian: "Tuteur",
    },
  },
};

export default {
  locale: "fr-FR",
  localeAntd,
  messages,
};
